var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/lodash/lodash.js
var require_lodash = __commonJS({
  "node_modules/lodash/lodash.js"(exports, module) {
    "use strict";
    (function() {
      var undefined2;
      var VERSION = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "\xC0": "A",
        "\xC1": "A",
        "\xC2": "A",
        "\xC3": "A",
        "\xC4": "A",
        "\xC5": "A",
        "\xE0": "a",
        "\xE1": "a",
        "\xE2": "a",
        "\xE3": "a",
        "\xE4": "a",
        "\xE5": "a",
        "\xC7": "C",
        "\xE7": "c",
        "\xD0": "D",
        "\xF0": "d",
        "\xC8": "E",
        "\xC9": "E",
        "\xCA": "E",
        "\xCB": "E",
        "\xE8": "e",
        "\xE9": "e",
        "\xEA": "e",
        "\xEB": "e",
        "\xCC": "I",
        "\xCD": "I",
        "\xCE": "I",
        "\xCF": "I",
        "\xEC": "i",
        "\xED": "i",
        "\xEE": "i",
        "\xEF": "i",
        "\xD1": "N",
        "\xF1": "n",
        "\xD2": "O",
        "\xD3": "O",
        "\xD4": "O",
        "\xD5": "O",
        "\xD6": "O",
        "\xD8": "O",
        "\xF2": "o",
        "\xF3": "o",
        "\xF4": "o",
        "\xF5": "o",
        "\xF6": "o",
        "\xF8": "o",
        "\xD9": "U",
        "\xDA": "U",
        "\xDB": "U",
        "\xDC": "U",
        "\xF9": "u",
        "\xFA": "u",
        "\xFB": "u",
        "\xFC": "u",
        "\xDD": "Y",
        "\xFD": "y",
        "\xFF": "y",
        "\xC6": "Ae",
        "\xE6": "ae",
        "\xDE": "Th",
        "\xFE": "th",
        "\xDF": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (!predicate(array[index], index, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }
        return result;
      }
      function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while (++index < length) {
          array[offset + index] = values[index];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index];
        }
        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string) {
        return string.split("");
      }
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (comparator(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
      }
      function baseProperty(key) {
        return function(object) {
          return object == null ? undefined2 : object[key];
        };
      }
      function basePropertyOf(object) {
        return function(key) {
          return object == null ? undefined2 : object[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while (++index < length) {
          var current = iteratee(array[index]);
          if (current !== undefined2) {
            result = result === undefined2 ? current : result + current;
          }
        }
        return result;
      }
      function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while (++index < n) {
          result[index] = iteratee(index);
        }
        return result;
      }
      function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
          return [key, object[key]];
        });
      }
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object, props) {
        return arrayMap(props, function(key) {
          return object[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result;
          }
        }
        return result;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue(object, key) {
        return object == null ? undefined2 : object[key];
      }
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      function iteratorToArray(iterator) {
        var data, result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
          result[++index] = [key, value];
        });
        return result;
      }
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result[resIndex++] = index;
          }
        }
        return result;
      }
      function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = value;
        });
        return result;
      }
      function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = [value, value];
        });
        return result;
      }
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while (index--) {
          if (array[index] === value) {
            return index;
          }
        }
        return index;
      }
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      function trimmedEndIndex(string) {
        var index = string.length;
        while (index-- && reWhitespace.test(string.charAt(index))) {
        }
        return index;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result;
        }
        return result;
      }
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      var runInContext = function runInContext2(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString = funcToString.call(Object2);
        var oldDash = root._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer2 = moduleExports ? context.Buffer : undefined2, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined2, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined2, symIterator = Symbol2 ? Symbol2.iterator : undefined2, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined2;
        var defineProperty = function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap && new WeakMap();
        var realNames = {};
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
        function lodash(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = /* @__PURE__ */ function() {
          function object() {
          }
          return function(proto) {
            if (!isObject(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object.prototype = proto;
            var result2 = new object();
            object.prototype = undefined2;
            return result2;
          };
        }();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined2;
        }
        lodash.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash
          }
        };
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result2 = [];
          outer:
            while (length-- && resIndex < takeCount) {
              index += dir;
              var iterIndex = -1, value = array[index];
              while (++iterIndex < iterLength) {
                var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
                if (type == LAZY_MAP_FLAG) {
                  value = computed;
                } else if (!computed) {
                  if (type == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result2[resIndex++] = value;
            }
          return result2;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result2 = data[key];
            return result2 === HASH_UNDEFINED ? undefined2 : result2;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined2;
        }
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined2 : hasOwnProperty.call(data, key);
        }
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          return index < 0 ? undefined2 : data[index][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map2 || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data = getMapData(this, key), size2 = data.size;
          data.set(key, value);
          this.size += data.size == size2 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index = -1, length = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index < length) {
            this.add(values2[index]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data = this.__data__, result2 = data["delete"](key);
          this.size = data.size;
          return result2;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined2;
        }
        function arraySampleSize(array, n) {
          return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        function assignMergeValue(object, key, value) {
          if (value !== undefined2 && !eq(object[key], value) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }
        function baseAssignIn(object, source) {
          return object && copyObject(source, keysIn(source), object);
        }
        function baseAssignValue(object, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object[key] = value;
          }
        }
        function baseAt(object, paths) {
          var index = -1, length = paths.length, result2 = Array2(length), skip = object == null;
          while (++index < length) {
            result2[index] = skip ? undefined2 : get(object, paths[index]);
          }
          return result2;
        }
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined2) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined2) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        function baseClone(value, bitmask, customizer, key, object, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result2 = object ? customizer(value, key, object, stack) : customizer(value);
          }
          if (result2 !== undefined2) {
            return result2;
          }
          if (!isObject(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result2 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result2);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object ? value : {};
              }
              result2 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result2);
          if (isSet(value)) {
            value.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined2 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result2;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object) {
            return baseConformsTo(object, source, props);
          };
        }
        function baseConformsTo(object, source, props) {
          var length = props.length;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (length--) {
            var key = props[length], predicate = source[key], value = object[key];
            if (value === undefined2 && !(key in object) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout(function() {
            func.apply(undefined2, args);
          }, wait);
        }
        function baseDifference(array, values2, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
          if (!length) {
            return result2;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result2.push(value);
              } else if (!includes2(values2, computed, comparator)) {
                result2.push(value);
              }
            }
          return result2;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value, index, collection2) {
            result2 = !!predicate(value, index, collection2);
            return result2;
          });
          return result2;
        }
        function baseExtremum(array, iteratee2, comparator) {
          var index = -1, length = array.length;
          while (++index < length) {
            var value = array[index], current = iteratee2(value);
            if (current != null && (computed === undefined2 ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current, result2 = value;
            }
          }
          return result2;
        }
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined2 || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value, index, collection2) {
            if (predicate(value, index, collection2)) {
              result2.push(value);
            }
          });
          return result2;
        }
        function baseFlatten(array, depth, predicate, isStrict, result2) {
          var index = -1, length = array.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index < length) {
            var value = array[index];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush(result2, value);
              }
            } else if (!isStrict) {
              result2[result2.length] = value;
            }
          }
          return result2;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object, iteratee2) {
          return object && baseFor(object, iteratee2, keys);
        }
        function baseForOwnRight(object, iteratee2) {
          return object && baseForRight(object, iteratee2, keys);
        }
        function baseFunctions(object, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object[key]);
          });
        }
        function baseGet(object, path) {
          path = castPath(path, object);
          var index = 0, length = path.length;
          while (object != null && index < length) {
            object = object[toKey(path[index++])];
          }
          return index && index == length ? object : undefined2;
        }
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object);
          return isArray(object) ? result2 : arrayPush(result2, symbolsFunc(object));
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined2 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object, key) {
          return object != null && hasOwnProperty.call(object, key);
        }
        function baseHasIn(object, key) {
          return object != null && key in Object2(object);
        }
        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined2;
          }
          array = arrays[0];
          var index = -1, seen = caches[0];
          outer:
            while (++index < length && result2.length < maxLength) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseInverter(object, setter, iteratee2, accumulator) {
          baseForOwn(object, function(value, key, object2) {
            setter(accumulator, iteratee2(value), key, object2);
          });
          return accumulator;
        }
        function baseInvoke(object, path, args) {
          path = castPath(path, object);
          object = parent(object, path);
          var func = object == null ? object : object[toKey(last(path))];
          return func == null ? undefined2 : apply(func, object, args);
        }
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object, source, matchData, customizer) {
          var index = matchData.length, length = index, noCustomizer = !customizer;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (index--) {
            var data = matchData[index];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }
          while (++index < length) {
            data = matchData[index];
            var key = data[0], objValue = object[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined2 && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result2 = customizer(objValue, srcValue, key, object, source, stack);
              }
              if (!(result2 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }
          var result2 = [];
          for (var key in Object2(object)) {
            if (hasOwnProperty.call(object, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseKeysIn(object) {
          if (!isObject(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object), result2 = [];
          for (var key in object) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result2[++index] = iteratee2(value, key, collection2);
          });
          return result2;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object) {
            var objValue = get(object, path);
            return objValue === undefined2 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object, source, srcIndex, customizer, stack) {
          if (object === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined2;
              if (newValue === undefined2) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined2;
          var isCommon = newValue === undefined2;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object, key, newValue);
        }
        function baseNth(array, n) {
          var length = array.length;
          if (!length) {
            return;
          }
          n += n < 0 ? length : 0;
          return isIndex(n, length) ? array[n] : undefined2;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity];
          }
          var index = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return { "criteria": criteria, "index": ++index, "value": value };
          });
          return baseSortBy(result2, function(object, other) {
            return compareMultiple(object, other, orders);
          });
        }
        function basePick(object, paths) {
          return basePickBy(object, paths, function(value, path) {
            return hasIn(object, path);
          });
        }
        function basePickBy(object, paths, predicate) {
          var index = -1, length = paths.length, result2 = {};
          while (++index < length) {
            var path = paths[index], value = baseGet(object, path);
            if (predicate(value, path)) {
              baseSet(result2, castPath(path, object), value);
            }
          }
          return result2;
        }
        function basePropertyDeep(path) {
          return function(object) {
            return baseGet(object, path);
          };
        }
        function basePullAll(array, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values2.length, seen = array;
          if (array === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index < length) {
            var fromIndex = 0, value = values2[index], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index = indexes[length];
            if (length == lastIndex || index !== previous) {
              var previous = index;
              if (isIndex(index)) {
                splice.call(array, index, 1);
              } else {
                baseUnset(array, index);
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
          while (length--) {
            result2[fromRight ? length : ++index] = start;
            start += step;
          }
          return result2;
        }
        function baseRepeat(string, n) {
          var result2 = "";
          if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n % 2) {
              result2 += string;
            }
            n = nativeFloor(n / 2);
            if (n) {
              string += string;
            }
          } while (n);
          return result2;
        }
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        function baseSet(object, path, value, customizer) {
          if (!isObject(object)) {
            return object;
          }
          path = castPath(path, object);
          var index = -1, length = path.length, lastIndex = length - 1, nested = object;
          while (nested != null && ++index < length) {
            var key = toKey(path[index]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object;
            }
            if (index != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined2;
              if (newValue === undefined2) {
                newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object;
        }
        var baseSetData = !metaMap ? identity : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array, start, end) {
          var index = -1, length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result2 = Array2(length);
          while (++index < length) {
            result2[index] = array[index + start];
          }
          return result2;
        }
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value, index, collection2) {
            result2 = predicate(value, index, collection2);
            return !result2;
          });
          return !!result2;
        }
        function baseSortedIndex(array, value, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        function baseSortedIndexBy(array, value, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined2;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined2, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array, iteratee2) {
          var index = -1, length = array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            if (!index || !eq(computed, seen)) {
              var seen = computed;
              result2[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result2;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function baseUniq(array, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set2 = iteratee2 ? null : createSet(array);
            if (set2) {
              return setToArray(set2);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result2.push(value);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result2) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseUnset(object, path) {
          path = castPath(path, object);
          object = parent(object, path);
          return object == null || delete object[toKey(last(path))];
        }
        function baseUpdate(object, path, updater, customizer) {
          return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length, index = fromRight ? length : -1;
          while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        function baseWrapperValue(value, actions) {
          var result2 = value;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions, function(result3, action) {
            return action.func.apply(action.thisArg, arrayPush([result3], action.args));
          }, result2);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index = -1, result2 = Array2(length);
          while (++index < length) {
            var array = arrays[index], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index) {
                result2[index] = baseDifference(result2[index] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index = -1, length = props.length, valsLength = values2.length, result2 = {};
          while (++index < length) {
            var value = index < valsLength ? values2[index] : undefined2;
            assignFunc(result2, props[index], value);
          }
          return result2;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity;
        }
        function castPath(value, object) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object) ? [value] : stringToPath(toString(value));
        }
        var castRest = baseRest;
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined2 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        var clearTimeout = ctxClearTimeout || function(id) {
          return root.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result2);
          return result2;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result2.lastIndex = regexp.lastIndex;
          return result2;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object, other, orders) {
          var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index < length) {
            var result2 = compareAscending(objCriteria[index], othCriteria[index]);
            if (result2) {
              if (index >= ordersLength) {
                return result2;
              }
              var order = orders[index];
              return result2 * (order == "desc" ? -1 : 1);
            }
          }
          return object.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        function copyArray(source, array) {
          var index = -1, length = source.length;
          array || (array = Array2(length));
          while (++index < length) {
            array[index] = source[index];
          }
          return array;
        }
        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index = -1, length = props.length;
          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined2;
            if (newValue === undefined2) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }
        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }
        function copySymbolsIn(source, object) {
          return copyObject(source, getSymbolsIn(source), object);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object, sources) {
            var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined2, guard = length > 2 ? sources[2] : undefined2;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined2 : customizer;
              length = 1;
            }
            object = Object2(object);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object, source, index, customizer);
              }
            }
            return object;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index = fromRight ? length : -1, iterable = Object2(collection);
            while (fromRight ? index-- : ++index < length) {
              if (iteratee2(iterable[index], index, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object, iteratee2, keysFunc) {
            var index = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function(string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined2;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string) {
            return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject(result2) ? result2 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length, placeholder = getHolder(wrapper);
            while (index--) {
              args[index] = arguments[index];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                undefined2,
                args,
                holders,
                undefined2,
                undefined2,
                arity - length
              );
            }
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          return wrapper;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined2;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index--) {
              var func = funcs[index];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index = wrapper ? index : length;
            while (++index < length) {
              func = funcs[index];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined2;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index2 = 0, result2 = length ? funcs[index2].apply(this, args) : value;
              while (++index2 < length) {
                result2 = funcs[index2].call(this, result2);
              }
              return result2;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length;
            while (index--) {
              args[index] = arguments[index];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length
              );
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createInverter(setter, toIteratee) {
          return function(object, iteratee2) {
            return baseInverter(object, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result2;
            if (value === undefined2 && other === undefined2) {
              return defaultValue;
            }
            if (value !== undefined2) {
              result2 = value;
            }
            if (other !== undefined2) {
              if (result2 === undefined2) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result2 = operator(value, other);
            }
            return result2;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length, chars) {
          chars = chars === undefined2 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined2;
            }
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined2, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder;
          return setWrapToString(result2, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number)) {
              var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop : function(values2) {
          return new Set2(values2);
        };
        function createToPairs(keysFunc) {
          return function(object) {
            var tag = getTag(object);
            if (tag == mapTag) {
              return mapToArray(object);
            }
            if (tag == setTag) {
              return setToPairs(object);
            }
            return baseToPairs(object, keysFunc(object));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined2;
          }
          ary2 = ary2 === undefined2 ? ary2 : nativeMax(toInteger(ary2), 0);
          arity = arity === undefined2 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined2;
          }
          var data = isBindKey ? undefined2 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined2, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result2, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined2 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
          if (isObject(objValue) && isObject(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject(value) ? undefined2 : value;
        }
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
          stack.set(array, other);
          stack.set(other, array);
          while (++index < arrLength) {
            var arrValue = array[index], othValue = other[index];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }
            if (compared !== undefined2) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result2;
        }
        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }
              object = object.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object, +other);
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
              return object == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object, other);
              var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object);
              return result2;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index = objLength;
          while (index--) {
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object;
          }
          var result2 = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;
          while (++index < objLength) {
            key = objProps[index];
            var objValue = object[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            }
            if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object);
          stack["delete"](other);
          return result2;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined2, flatten), func + "");
        }
        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }
        function getAllKeysIn(object) {
          return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty.call(realNames, result2) ? array.length : 0;
          while (length--) {
            var data = array[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result2;
        }
        function getHolder(func) {
          var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
          return object.placeholder;
        }
        function getIteratee() {
          var result2 = lodash.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        function getMapData(map2, key) {
          var data = map2.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        function getMatchData(object) {
          var result2 = keys(object), length = result2.length;
          while (length--) {
            var key = result2[length], value = object[key];
            result2[length] = [key, value, isStrictComparable(value)];
          }
          return result2;
        }
        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined2;
        }
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined2;
            var unmasked = true;
          } catch (e) {
          }
          var result2 = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result2;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
          if (object == null) {
            return [];
          }
          object = Object2(object);
          return arrayFilter(nativeGetSymbols(object), function(symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
          var result2 = [];
          while (object) {
            arrayPush(result2, getSymbols(object));
            object = getPrototype(object);
          }
          return result2;
        };
        var getTag = baseGetTag;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
          getTag = function(value) {
            var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          };
        }
        function getView(start, end, transforms) {
          var index = -1, length = transforms.length;
          while (++index < length) {
            var data = transforms[index], size2 = data.size;
            switch (data.type) {
              case "drop":
                start += size2;
                break;
              case "dropRight":
                end -= size2;
                break;
              case "take":
                end = nativeMin(end, start + size2);
                break;
              case "takeRight":
                start = nativeMax(start, end - size2);
                break;
            }
          }
          return { "start": start, "end": end };
        }
        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }
        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index = -1, length = path.length, result2 = false;
          while (++index < length) {
            var key = toKey(path[index]);
            if (!(result2 = object != null && hasFunc(object, key))) {
              break;
            }
            object = object[key];
          }
          if (result2 || ++index != length) {
            return result2;
          }
          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        function initCloneArray(array) {
          var length = array.length, result2 = new array.constructor(length);
          if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
            result2.index = array.index;
            result2.input = array.input;
          }
          return result2;
        }
        function initCloneObject(object) {
          return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object);
            case boolTag:
            case dateTag:
              return new Ctor(+object);
            case dataViewTag:
              return cloneDataView(object, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object);
            case regexpTag:
              return cloneRegExp(object);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object);
          }
        }
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
        }
        function isIterateeCall(value, index, object) {
          if (!isObject(object)) {
            return false;
          }
          var type = typeof index;
          if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
            return eq(object[index], value);
          }
          return false;
        }
        function isKey(value, object) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object) {
            if (object == null) {
              return false;
            }
            return object[key] === srcValue && (srcValue !== undefined2 || key in Object2(object));
          };
        }
        function memoizeCapped(func) {
          var result2 = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result2.cache;
          return result2;
        }
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function nativeKeysIn(object) {
          var result2 = [];
          if (object != null) {
            for (var key in Object2(object)) {
              result2.push(key);
            }
          }
          return result2;
        }
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        function overRest(func, start, transform2) {
          start = nativeMax(start === undefined2 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array2(start + 1);
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = transform2(array);
            return apply(func, this, otherArgs);
          };
        }
        function parent(object, path) {
          return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
          while (length--) {
            var index = indexes[length];
            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined2;
          }
          return array;
        }
        function safeGet(object, key) {
          if (key === "constructor" && typeof object[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout = ctxSetTimeout || function(func, wait) {
          return root.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined2, arguments);
          };
        }
        function shuffleSelf(array, size2) {
          var index = -1, length = array.length, lastIndex = length - 1;
          size2 = size2 === undefined2 ? length : size2;
          while (++index < size2) {
            var rand = baseRandom(index, lastIndex), value = array[rand];
            array[rand] = array[index];
            array[index] = value;
          }
          array.length = size2;
          return array;
        }
        var stringToPath = memoizeCapped(function(string) {
          var result2 = [];
          if (string.charCodeAt(0) === 46) {
            result2.push("");
          }
          string.replace(rePropName, function(match, number, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
          });
          return result2;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {
            }
            try {
              return func + "";
            } catch (e) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result2.__actions__ = copyArray(wrapper.__actions__);
          result2.__index__ = wrapper.__index__;
          result2.__values__ = wrapper.__values__;
          return result2;
        }
        function chunk(array, size2, guard) {
          if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined2) {
            size2 = 1;
          } else {
            size2 = nativeMax(toInteger(size2), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size2 < 1) {
            return [];
          }
          var index = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
          while (index < length) {
            result2[resIndex++] = baseSlice(array, index, index += size2);
          }
          return result2;
        }
        function compact(array) {
          var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index];
            if (value) {
              result2[resIndex++] = value;
            }
          }
          return result2;
        }
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array2(length - 1), array = arguments[0], index = length;
          while (index--) {
            args[index - 1] = arguments[index];
          }
          return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        var difference2 = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined2, comparator) : [];
        });
        function drop(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function dropRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length - 1;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }
        function fromPairs(pairs) {
          var index = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index < length) {
            var pair = pairs[index];
            result2[pair[0]] = pair[1];
          }
          return result2;
        }
        function head(array) {
          return array && array.length ? array[0] : undefined2;
        }
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseIndexOf(array, value, index);
        }
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        var intersection2 = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined2;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
        });
        function join(array, separator) {
          return array == null ? "" : nativeJoin.call(array, separator);
        }
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined2;
        }
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        function nth(array, n) {
          return array && array.length ? baseNth(array, toInteger(n)) : undefined2;
        }
        var pull = baseRest(pullAll);
        function pullAll(array, values2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
        }
        function pullAllBy(array, values2, iteratee2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
        }
        function pullAllWith(array, values2, comparator) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined2, comparator) : array;
        }
        var pullAt = flatRest(function(array, indexes) {
          var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index) {
            return isIndex(index, length) ? +index : index;
          }).sort(compareAscending));
          return result2;
        });
        function remove(array, predicate) {
          var result2 = [];
          if (!(array && array.length)) {
            return result2;
          }
          var index = -1, indexes = [], length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result2.push(value);
              indexes.push(index);
            }
          }
          basePullAt(array, indexes);
          return result2;
        }
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined2 ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        function sortedIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value);
            if (index < length && eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        function sortedLastIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function takeRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return array && array.length ? baseUniq(array, undefined2, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index) {
            return arrayMap(array, baseProperty(index));
          });
        }
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result2 = unzip(array);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group) {
            return apply(iteratee2, undefined2, group);
          });
        }
        var without = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined2;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result2 = lodash(value);
          result2.__chain__ = true;
          return result2;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
            return baseAt(object, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined2
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array) {
            if (length && !array.length) {
              array.push(undefined2);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined2) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
          return { "done": done, "value": value };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined2;
            if (result2) {
              previous.__wrapped__ = clone2;
            } else {
              result2 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result2;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined2
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            result2[key].push(value);
          } else {
            baseAssignValue(result2, key, [value]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value) {
            result2[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result2;
        });
        var keyBy = createAggregator(function(result2, value, key) {
          baseAssignValue(result2, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined2 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function(result2, value, key) {
          result2[key ? 0 : 1].push(value);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now = ctxNow || function() {
          return root.Date.now();
        };
        function after(n, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n, guard) {
          n = guard ? undefined2 : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n);
        }
        function before(n, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined2;
            }
            return result2;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curry.placeholder;
          return result2;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        function debounce(func, wait, options) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined2;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined2;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined2;
            return result2;
          }
          function cancel() {
            if (timerId !== undefined2) {
              clearTimeout(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined2;
          }
          function flush() {
            return timerId === undefined2 ? result2 : trailingEdge(now());
          }
          function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined2) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined2) {
              timerId = setTimeout(timerExpired, wait);
            }
            return result2;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result2 = func.apply(this, args);
            memoized.cache = cache.set(key, result2) || cache;
            return result2;
          };
          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        }
        memoize.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index = -1, length = nativeMin(args.length, funcsLength);
            while (++index < length) {
              args[index] = transforms[index].call(this, args[index]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start === undefined2 ? start : toInteger(start);
          return baseRest(func, start);
        }
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function(args) {
            var array = args[start], otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }
        function throttle(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [value];
        }
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep3(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object, source) {
          return source == null || baseConformsTo(object, source, keys(source));
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(/* @__PURE__ */ function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array2.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual4(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          var result2 = customizer ? customizer(value, other) : undefined2;
          return result2 === undefined2 ? baseIsEqual(value, other, undefined2, customizer) : !!result2;
        }
        function isError(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        function isFinite2(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        function isMatchWith(object, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        function isNaN(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value) {
          return value === undefined2;
        }
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger(value) {
          var result2 = toFinite(value), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign = createAssigner(function(object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object, source) {
          copyObject(source, keysIn(source), object);
        });
        var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object, customizer);
        });
        var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keys(source), object, customizer);
        });
        var at = flatRest(baseAt);
        function create(prototype, properties) {
          var result2 = baseCreate(prototype);
          return properties == null ? result2 : baseAssign(result2, properties);
        }
        var defaults = baseRest(function(object, sources) {
          object = Object2(object);
          var index = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined2;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index < length) {
            var source = sources[index];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object[key];
              if (value === undefined2 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                object[key] = source[key];
              }
            }
          }
          return object;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined2, customDefaultsMerge);
          return apply(mergeWith, undefined2, args);
        });
        function findKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object, iteratee2) {
          return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object, iteratee2) {
          return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object, iteratee2) {
          return object && baseForOwn(object, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object, iteratee2) {
          return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
        }
        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }
        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        function get(object, path, defaultValue) {
          var result2 = object == null ? undefined2 : baseGet(object, path);
          return result2 === undefined2 ? defaultValue : result2;
        }
        function has(object, path) {
          return object != null && hasPath(object, path, baseHas);
        }
        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }
        var invert = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          result2[value] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty.call(result2, value)) {
            result2[value].push(key);
          } else {
            result2[value] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        function mapKeys(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, iteratee2(value, key, object2), value);
          });
          return result2;
        }
        function mapValues(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, key, iteratee2(value, key, object2));
          });
          return result2;
        }
        var merge = createAssigner(function(object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
          baseMerge(object, source, srcIndex, customizer);
        });
        var omit = flatRest(function(object, paths) {
          var result2 = {};
          if (object == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object, getAllKeysIn(object), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result2, paths[length]);
          }
          return result2;
        });
        function omitBy(object, predicate) {
          return pickBy(object, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object, paths) {
          return object == null ? {} : basePick(object, paths);
        });
        function pickBy(object, predicate) {
          if (object == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        function result(object, path, defaultValue) {
          path = castPath(path, object);
          var index = -1, length = path.length;
          if (!length) {
            length = 1;
            object = undefined2;
          }
          while (++index < length) {
            var value = object == null ? undefined2 : object[toKey(path[index])];
            if (value === undefined2) {
              index = length;
              value = defaultValue;
            }
            object = isFunction(value) ? value.call(object) : value;
          }
          return object;
        }
        function set(object, path, value) {
          return object == null ? object : baseSet(object, path, value);
        }
        function setWith(object, path, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseSet(object, path, value, customizer);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object, iteratee2, accumulator) {
          var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object && object.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject(object)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object2) {
            return iteratee2(accumulator, value, index, object2);
          });
          return accumulator;
        }
        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }
        function update(object, path, updater) {
          return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        function updateWith(object, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }
        function valuesIn(object) {
          return object == null ? [] : baseValues(object, keysIn(object));
        }
        function clamp(number, lower, upper) {
          if (upper === undefined2) {
            upper = lower;
            lower = undefined2;
          }
          if (upper !== undefined2) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined2) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }
        function inRange(number, start, end) {
          start = toFinite(start);
          if (end === undefined2) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number = toNumber(number);
          return baseInRange(number, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined2;
          }
          if (floating === undefined2) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined2;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined2;
            }
          }
          if (lower === undefined2 && upper === undefined2) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined2) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result2, word, index) {
          word = word.toLowerCase();
          return result2 + (index ? capitalize(word) : word);
        });
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string, target, position) {
          string = toString(string);
          target = baseToString(target);
          var length = string.length;
          position = position === undefined2 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string.slice(position, end) == target;
        }
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        var kebabCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          if (!length || strLength >= length) {
            return string;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        function padStart(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        function parseInt2(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string, n, guard) {
          if (guard ? isIterateeCall(string, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          return baseRepeat(toString(string), n);
        }
        function replace() {
          var args = arguments, string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "_" : "") + word.toLowerCase();
        });
        function split(string, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
            separator = limit = undefined2;
          }
          limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string = toString(string);
          if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }
          return string.split(separator, limit);
        }
        var startCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + upperFirst(word);
        });
        function startsWith(string, target, position) {
          string = toString(string);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
          target = baseToString(target);
          return string.slice(position, position + target.length) == target;
        }
        function template(string, options, guard) {
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined2;
          }
          string = toString(string);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index = offset + match.length;
            return match;
          });
          source += "';\n";
          var variable = hasOwnProperty.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
          });
          result2.source = source;
          if (isError(result2)) {
            throw result2;
          }
          return result2;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return baseTrim(string);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.slice(0, trimmedEndIndex(string) + 1);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.replace(reTrimStart, "");
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length = "length" in options ? toInteger(options.length) : length;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
          if (separator === undefined2) {
            return result2 + omission;
          }
          if (strSymbols) {
            end += result2.length - end;
          }
          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match, substring = result2;
              if (!separator.global) {
                separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }
              result2 = result2.slice(0, newEnd === undefined2 ? end : newEnd);
            }
          } else if (string.indexOf(baseToString(separator), end) != end) {
            var index = result2.lastIndexOf(separator);
            if (index > -1) {
              result2 = result2.slice(0, index);
            }
          }
          return result2 + omission;
        }
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        var upperCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined2 : pattern;
          if (pattern === undefined2) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined2, args);
          } catch (e) {
            return isError(e) ? e : new Error2(e);
          }
        });
        var bindAll = flatRest(function(object, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object, key, bind(object[key], object));
          });
          return object;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index = -1;
            while (++index < length) {
              var pair = pairs[index];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object) {
            return baseInvoke(object, path, args);
          };
        });
        var methodOf = baseRest(function(object, args) {
          return function(path) {
            return baseInvoke(object, path, args);
          };
        });
        function mixin(object, source, options) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object[methodName] = func;
            if (isFunc) {
              object.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                  actions.push({ "func": func, "args": arguments, "thisArg": object });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object, arrayPush([this.value()], arguments));
              };
            }
          });
          return object;
        }
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }
        function noop() {
        }
        function nthArg(n) {
          n = toInteger(n);
          return baseRest(function(args) {
            return baseNth(args, n);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        function propertyOf(object) {
          return function(path) {
            return object == null ? undefined2 : baseGet(object, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n, iteratee2) {
          n = toInteger(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length, iteratee2);
          while (++index < n) {
            iteratee2(index);
          }
          return result2;
        }
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        function uniqueId2(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor = createRound("floor");
        function max3(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined2;
        }
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined2;
        }
        function mean(array) {
          return baseMean(array, identity);
        }
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        function min3(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined2;
        }
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined2;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        function sumBy(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference2;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection2;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        mixin(lodash, lodash);
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep3;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual4;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite2;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max3;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min3;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt2;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext2;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId2;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
          var source = {};
          baseForOwn(lodash, function(func, methodName) {
            if (!hasOwnProperty.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), { "chain": false });
        lodash.VERSION = VERSION;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash[methodName].placeholder = lodash;
        });
        arrayEach(["drop", "take"], function(methodName, index) {
          LazyWrapper.prototype[methodName] = function(n) {
            n = n === undefined2 ? 1 : nativeMax(toInteger(n), 0);
            var result2 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin(n, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n) {
            return this.reverse()[methodName](n).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index) {
          var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach(["head", "last"], function(methodName, index) {
          var takeName = "take" + (index ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index) {
          var dropName = "drop" + (index ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger(start);
          var result2 = this;
          if (result2.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result2);
          }
          if (start < 0) {
            result2 = result2.takeRight(-start);
          } else if (start) {
            result2 = result2.drop(start);
          }
          if (end !== undefined2) {
            end = toInteger(end);
            result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = function(value2) {
              var result3 = lodashFunc.apply(lodash, arrayPush([value2], args));
              return isTaker && chainAll ? result3[0] : result3;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result2 = func.apply(value, args);
              result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined2 });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined2
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
      };
      var _ = runInContext();
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        root._ = _;
        define(function() {
          return _;
        });
      } else if (freeModule) {
        (freeModule.exports = _)._ = _;
        freeExports._ = _;
      } else {
        root._ = _;
      }
    }).call(exports);
  }
});

// node_modules/pure-uuid/uuid.js
var require_uuid = __commonJS({
  "node_modules/pure-uuid/uuid.js"(exports, module) {
    "use strict";
    (function(root, name, factory) {
      if (typeof define === "function" && typeof define.amd !== "undefined")
        define(function() {
          return factory(root);
        });
      else if (typeof module === "object" && typeof module.exports === "object") {
        module.exports = factory(root);
        module.exports.default = module.exports;
      } else
        root[name] = factory(root);
    })(exports, "UUID", function() {
      var a2hs = function(bytes, begin, end, uppercase, str, pos) {
        var mkNum = function(num, uppercase2) {
          var base16 = num.toString(16);
          if (base16.length < 2)
            base16 = "0" + base16;
          if (uppercase2)
            base16 = base16.toUpperCase();
          return base16;
        };
        for (var i = begin; i <= end; i++)
          str[pos++] = mkNum(bytes[i], uppercase);
        return str;
      };
      var hs2a = function(str, begin, end, bytes, pos) {
        for (var i = begin; i <= end; i += 2)
          bytes[pos++] = parseInt(str.substr(i, 2), 16);
      };
      var z85_encoder = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.-:+=^!/*?&<>()[]{}@%$#".split("");
      var z85_decoder = [
        0,
        68,
        0,
        84,
        83,
        82,
        72,
        0,
        75,
        76,
        70,
        65,
        0,
        63,
        62,
        69,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        64,
        0,
        73,
        66,
        74,
        71,
        81,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        77,
        0,
        78,
        67,
        0,
        0,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        79,
        0,
        80,
        0,
        0
      ];
      var z85_encode = function(data, size) {
        if (size % 4 !== 0)
          throw new Error("z85_encode: invalid input length (multiple of 4 expected)");
        var str = "";
        var i = 0;
        var value = 0;
        while (i < size) {
          value = value * 256 + data[i++];
          if (i % 4 === 0) {
            var divisor = 85 * 85 * 85 * 85;
            while (divisor >= 1) {
              var idx = Math.floor(value / divisor) % 85;
              str += z85_encoder[idx];
              divisor /= 85;
            }
            value = 0;
          }
        }
        return str;
      };
      var z85_decode = function(str, dest) {
        var l = str.length;
        if (l % 5 !== 0)
          throw new Error("z85_decode: invalid input length (multiple of 5 expected)");
        if (typeof dest === "undefined")
          dest = new Array(l * 4 / 5);
        var i = 0;
        var j = 0;
        var value = 0;
        while (i < l) {
          var idx = str.charCodeAt(i++) - 32;
          if (idx < 0 || idx >= z85_decoder.length)
            break;
          value = value * 85 + z85_decoder[idx];
          if (i % 5 === 0) {
            var divisor = 256 * 256 * 256;
            while (divisor >= 1) {
              dest[j++] = Math.trunc(value / divisor % 256);
              divisor /= 256;
            }
            value = 0;
          }
        }
        return dest;
      };
      var s2a = function(s, _options) {
        var options = { ibits: 8, obits: 8, obigendian: true };
        for (var opt in _options)
          if (typeof options[opt] !== "undefined")
            options[opt] = _options[opt];
        var a = [];
        var i = 0;
        var c, C;
        var ck = 0;
        var w;
        var wk = 0;
        var sl = s.length;
        for (; ; ) {
          if (ck === 0)
            C = s.charCodeAt(i++);
          c = C >> options.ibits - (ck + 8) & 255;
          ck = (ck + 8) % options.ibits;
          if (options.obigendian) {
            if (wk === 0) w = c << options.obits - 8;
            else w |= c << options.obits - 8 - wk;
          } else {
            if (wk === 0) w = c;
            else w |= c << wk;
          }
          wk = (wk + 8) % options.obits;
          if (wk === 0) {
            a.push(w);
            if (i >= sl)
              break;
          }
        }
        return a;
      };
      var a2s = function(a, _options) {
        var options = { ibits: 32, ibigendian: true };
        for (var opt in _options)
          if (typeof options[opt] !== "undefined")
            options[opt] = _options[opt];
        var s = "";
        var imask = 4294967295;
        if (options.ibits < 32)
          imask = (1 << options.ibits) - 1;
        var al = a.length;
        for (var i = 0; i < al; i++) {
          var w = a[i] & imask;
          for (var j = 0; j < options.ibits; j += 8) {
            if (options.ibigendian)
              s += String.fromCharCode(w >> options.ibits - 8 - j & 255);
            else
              s += String.fromCharCode(w >> j & 255);
          }
        }
        return s;
      };
      var UI64_DIGITS = 8;
      var UI64_DIGIT_BITS = 8;
      var UI64_DIGIT_BASE = 256;
      var ui64_d2i = function(d7, d6, d5, d4, d3, d2, d1, d0) {
        return [d0, d1, d2, d3, d4, d5, d6, d7];
      };
      var ui64_zero = function() {
        return ui64_d2i(0, 0, 0, 0, 0, 0, 0, 0);
      };
      var ui64_clone = function(x) {
        return x.slice(0);
      };
      var ui64_n2i = function(n) {
        var ui64 = ui64_zero();
        for (var i = 0; i < UI64_DIGITS; i++) {
          ui64[i] = Math.floor(n % UI64_DIGIT_BASE);
          n /= UI64_DIGIT_BASE;
        }
        return ui64;
      };
      var ui64_i2n = function(x) {
        var n = 0;
        for (var i = UI64_DIGITS - 1; i >= 0; i--) {
          n *= UI64_DIGIT_BASE;
          n += x[i];
        }
        return Math.floor(n);
      };
      var ui64_add = function(x, y) {
        var carry = 0;
        for (var i = 0; i < UI64_DIGITS; i++) {
          carry += x[i] + y[i];
          x[i] = Math.floor(carry % UI64_DIGIT_BASE);
          carry = Math.floor(carry / UI64_DIGIT_BASE);
        }
        return carry;
      };
      var ui64_muln = function(x, n) {
        var carry = 0;
        for (var i = 0; i < UI64_DIGITS; i++) {
          carry += x[i] * n;
          x[i] = Math.floor(carry % UI64_DIGIT_BASE);
          carry = Math.floor(carry / UI64_DIGIT_BASE);
        }
        return carry;
      };
      var ui64_mul = function(x, y) {
        var i, j;
        var zx = new Array(UI64_DIGITS + UI64_DIGITS);
        for (i = 0; i < UI64_DIGITS + UI64_DIGITS; i++)
          zx[i] = 0;
        var carry;
        for (i = 0; i < UI64_DIGITS; i++) {
          carry = 0;
          for (j = 0; j < UI64_DIGITS; j++) {
            carry += x[i] * y[j] + zx[i + j];
            zx[i + j] = carry % UI64_DIGIT_BASE;
            carry /= UI64_DIGIT_BASE;
          }
          for (; j < UI64_DIGITS + UI64_DIGITS - i; j++) {
            carry += zx[i + j];
            zx[i + j] = carry % UI64_DIGIT_BASE;
            carry /= UI64_DIGIT_BASE;
          }
        }
        for (i = 0; i < UI64_DIGITS; i++)
          x[i] = zx[i];
        return zx.slice(UI64_DIGITS, UI64_DIGITS);
      };
      var ui64_and = function(x, y) {
        for (var i = 0; i < UI64_DIGITS; i++)
          x[i] &= y[i];
        return x;
      };
      var ui64_or = function(x, y) {
        for (var i = 0; i < UI64_DIGITS; i++)
          x[i] |= y[i];
        return x;
      };
      var ui64_rorn = function(x, s) {
        var ov = ui64_zero();
        if (s % UI64_DIGIT_BITS !== 0)
          throw new Error("ui64_rorn: only bit rotations supported with a multiple of digit bits");
        var k = Math.floor(s / UI64_DIGIT_BITS);
        for (var i = 0; i < k; i++) {
          for (var j = UI64_DIGITS - 1 - 1; j >= 0; j--)
            ov[j + 1] = ov[j];
          ov[0] = x[0];
          for (j = 0; j < UI64_DIGITS - 1; j++)
            x[j] = x[j + 1];
          x[j] = 0;
        }
        return ui64_i2n(ov);
      };
      var ui64_ror = function(x, s) {
        if (s > UI64_DIGITS * UI64_DIGIT_BITS)
          throw new Error("ui64_ror: invalid number of bits to shift");
        var zx = new Array(UI64_DIGITS + UI64_DIGITS);
        var i;
        for (i = 0; i < UI64_DIGITS; i++) {
          zx[i + UI64_DIGITS] = x[i];
          zx[i] = 0;
        }
        var k1 = Math.floor(s / UI64_DIGIT_BITS);
        var k2 = s % UI64_DIGIT_BITS;
        for (i = k1; i < UI64_DIGITS + UI64_DIGITS - 1; i++) {
          zx[i - k1] = (zx[i] >>> k2 | zx[i + 1] << UI64_DIGIT_BITS - k2) & (1 << UI64_DIGIT_BITS) - 1;
        }
        zx[UI64_DIGITS + UI64_DIGITS - 1 - k1] = zx[UI64_DIGITS + UI64_DIGITS - 1] >>> k2 & (1 << UI64_DIGIT_BITS) - 1;
        for (i = UI64_DIGITS + UI64_DIGITS - 1 - k1 + 1; i < UI64_DIGITS + UI64_DIGITS; i++)
          zx[i] = 0;
        for (i = 0; i < UI64_DIGITS; i++)
          x[i] = zx[i + UI64_DIGITS];
        return zx.slice(0, UI64_DIGITS);
      };
      var ui64_rol = function(x, s) {
        if (s > UI64_DIGITS * UI64_DIGIT_BITS)
          throw new Error("ui64_rol: invalid number of bits to shift");
        var zx = new Array(UI64_DIGITS + UI64_DIGITS);
        var i;
        for (i = 0; i < UI64_DIGITS; i++) {
          zx[i + UI64_DIGITS] = 0;
          zx[i] = x[i];
        }
        var k1 = Math.floor(s / UI64_DIGIT_BITS);
        var k2 = s % UI64_DIGIT_BITS;
        for (i = UI64_DIGITS - 1 - k1; i > 0; i--) {
          zx[i + k1] = (zx[i] << k2 | zx[i - 1] >>> UI64_DIGIT_BITS - k2) & (1 << UI64_DIGIT_BITS) - 1;
        }
        zx[0 + k1] = zx[0] << k2 & (1 << UI64_DIGIT_BITS) - 1;
        for (i = 0 + k1 - 1; i >= 0; i--)
          zx[i] = 0;
        for (i = 0; i < UI64_DIGITS; i++)
          x[i] = zx[i];
        return zx.slice(UI64_DIGITS, UI64_DIGITS);
      };
      var ui64_xor = function(x, y) {
        for (var i = 0; i < UI64_DIGITS; i++)
          x[i] ^= y[i];
      };
      var ui32_add = function(x, y) {
        var lsw = (x & 65535) + (y & 65535);
        var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 65535;
      };
      var ui32_rol = function(num, cnt) {
        return num << cnt & 4294967295 | num >>> 32 - cnt & 4294967295;
      };
      var sha1_core = function(x, len) {
        function sha1_ft(t2, b2, c2, d2) {
          if (t2 < 20) return b2 & c2 | ~b2 & d2;
          if (t2 < 40) return b2 ^ c2 ^ d2;
          if (t2 < 60) return b2 & c2 | b2 & d2 | c2 & d2;
          return b2 ^ c2 ^ d2;
        }
        function sha1_kt(t2) {
          return t2 < 20 ? 1518500249 : t2 < 40 ? 1859775393 : t2 < 60 ? -1894007588 : -899497514;
        }
        x[len >> 5] |= 128 << 24 - len % 32;
        x[(len + 64 >> 9 << 4) + 15] = len;
        var w = Array(80);
        var a = 1732584193;
        var b = -271733879;
        var c = -1732584194;
        var d = 271733878;
        var e = -1009589776;
        for (var i = 0; i < x.length; i += 16) {
          var olda = a;
          var oldb = b;
          var oldc = c;
          var oldd = d;
          var olde = e;
          for (var j = 0; j < 80; j++) {
            if (j < 16)
              w[j] = x[i + j];
            else
              w[j] = ui32_rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
            var t = ui32_add(
              ui32_add(ui32_rol(a, 5), sha1_ft(j, b, c, d)),
              ui32_add(ui32_add(e, w[j]), sha1_kt(j))
            );
            e = d;
            d = c;
            c = ui32_rol(b, 30);
            b = a;
            a = t;
          }
          a = ui32_add(a, olda);
          b = ui32_add(b, oldb);
          c = ui32_add(c, oldc);
          d = ui32_add(d, oldd);
          e = ui32_add(e, olde);
        }
        return [a, b, c, d, e];
      };
      var sha1 = function(s) {
        return a2s(
          sha1_core(
            s2a(s, { ibits: 8, obits: 32, obigendian: true }),
            s.length * 8
          ),
          { ibits: 32, ibigendian: true }
        );
      };
      var md5_core = function(x, len) {
        function md5_cmn(q, a2, b2, x2, s, t) {
          return ui32_add(ui32_rol(ui32_add(ui32_add(a2, q), ui32_add(x2, t)), s), b2);
        }
        function md5_ff(a2, b2, c2, d2, x2, s, t) {
          return md5_cmn(b2 & c2 | ~b2 & d2, a2, b2, x2, s, t);
        }
        function md5_gg(a2, b2, c2, d2, x2, s, t) {
          return md5_cmn(b2 & d2 | c2 & ~d2, a2, b2, x2, s, t);
        }
        function md5_hh(a2, b2, c2, d2, x2, s, t) {
          return md5_cmn(b2 ^ c2 ^ d2, a2, b2, x2, s, t);
        }
        function md5_ii(a2, b2, c2, d2, x2, s, t) {
          return md5_cmn(c2 ^ (b2 | ~d2), a2, b2, x2, s, t);
        }
        x[len >> 5] |= 128 << len % 32;
        x[(len + 64 >>> 9 << 4) + 14] = len;
        var a = 1732584193;
        var b = -271733879;
        var c = -1732584194;
        var d = 271733878;
        for (var i = 0; i < x.length; i += 16) {
          var olda = a;
          var oldb = b;
          var oldc = c;
          var oldd = d;
          a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
          d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
          c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
          b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
          a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
          d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
          c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
          b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
          a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
          d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
          c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
          b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
          a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
          d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
          c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
          b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
          a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
          d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
          c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
          b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
          a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
          d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
          c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
          b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
          a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
          d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
          c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
          b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
          a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
          d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
          c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
          b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
          a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
          d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
          c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
          b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
          a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
          d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
          c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
          b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
          a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
          d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
          c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
          b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
          a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
          d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
          c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
          b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
          a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
          d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
          c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
          b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
          a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
          d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
          c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
          b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
          a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
          d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
          c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
          b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
          a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
          d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
          c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
          b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
          a = ui32_add(a, olda);
          b = ui32_add(b, oldb);
          c = ui32_add(c, oldc);
          d = ui32_add(d, oldd);
        }
        return [a, b, c, d];
      };
      var md5 = function(s) {
        return a2s(
          md5_core(
            s2a(s, { ibits: 8, obits: 32, obigendian: false }),
            s.length * 8
          ),
          { ibits: 32, ibigendian: false }
        );
      };
      var PCG = function(seed) {
        this.mul = ui64_d2i(88, 81, 244, 45, 76, 149, 127, 45);
        this.inc = ui64_d2i(20, 5, 123, 126, 247, 103, 129, 79);
        this.mask = ui64_d2i(0, 0, 0, 0, 255, 255, 255, 255);
        this.state = ui64_clone(this.inc);
        this.next();
        ui64_and(this.state, this.mask);
        var arr;
        if (seed !== void 0)
          seed = ui64_n2i(seed >>> 0);
        else if (typeof window === "object" && typeof window.crypto === "object" && typeof window.crypto.getRandomValues === "function") {
          arr = new Uint32Array(2);
          window.crypto.getRandomValues(arr);
          seed = ui64_or(ui64_n2i(arr[0] >>> 0), ui64_ror(ui64_n2i(arr[1] >>> 0), 32));
        } else if (typeof globalThis === "object" && typeof globalThis.crypto === "object" && typeof globalThis.crypto.getRandomValues === "function") {
          arr = new Uint32Array(2);
          globalThis.crypto.getRandomValues(arr);
          seed = ui64_or(ui64_n2i(arr[0] >>> 0), ui64_ror(ui64_n2i(arr[1] >>> 0), 32));
        } else {
          seed = ui64_n2i(Math.random() * 4294967295 >>> 0);
          ui64_or(seed, ui64_ror(ui64_n2i((/* @__PURE__ */ new Date()).getTime()), 32));
        }
        ui64_or(this.state, seed);
        this.next();
      };
      PCG.prototype.next = function() {
        var state = ui64_clone(this.state);
        ui64_mul(this.state, this.mul);
        ui64_add(this.state, this.inc);
        var output = ui64_clone(state);
        ui64_ror(output, 18);
        ui64_xor(output, state);
        ui64_ror(output, 27);
        var rot = ui64_clone(state);
        ui64_ror(rot, 59);
        ui64_and(output, this.mask);
        var k = ui64_i2n(rot);
        var output2 = ui64_clone(output);
        ui64_rol(output2, 32 - k);
        ui64_ror(output, k);
        ui64_xor(output, output2);
        return ui64_i2n(output);
      };
      PCG.prototype.reseed = function(seed) {
        if (typeof seed !== "string")
          throw new Error("UUID: PCG: seed: invalid argument (string expected)");
        var arr = sha1_core(s2a(seed, { ibits: 8, obits: 32, obigendian: true }), seed.length * 8);
        for (var i = 0; i < arr.length; i++)
          ui64_xor(pcg.state, ui64_n2i(arr[i] >>> 0));
      };
      var pcg = new PCG();
      PCG.reseed = function(seed) {
        pcg.reseed(seed);
      };
      var prng = function(len, radix) {
        var bytes = [];
        for (var i = 0; i < len; i++)
          bytes[i] = pcg.next() % radix;
        return bytes;
      };
      var time_last = 0;
      var time_seq = 0;
      var UUID2 = function() {
        if (arguments.length === 1 && typeof arguments[0] === "string")
          this.parse.apply(this, arguments);
        else if (arguments.length >= 1 && typeof arguments[0] === "number")
          this.make.apply(this, arguments);
        else if (arguments.length >= 1)
          throw new Error("UUID: constructor: invalid arguments");
        else
          for (var i = 0; i < 16; i++)
            this[i] = 0;
      };
      if (typeof Uint8Array !== "undefined")
        UUID2.prototype = new Uint8Array(16);
      else if (Buffer)
        UUID2.prototype = Buffer.alloc(16);
      else
        UUID2.prototype = new Array(16);
      UUID2.prototype.constructor = UUID2;
      UUID2.prototype.make = function(version) {
        var i;
        var uuid = this;
        if (version === 1) {
          var date = /* @__PURE__ */ new Date();
          var time_now = date.getTime();
          if (time_now !== time_last)
            time_seq = 0;
          else
            time_seq++;
          time_last = time_now;
          var t = ui64_n2i(time_now);
          ui64_muln(t, 1e3 * 10);
          ui64_add(t, ui64_d2i(1, 178, 29, 210, 19, 129, 64, 0));
          if (time_seq > 0)
            ui64_add(t, ui64_n2i(time_seq));
          var ov;
          ov = ui64_rorn(t, 8);
          uuid[3] = ov & 255;
          ov = ui64_rorn(t, 8);
          uuid[2] = ov & 255;
          ov = ui64_rorn(t, 8);
          uuid[1] = ov & 255;
          ov = ui64_rorn(t, 8);
          uuid[0] = ov & 255;
          ov = ui64_rorn(t, 8);
          uuid[5] = ov & 255;
          ov = ui64_rorn(t, 8);
          uuid[4] = ov & 255;
          ov = ui64_rorn(t, 8);
          uuid[7] = ov & 255;
          ov = ui64_rorn(t, 8);
          uuid[6] = ov & 15;
          var clock = prng(2, 255);
          uuid[8] = clock[0];
          uuid[9] = clock[1];
          var node = prng(6, 255);
          node[0] |= 1;
          node[0] |= 2;
          for (i = 0; i < 6; i++)
            uuid[10 + i] = node[i];
        } else if (version === 4) {
          var data = prng(16, 255);
          for (i = 0; i < 16; i++)
            this[i] = data[i];
        } else if (version === 3 || version === 5) {
          var input = "";
          var nsUUID = typeof arguments[1] === "object" && arguments[1] instanceof UUID2 ? arguments[1] : new UUID2().parse(arguments[1]);
          for (i = 0; i < 16; i++)
            input += String.fromCharCode(nsUUID[i]);
          input += arguments[2];
          var s = version === 3 ? md5(input) : sha1(input);
          for (i = 0; i < 16; i++)
            uuid[i] = s.charCodeAt(i);
        } else
          throw new Error("UUID: make: invalid version");
        uuid[6] &= 15;
        uuid[6] |= version << 4;
        uuid[8] &= 63;
        uuid[8] |= 2 << 6;
        return uuid;
      };
      UUID2.prototype.format = function(type) {
        var str, arr;
        if (type === "z85")
          str = z85_encode(this, 16);
        else if (type === "b16") {
          arr = Array(32);
          a2hs(this, 0, 15, true, arr, 0);
          str = arr.join("");
        } else if (type === void 0 || type === "std") {
          arr = new Array(36);
          a2hs(this, 0, 3, false, arr, 0);
          arr[8] = "-";
          a2hs(this, 4, 5, false, arr, 9);
          arr[13] = "-";
          a2hs(this, 6, 7, false, arr, 14);
          arr[18] = "-";
          a2hs(this, 8, 9, false, arr, 19);
          arr[23] = "-";
          a2hs(this, 10, 15, false, arr, 24);
          str = arr.join("");
        }
        return str;
      };
      UUID2.prototype.toString = function(type) {
        return this.format(type);
      };
      UUID2.prototype.toJSON = function() {
        return this.format("std");
      };
      UUID2.prototype.parse = function(str, type) {
        if (typeof str !== "string")
          throw new Error("UUID: parse: invalid argument (type string expected)");
        if (type === "z85")
          z85_decode(str, this);
        else if (type === "b16")
          hs2a(str, 0, 35, this, 0);
        else if (type === void 0 || type === "std") {
          var map = {
            "nil": "00000000-0000-0000-0000-000000000000",
            "ns:DNS": "6ba7b810-9dad-11d1-80b4-00c04fd430c8",
            "ns:URL": "6ba7b811-9dad-11d1-80b4-00c04fd430c8",
            "ns:OID": "6ba7b812-9dad-11d1-80b4-00c04fd430c8",
            "ns:X500": "6ba7b814-9dad-11d1-80b4-00c04fd430c8"
          };
          if (map[str] !== void 0)
            str = map[str];
          else if (!str.match(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/))
            throw new Error('UUID: parse: invalid string representation (expected "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx")');
          hs2a(str, 0, 7, this, 0);
          hs2a(str, 9, 12, this, 4);
          hs2a(str, 14, 17, this, 6);
          hs2a(str, 19, 22, this, 8);
          hs2a(str, 24, 35, this, 10);
        }
        return this;
      };
      UUID2.prototype.export = function() {
        var arr = Array(16);
        for (var i = 0; i < 16; i++)
          arr[i] = this[i];
        return arr;
      };
      UUID2.prototype.import = function(arr) {
        if (!(typeof arr === "object" && arr instanceof Array))
          throw new Error("UUID: import: invalid argument (type Array expected)");
        if (arr.length !== 16)
          throw new Error("UUID: import: invalid argument (Array of length 16 expected)");
        for (var i = 0; i < 16; i++) {
          if (typeof arr[i] !== "number")
            throw new Error("UUID: import: invalid array element #" + i + " (type Number expected)");
          if (!(isFinite(arr[i]) && Math.floor(arr[i]) === arr[i]))
            throw new Error("UUID: import: invalid array element #" + i + " (Number with integer value expected)");
          if (!(arr[i] >= 0 && arr[i] <= 255))
            throw new Error("UUID: import: invalid array element #" + i + " (Number with integer value in range 0...255 expected)");
          this[i] = arr[i];
        }
        return this;
      };
      UUID2.prototype.compare = function(other) {
        if (typeof other !== "object")
          throw new Error("UUID: compare: invalid argument (type UUID expected)");
        if (!(other instanceof UUID2))
          throw new Error("UUID: compare: invalid argument (type UUID expected)");
        for (var i = 0; i < 16; i++) {
          if (this[i] < other[i])
            return -1;
          else if (this[i] > other[i])
            return 1;
        }
        return 0;
      };
      UUID2.prototype.equal = function(other) {
        return this.compare(other) === 0;
      };
      UUID2.prototype.fold = function(k) {
        if (typeof k === "undefined")
          throw new Error("UUID: fold: invalid argument (number of fold operations expected)");
        if (k < 1 || k > 4)
          throw new Error("UUID: fold: invalid argument (1-4 fold operations expected)");
        var n = 16 / Math.pow(2, k);
        var hash = new Array(n);
        for (var i = 0; i < n; i++) {
          var h = 0;
          for (var j = 0; i + j < 16; j += n)
            h ^= this[i + j];
          hash[i] = h;
        }
        return hash;
      };
      UUID2.PCG = PCG;
      return UUID2;
    });
  }
});

// src/common/domainTypes.ts
var DependencyType = /* @__PURE__ */ ((DependencyType2) => {
  DependencyType2["FS"] = "FINISH_TO_START";
  DependencyType2["FF"] = "FINISH_TO_FINISH";
  DependencyType2["SS"] = "START_TO_START";
  DependencyType2["SF"] = "START_TO_FINISH";
  return DependencyType2;
})(DependencyType || {});
var OrderStatus = /* @__PURE__ */ ((OrderStatus2) => {
  OrderStatus2["SUCCESS"] = "GREEN";
  OrderStatus2["DELAY"] = "YELLOW";
  OrderStatus2["ERROR"] = "RED";
  OrderStatus2["REPORTED_DONE"] = "REPORTED_DONE";
  OrderStatus2["REJECTED"] = "REJECTED";
  OrderStatus2["DONE"] = "DONE";
  OrderStatus2["NOT_SET"] = "NOT_SET";
  return OrderStatus2;
})(OrderStatus || {});

// src/common/errors.ts
var BaseError = class extends Error {
  code;
  constructor(code, message) {
    super(message);
    this.code = code;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = this.constructor.name;
  }
};
var EntityNotFoundError = class extends BaseError {
  constructor(entity, id) {
    super("001_ENTITY_NOT_FOUND", `The ${entity} with id ${id} was not found`);
  }
};
var UndefinedElementDatesError = class extends BaseError {
  constructor(entity, id) {
    super(
      "002_UNDEFINED_ELEMENT_DATES",
      `The ${entity} with id ${id} has no defined start or end date`
    );
  }
};
var DependencyCycleError = class extends BaseError {
  constructor(nodes) {
    super(
      "003_DEPENDENCY_CYCLE_DETECTED",
      `A dependency cycle was detected: ${nodes.join(" -> ")}`
    );
  }
};
var NoWorkingTimeAvailableError = class extends BaseError {
  constructor(calendar) {
    super(
      "004_NO_WORKING_TIME_AVAILABLE",
      `The calendar with id ${calendar} has no working time available`
    );
  }
};
var InvalidDateTimeFormatError = class extends BaseError {
  constructor(time) {
    super(
      "005_INVALID_DATE_TIME_FORMAT",
      `While parsing a date, an invalid date time format ${time} was detected`
    );
  }
};
var InfiniteLoopInCalendarError = class extends BaseError {
  constructor(date, calendarId) {
    super(
      "006_INFINITE_LOOP_IN_CALENDAR_DETECTED",
      `While iterating calendar '${calendarId}', an infinite loop was detected. The date ${date.toISOString()} was processed multiple times in a row`
    );
  }
};
var UnknownDependencyTypeError = class extends BaseError {
  constructor(type) {
    super("007_UNKNOWN_DEPENDENCY_TYPE", `Received an unknown dependency type ${type}`);
  }
};
var NoOrderFoundInSequenceError = class extends BaseError {
  constructor() {
    super(
      "008_NO_ORDER_FOUND_IN_SEQUENCE",
      `Could not find an order related to the sequence to derive the offsets from`
    );
  }
};
var SchedulingEngineNotInitializedError = class extends BaseError {
  constructor() {
    super(
      "009_SCHEDULING_ENGINE_NOT_INITIALIZED",
      `The scheduling engine has not been initialized yet`
    );
  }
};
var MultipleDependenciesError = class extends BaseError {
  constructor(from, to) {
    super(
      "010_MULTIPLE_DEPENDENCIES_DETECTED",
      `Multiple dependencies between ${from} and ${to} were detected, making it unclear which one to resolve.`
    );
  }
};
var InvalidElementDurationError = class extends BaseError {
  constructor(elementId, duration, entity = "element") {
    super(
      "011_INVALID_ELEMENT_DURATION",
      `Cannot schedule the ${entity} with id ${elementId} using a duration of ${duration.toString()}.`
    );
  }
};

// src/common/utils/search.ts
function depthFirstSearch(startNodes, getSuccessors, canVisitNode = () => true) {
  const visited = /* @__PURE__ */ new Set();
  let shouldContinue = true;
  const doDfs = (node, path) => {
    if (!canVisitNode(node, path)) {
      shouldContinue = false;
      return;
    }
    if (!shouldContinue || visited.has(node)) {
      return;
    }
    visited.add(node);
    path.add(node);
    getSuccessors(node).forEach((neighbor) => {
      if (shouldContinue) {
        doDfs(neighbor, new Set(path));
      }
    });
    path.delete(node);
  };
  startNodes.forEach((node) => {
    if (!visited.has(node) && shouldContinue) {
      doDfs(node, /* @__PURE__ */ new Set());
    }
  });
  return visited;
}
function binarySearch(arr, target, compare) {
  let start = 0;
  let end = arr.length - 1;
  compare = compare || ((a, b) => {
    if (typeof a === "number" && typeof b === "number") {
      return a - b;
    }
    if (typeof a === "string" && typeof b === "string") {
      return a.localeCompare(b);
    }
    if (a instanceof Date && b instanceof Date) {
      return a.getTime() - b.getTime();
    }
    throw new Error("No compare function provided for binary search");
  });
  while (start <= end) {
    const mid = start + Math.floor((end - start) / 2);
    const result = compare(target, arr[mid]);
    if (result === 0) {
      return mid;
    }
    if (result < 0) {
      end = mid - 1;
    } else {
      start = mid + 1;
    }
  }
  return -1;
}

// src/common/utils/sets.ts
function intersection(setA, setB) {
  const [smallerSet, largerSet] = setA.size > setB.size ? [setB, setA] : [setA, setB];
  const intersect = /* @__PURE__ */ new Set();
  smallerSet.forEach((elem) => {
    if (largerSet.has(elem)) {
      intersect.add(elem);
    }
  });
  return intersect;
}
function difference(setA, setB) {
  const diff = /* @__PURE__ */ new Set();
  setA.forEach((elem) => {
    if (!setB.has(elem)) {
      diff.add(elem);
    }
  });
  return diff;
}
function rename(set, mapping) {
  const newSet = /* @__PURE__ */ new Set();
  set.forEach((elem) => {
    const mappedValue = mapping[elem];
    if (mappedValue === void 0) {
      newSet.add(elem);
      return;
    }
    if (Array.isArray(mappedValue)) {
      mappedValue.forEach((newElem) => {
        newSet.add(newElem);
      });
      return;
    }
    newSet.add(mappedValue);
  });
  return newSet;
}

// src/core/dependencies/dependencyGraph.ts
var DependencyGraph = class _DependencyGraph {
  nodes = /* @__PURE__ */ new Map();
  edges = /* @__PURE__ */ new Map();
  predecessors = /* @__PURE__ */ new Map();
  successors = /* @__PURE__ */ new Map();
  edgeIdDictionary = /* @__PURE__ */ new Map();
  constructor(nodes = [], edges = []) {
    this.addNodes(nodes);
    this.addEdges(edges);
  }
  addNode(node) {
    this.nodes.set(node.id, { id: node.id });
    this.successors.set(node.id, /* @__PURE__ */ new Set());
    this.predecessors.set(node.id, /* @__PURE__ */ new Set());
  }
  addNodes(nodes) {
    nodes.forEach((node) => {
      this.addNode(node);
    });
  }
  removeNode(node) {
    if (typeof node === "string") {
      const internalNode = this.nodes.get(node);
      if (!internalNode) {
        return;
      }
      node = internalNode;
    }
    const nodeId = node.id;
    const predecessors = this.getPredecessors(node.id);
    const successors = this.getSuccessors(node.id);
    predecessors.forEach((predecessor) => {
      const edge = this.getEdge(predecessor, nodeId);
      if (!edge) {
        return;
      }
      this.removeEdge(edge);
    });
    successors.forEach((successor) => {
      const edge = this.getEdge(nodeId, successor);
      if (!edge) {
        return;
      }
      this.removeEdge(edge);
    });
    this.successors.delete(node.id);
    this.predecessors.delete(node.id);
    this.nodes.delete(node.id);
  }
  removeNodes(nodes) {
    nodes.forEach((node) => {
      this.removeNode(node);
    });
  }
  addEdge(edge) {
    if (!this.nodes.has(edge.from.id)) {
      this.addNode(edge.from);
    }
    if (!this.nodes.has(edge.to.id)) {
      this.addNode(edge.to);
    }
    const internalEdgeId = this.getEdgeIdentifier(edge.from.id, edge.to.id);
    const successors = this.successors.get(edge.from.id);
    const predecessors = this.predecessors.get(edge.to.id);
    const existingEdge = this.edges.get(internalEdgeId);
    if (existingEdge && existingEdge.id !== edge.id) {
      throw new MultipleDependenciesError(edge.from.id, edge.to.id);
    }
    successors.add(edge.to.id);
    predecessors.add(edge.from.id);
    this.edges.set(internalEdgeId, { id: edge.id, from: edge.from, to: edge.to });
    this.edgeIdDictionary.set(edge.id, internalEdgeId);
  }
  addEdges(edges) {
    edges.forEach((edge) => {
      this.addEdge(edge);
    });
  }
  removeEdge(edge) {
    if (typeof edge === "string") {
      const internalEdgeId2 = this.edgeIdDictionary.get(edge);
      if (!internalEdgeId2) {
        return;
      }
      const internalEdge = this.edges.get(internalEdgeId2);
      if (!internalEdge) {
        return;
      }
      edge = internalEdge;
    }
    const internalEdgeId = this.getEdgeIdentifier(edge.from.id, edge.to.id);
    if (!this.edges.has(internalEdgeId)) {
      return;
    }
    this.successors.get(edge.from.id)?.delete(edge.to.id);
    this.predecessors.get(edge.to.id)?.delete(edge.from.id);
    this.edges.delete(internalEdgeId);
    this.edgeIdDictionary.delete(edge.id);
  }
  removeEdges(edges) {
    edges.forEach((edge) => {
      this.removeEdge(typeof edge === "string" ? edge : edge.id);
    });
  }
  getNodes() {
    return Array.from(this.nodes.values());
  }
  getNode(id) {
    return this.nodes.get(id) ?? null;
  }
  getEdges() {
    return Array.from(this.edges.values());
  }
  getEdge(edgeIdOrFromId, toId) {
    if (!toId) {
      const internalEdgeId = this.edgeIdDictionary.get(edgeIdOrFromId) ?? "";
      return this.edges.get(internalEdgeId) ?? null;
    }
    return this.edges.get(this.getEdgeIdentifier(edgeIdOrFromId, toId)) ?? null;
  }
  /**
   * Returns the direct successors of a node.
   * @param nodeId
   */
  getSuccessors(nodeId) {
    return this.successors.get(nodeId) ?? /* @__PURE__ */ new Set();
  }
  /**
   * Returns the ids of the direct successors of a node.
   * @param nodeId
   * @returns
   */
  getSuccessorEdgeIds(nodeId) {
    return Array.from(this.getSuccessors(nodeId)).map(
      (successor) => this.getEdge(nodeId, successor).id
    );
  }
  /**
   * Returns all descendants (direct and indirect successors) of a node.
   * @param nodeIds
   * @param includeOwn Whether to include the nodes itself.
   * @returns
   */
  getDescendants(nodeIds, includeOwn = true) {
    const descendants = depthFirstSearch(nodeIds, (n) => this.getSuccessors(n));
    if (!includeOwn) {
      nodeIds.forEach((nodeId) => {
        descendants.delete(nodeId);
      });
    }
    return descendants;
  }
  /**
   * Returns the direct predecessors of a node.
   * @param nodeId
   */
  getPredecessors(nodeId) {
    return this.predecessors.get(nodeId) ?? /* @__PURE__ */ new Set();
  }
  /**
   * Returns the ids of the direct predecessors of a node.
   * @param nodeId
   */
  getPredecessorEdgeIds(nodeId) {
    return Array.from(this.getPredecessors(nodeId)).map(
      (predecessor) => this.getEdge(predecessor, nodeId).id
    );
  }
  /**
   * Returns all ancestors (direct and indirect predecessors) of a node.
   * @param nodeIds
   * @param includeOwn Whether to include the nodes itself.
   * @returns
   */
  getAncestors(nodeIds, includeOwn = true) {
    const ancestors = depthFirstSearch(nodeIds, (n) => this.getPredecessors(n));
    if (!includeOwn) {
      nodeIds.forEach((nodeId) => {
        ancestors.delete(nodeId);
      });
    }
    return ancestors;
  }
  /**
   * Returns the edges that are incident to the given nodes.
   * @param nodeIds
   * @param intersectionOnly Specify when only edges between the given nodes should be considered.
   * @returns
   */
  getIncidentEdges(nodeIds, intersectionOnly = false) {
    const edges = /* @__PURE__ */ new Set();
    const nodeSet = new Set(typeof nodeIds !== "string" ? nodeIds : [nodeIds]);
    nodeSet.forEach((nodeId) => {
      this.getPredecessors(nodeId).forEach((predecessor) => {
        if (!intersectionOnly || nodeSet.has(predecessor)) {
          edges.add(this.getEdge(predecessor, nodeId));
        }
      });
      this.getSuccessors(nodeId).forEach((successor) => {
        if (!intersectionOnly || nodeSet.has(successor)) {
          edges.add(this.getEdge(nodeId, successor));
        }
      });
    });
    return Array.from(edges);
  }
  /**
   * Returns an array of node IDs that have no predecessors (i.e. sources).
   */
  getSourceNodes() {
    return Array.from(this.predecessors).filter(([, predSet]) => predSet.size === 0).map(([nodeId]) => nodeId);
  }
  /**
   * Returns an array of node IDs that have no successors (i.e. sinks).
   */
  getSinkNodes() {
    return Array.from(this.successors).filter(([, succSet]) => succSet.size === 0).map(([nodeId]) => nodeId);
  }
  /**
   * Returns the topological order of the graph, starting from the given nodes.
   * If no nodes are provided, the order will be calculated for all nodes.
   * Throws an error if the graph contains a cycle.
   * @param nodeIds
   * @returns
   */
  getTopologicalOrder(nodeIds = new Set(this.nodes.keys())) {
    const order = [];
    const queue = [];
    const remainingInDegree = /* @__PURE__ */ new Map();
    const nodes = new Set(nodeIds);
    nodes.forEach((nodeId) => {
      if (!this.nodes.has(nodeId)) {
        throw new EntityNotFoundError("node", nodeId);
      }
      const predecessors = this.getPredecessors(nodeId);
      const inDegree = this.nodes.size > nodes.size ? intersection(predecessors, nodes).size : predecessors.size;
      remainingInDegree.set(nodeId, inDegree);
      if (inDegree === 0) {
        queue.push(nodeId);
      }
    });
    while (queue.length > 0) {
      const nodeId = queue.shift();
      order.push(nodeId);
      this.getSuccessors(nodeId).forEach((successor) => {
        if (!nodes.has(successor)) {
          return;
        }
        const previousInDegree = remainingInDegree.get(successor);
        if (previousInDegree === void 0) {
          throw new EntityNotFoundError("node", successor);
        }
        const count = previousInDegree - 1;
        remainingInDegree.set(successor, count);
        if (count === 0) {
          queue.push(successor);
        }
      });
    }
    if (order.length !== nodes.size) {
      throw new DependencyCycleError(this.findCycle());
    }
    return order;
  }
  hasCycle() {
    return this.findCycle() !== null;
  }
  /**
   * Patches the graph with the given changes.
   * @param nodeChanges
   * @param dependencyChanges
   * @returns
   */
  patch(nodeChanges, dependencyChanges) {
    if (nodeChanges.added) {
      this.addNodes(nodeChanges.added);
    }
    if (nodeChanges.deleted) {
      this.removeNodes(nodeChanges.deleted);
    }
    if (dependencyChanges.added) {
      this.addEdges(dependencyChanges.added);
    }
    if (dependencyChanges.deleted) {
      this.removeEdges(dependencyChanges.deleted);
    }
    return this;
  }
  findCycle() {
    let cycle = null;
    this.nodes.forEach((node) => {
      if (cycle) {
        return;
      }
      depthFirstSearch(
        [node.id],
        (nodeId) => this.getSuccessors(nodeId),
        (nodeId, path) => {
          if (path.has(nodeId)) {
            cycle = [...Array.from(path), nodeId];
            return false;
          }
          return true;
        }
      );
    });
    return cycle;
  }
  getEdgeIdentifier(fromId, toId) {
    return `edge-${fromId}-${toId}`;
  }
  /**
   * Creates a copy of the graph with the same state.
   * @returns
   */
  copy() {
    const copy = new _DependencyGraph(
      Array.from(this.nodes.values()),
      Array.from(this.edges.values())
    );
    return copy;
  }
};

// node_modules/@date-fns/utc/date/mini.js
var UTCDateMini = class extends Date {
  constructor() {
    super();
    this.setTime(arguments.length === 0 ? (
      // Enables Sinon's fake timers that override the constructor
      Date.now()
    ) : arguments.length === 1 ? typeof arguments[0] === "string" ? +new Date(arguments[0]) : arguments[0] : Date.UTC(...arguments));
  }
  getTimezoneOffset() {
    return 0;
  }
};
var re = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((method) => {
  if (re.test(method)) {
    const utcMethod = Date.prototype[method.replace(re, "$1UTC")];
    if (utcMethod) UTCDateMini.prototype[method] = utcMethod;
  }
});

// node_modules/@date-fns/utc/date/index.js
var UTCDate = class extends UTCDateMini {
  toString() {
    const date = this.toDateString();
    const time = this.toTimeString();
    return `${date} ${time}`;
  }
  toDateString() {
    const weekday = weekdayFormat.format(this);
    const date = dateFormat.format(this);
    const year = this.getFullYear();
    return `${weekday} ${date} ${year}`;
  }
  toTimeString() {
    const time = timeFormat.format(this);
    return `${time} GMT+0000 (Coordinated Universal Time)`;
  }
  toLocaleString(locales, options) {
    return Date.prototype.toLocaleString.call(this, locales, {
      timeZone: "UTC",
      ...options
    });
  }
  toLocaleDateString(locales, options) {
    return Date.prototype.toLocaleDateString.call(this, locales, {
      timeZone: "UTC",
      ...options
    });
  }
  toLocaleTimeString(locales, options) {
    return Date.prototype.toLocaleTimeString.call(this, locales, {
      timeZone: "UTC",
      ...options
    });
  }
};
var weekdayFormat = new Intl.DateTimeFormat("en-US", {
  weekday: "short",
  timeZone: "UTC"
});
var dateFormat = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  timeZone: "UTC"
});
var timeFormat = new Intl.DateTimeFormat("en-GB", {
  hour12: false,
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  timeZone: "UTC"
});

// src/common/tests/generation.ts
var import_lodash = __toESM(require_lodash());

// src/common/utils/dates.ts
var START_OF_WEEK = 1;
function getWeekDay(date) {
  return (date.getDay() + 7 - START_OF_WEEK) % 7;
}
function getDaysWithinInterval(from, to) {
  const days = [];
  let startDate = from;
  const endDate = to;
  while (isBefore(startDate, endDate)) {
    days.push(startDate);
    startDate = addDays(startDate, 1);
  }
  return days;
}
function buildDateFromWeekday(date, weekday, {
  timeString = "00:00",
  pushStartOfDay = false,
  pushForward = true
} = {}) {
  const newDate = buildDateFromTimeString(date, timeString, { pushStartOfDay });
  const [hours, minutes] = timeString.split(":").map(Number);
  if (pushForward) {
    let daysToAdd = (weekday - getWeekDay(newDate) + 7) % 7;
    if (daysToAdd === 0 && (date.getHours() > hours || date.getHours() === hours && date.getMinutes() > minutes)) {
      daysToAdd = 7;
    }
    return addDays(newDate, daysToAdd);
  }
  let daysToSubtract = (getWeekDay(newDate) - weekday + 7) % 7;
  if (daysToSubtract === 0 && (date.getHours() < hours || date.getHours() === hours && date.getMinutes() < minutes)) {
    daysToSubtract = 7;
  }
  return subDays(newDate, daysToSubtract);
}
function formatTimeString(timeString) {
  return timeString.split(":").slice(0, 2).join(":");
}
function buildDateFromTimeString(date, timeString, { pushStartOfDay = false } = {}) {
  let newDate = new UTCDate(date);
  const timeStringParts = timeString.split(":");
  if (timeStringParts.length < 2) {
    throw new InvalidDateTimeFormatError(timeString);
  }
  const hours = parseInt(timeStringParts[0], 10);
  const minutes = parseInt(timeStringParts[1], 10);
  if (Number.isNaN(hours) || hours < 0 || hours > 23) {
    throw new InvalidDateTimeFormatError(timeString);
  }
  if (Number.isNaN(minutes) || minutes < 0 || minutes > 59) {
    throw new InvalidDateTimeFormatError(timeString);
  }
  newDate.setHours(hours);
  newDate.setMinutes(minutes);
  newDate.setSeconds(0);
  newDate.setMilliseconds(0);
  if (pushStartOfDay && hours === 0 && minutes === 0) {
    newDate = addDays(newDate, 1);
  }
  return newDate;
}
function getTimeString(date) {
  return `${date.getHours().toString()}:${date.getMinutes().toString()}`;
}
function isBefore(dateA, dateB) {
  return dateA.getTime() < dateB.getTime();
}
function isAfter(dateA, dateB) {
  return dateA.getTime() > dateB.getTime();
}
function isEqual(dateA, dateB) {
  return dateA.getTime() === dateB.getTime();
}
function differenceInMinutes(dateA, dateB) {
  return (dateA.getTime() - dateB.getTime()) / 6e4;
}
function isWithinInterval(date, interval) {
  return date.getTime() >= interval.start.getTime() && date.getTime() <= interval.end.getTime();
}
function addDays(date, days) {
  return new UTCDate(date.getTime() + days * 24 * 60 * 60 * 1e3);
}
function addMinutes(date, minutes) {
  return new UTCDate(date.getTime() + minutes * 60 * 1e3);
}
function subDays(date, days) {
  return new UTCDate(date.getTime() - days * 24 * 60 * 60 * 1e3);
}
function subMinutes(date, minutes) {
  return new UTCDate(date.getTime() - minutes * 60 * 1e3);
}
function subSeconds(date, seconds) {
  return new UTCDate(date.getTime() - seconds * 1e3);
}
function startOfDay(date) {
  const newDate = new UTCDate(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
}
function endOfDay(date) {
  const newDate = new UTCDate(date);
  newDate.setHours(23, 59, 59, 999);
  return newDate;
}
function max(dates) {
  return new UTCDate(Math.max(...dates.map((date) => date.getTime())));
}
function min(dates) {
  return new UTCDate(Math.min(...dates.map((date) => date.getTime())));
}

// src/common/tests/generation.ts
function generateDuration(days, hours = 0, minutes = 0) {
  return days * 1440 + hours * 60 + minutes;
}

// src/common/utils/arrays.ts
function patchArray(array, {
  added,
  updated,
  deleted
}) {
  const patchedArray = [];
  array.forEach((item) => {
    if (deleted?.has(item.id)) {
      return;
    }
    if (updated?.has(item.id)) {
      patchedArray.push({ ...item, ...updated.get(item.id) });
      return;
    }
    patchedArray.push(item);
  });
  added?.forEach((item) => {
    patchedArray.push(item);
  });
  return patchedArray;
}
function mergeArrays(array1, array2, key = "id") {
  const mergedArray = [...array1];
  const array1Map = new Map(array1.map((item) => [item[key], item]));
  const array1IndicesMap = new Map(array1.map((item, index) => [item[key], index]));
  array2.forEach((item) => {
    const index = array1IndicesMap.get(item[key]);
    if (index === void 0) {
      mergedArray.push(item);
      return;
    }
    mergedArray[index] = { ...array1Map.get(item[key]), ...item };
  });
  return mergedArray;
}

// src/common/utils/objects.ts
var import_lodash2 = __toESM(require_lodash());
function omitKeys(raw, keys) {
  if (keys.length === 0) return raw;
  return Object.keys(raw).filter((key) => !keys.includes(key)).reduce((obj, key) => {
    obj[key] = raw[key];
    return obj;
  }, {});
}
function pickKeys(raw, allowed) {
  if (allowed.length === 0) return raw;
  return Object.keys(raw).filter((key) => allowed.includes(key)).reduce((obj, key) => {
    obj[key] = raw[key];
    return obj;
  }, {});
}
function omitUndefinedKeys(raw) {
  return omitKeys(
    raw,
    Object.keys(raw).filter((key) => raw[key] === void 0)
  );
}
function findDivergingKeys(a, b) {
  return Object.keys(a).filter(
    (key) => !(0, import_lodash2.isEqual)(a[key], b[key])
  );
}

// src/core/utils/store.ts
var ObjectStore = class {
  constructor(state, ...params) {
    this.state = state;
  }
  added = /* @__PURE__ */ new Map();
  updated = /* @__PURE__ */ new Map();
  deleted = /* @__PURE__ */ new Map();
  /**
   * Returns the latest state of an object, including uncommitted changes.
   * @param id
   * @returns
   * @throws EntityNotFoundError - ff the object has been deleted or was not found in the state map
   */
  getLatestById(id) {
    if (this.added.has(id)) {
      return this.added.get(id);
    }
    if (this.updated.has(id)) {
      const object2 = this.state.get(id);
      if (!object2) {
        throw new EntityNotFoundError(this.objectName, id);
      }
      return {
        ...object2,
        ...this.updated.get(id)
      };
    }
    if (this.deleted.has(id)) {
      throw new EntityNotFoundError(this.objectName, id);
    }
    const object = this.state.get(id);
    if (!object) {
      throw new EntityNotFoundError(this.objectName, id);
    }
    return object;
  }
  /**
   * Returns the archived state of an object, not including uncommitted changes.
   * @param id
   * @returns
   */
  getArchivedById(id) {
    return this.state.get(id);
  }
  /**
   * Updates the latest state of an object by setting the uncommitted changes.
   * @param id
   * @returns
   */
  setLatest(object) {
    if (this.added.has(object.id)) {
      this.added.set(object.id, {
        ...this.added.get(object.id) ?? {},
        ...object
      });
    } else {
      this.updated.set(object.id, {
        ...this.updated.get(object.id) ?? { id: object.id },
        ...object
      });
    }
  }
  hasChanges(id) {
    return this.added.has(id) || this.updated.has(id);
  }
  getAdded() {
    return this.added;
  }
  getUpdated() {
    return this.updated;
  }
  getDeleted() {
    return this.deleted;
  }
  getState() {
    return this.state;
  }
  getChanged() {
    const added = Array.from(this.added.keys());
    const updated = Array.from(this.updated.keys());
    return [...added, ...updated].map((id) => this.getLatestById(id));
  }
  /**
   * Returns all ids of the objects in the store, including the uncommitted changes.
   * @returns
   */
  getAllIds() {
    const allIdsSet = /* @__PURE__ */ new Set();
    this.state.forEach((_, id) => {
      allIdsSet.add(id);
    });
    const added = Array.from(this.added.keys());
    const updated = Array.from(this.updated.keys());
    const deleted = Array.from(this.deleted.keys());
    added.forEach((id) => {
      allIdsSet.add(id);
    });
    updated.forEach((id) => {
      allIdsSet.add(id);
    });
    deleted.forEach((id) => {
      allIdsSet.delete(id);
    });
    return Array.from(allIdsSet);
  }
  /**
   * Updates the store with the provided changes. The changes will be stored in separate maps until they are committed.
   * Any existing uncommitted changes will be overwritten.
   * @param changes
   * @returns
   */
  patch({
    added,
    updated,
    deleted
  } = {}) {
    this.reset();
    added?.forEach((object) => {
      this.added.set(object.id, object);
    });
    updated?.forEach((object) => {
      this.updated.set(object.id, object);
    });
    deleted?.forEach((object) => {
      this.deleted.set(object.id, object);
    });
    return this;
  }
  /**
   * Commits the current changes to the state map and resets the store.
   */
  commit() {
    this.added.forEach((value, id) => {
      this.state.set(id, value);
    });
    this.updated.forEach((value, id) => {
      this.state.set(id, {
        ...this.state.get(id) ?? {},
        ...value
      });
    });
    this.deleted.forEach((_, id) => {
      this.state.delete(id);
    });
    this.clear();
  }
  /**
   * Resets the store to original state, potentially reverting changes.
   */
  reset() {
    this.clear();
  }
  /**
   * Clears uncommitted state, changes or any other temporary data
   */
  clear() {
    this.added.clear();
    this.updated.clear();
    this.deleted.clear();
  }
  /**
   * Creates a copy of the store with the same state and changes.
   * @param constructorParams
   * @returns
   */
  copy(...constructorParams) {
    const copy = new this.constructor(new Map(this.state), ...constructorParams);
    copy.added = new Map(this.added);
    copy.updated = new Map(this.updated);
    copy.deleted = new Map(this.deleted);
    return copy;
  }
};

// src/core/utils/cache.ts
var Cache = class {
  constructor(disabled = false) {
    this.disabled = disabled;
  }
  cache = /* @__PURE__ */ new Map();
  toRawKey(key) {
    return key;
  }
  fromRawKey(key) {
    return key;
  }
  toRawValue(value) {
    return value;
  }
  fromRawValue(value) {
    return value;
  }
  read(key) {
    if (this.disabled) return void 0;
    const rawKey = this.toRawKey(key);
    const rawValue = this.cache.get(rawKey);
    return rawValue ? this.fromRawValue(rawValue) : void 0;
  }
  write(key, value) {
    if (this.disabled) return value;
    const rawKey = this.toRawKey(key);
    const rawValue = this.toRawValue(value);
    this.cache.set(rawKey, rawValue);
    return value;
  }
  purge() {
    this.cache.clear();
  }
  copy() {
    const copy = new this.constructor(this.disabled);
    copy.cache = new Map(this.cache);
    return copy;
  }
  getCache() {
    return this.cache;
  }
  getCacheEntryString(rawKey) {
    const rawValue = this.cache.get(rawKey);
    if (rawValue === void 0) return "";
    return `${this.fromRawKey(rawKey)} => ${this.fromRawValue(rawValue)}`;
  }
  log() {
    const logString = Array.from(this.cache.entries()).reduce(
      (acc, [rawKey]) => `${acc}
${this.getCacheEntryString(rawKey)}`,
      ""
    );
    console.log(logString);
  }
};
var DateCache = class extends Cache {
  toRawKey(key) {
    return key.getTime();
  }
  fromRawKey(key) {
    return new UTCDate(key);
  }
};
var DateDurationCache = class extends Cache {
  toRawKey({ date, duration }) {
    return `${date.getTime().toString()}#${duration.toString()}`;
  }
  fromRawKey(key) {
    const [date, duration] = key.split("#");
    return { date: new UTCDate(parseInt(date, 10)), duration: parseInt(duration, 10) };
  }
};
var DurationCache = class extends Cache {
  toRawKey({ start, end }) {
    return `${start.getTime().toString()}#${end.getTime().toString()}`;
  }
  fromRawKey(key) {
    const [start, end] = key.split("#");
    return { start: new UTCDate(parseInt(start, 10)), end: new UTCDate(parseInt(end, 10)) };
  }
};
var DateBooleanCache = class extends Cache {
  toRawKey(key) {
    return key.getTime();
  }
  fromRawKey(key) {
    return new UTCDate(key);
  }
};

// src/core/calendars/calendarInterval.ts
var DateIntervalListCache = class extends Cache {
  toRawKey(key) {
    return key.getTime();
  }
  fromRawKey(key) {
    return new UTCDate(key);
  }
};
var CalendarInterval = class _CalendarInterval {
  constructor(weekday, from, to, cache = false, prev = "", next = "", exceptions = []) {
    this.weekday = weekday;
    this.from = from;
    this.to = to;
    this.cache = cache;
    this.prev = prev;
    this.next = next;
    this.exceptions = exceptions;
    this.id = this.generateId();
    this.memoizationCache = {
      getAllDateIntervals: new DateIntervalListCache(!cache),
      getDateIntervalDuration: new DurationCache(!cache),
      isAtStartOfInterval: new DateBooleanCache(!cache),
      isAtEndOfInterval: new DateBooleanCache(!cache)
    };
  }
  id;
  memoizationCache;
  /**
   * Map of a specific day (timestamp of day start) and all exceptions that are within this day.
   */
  dayToExceptionsDictionary = /* @__PURE__ */ new Map();
  /**
   * Returns the actual date intervals for the given date using the regular time of the calendar interval
   * minus non-working time exceptions and plus working time exceptions. Overlapping intervals are merged.
   * @param date
   * @returns
   */
  getAllDateIntervals(date) {
    const cache = this.memoizationCache.getAllDateIntervals;
    const cached = cache.read(date);
    if (cached) {
      return cached;
    }
    const { workingTimeExceptions, nonWorkingTimeExceptions } = this.findMatchingExceptions(date);
    if (!this.from || !this.to) {
      return cache.write(date, this.mergeIntervals(workingTimeExceptions));
    }
    const fromDate = buildDateFromTimeString(date, this.from);
    const toDate = buildDateFromTimeString(date, this.to, { pushStartOfDay: true });
    const regularIntervals = this.subtractIntervals(
      [{ from: fromDate, to: toDate }],
      nonWorkingTimeExceptions
    );
    return cache.write(date, this.mergeIntervals([...regularIntervals, ...workingTimeExceptions]));
  }
  /**
   * Returns the date interval that a given date overlaps with.
   * @param date
   * @returns
   */
  getMatchingDateInterval(date) {
    const dateIntervals = this.getAllDateIntervals(date);
    if (!dateIntervals.length) {
      return null;
    }
    for (let i = 0; i < dateIntervals.length; i++) {
      if (isWithinInterval(date, {
        start: dateIntervals[i].from,
        end: dateIntervals[i].to
      })) {
        return dateIntervals[i];
      }
    }
    return null;
  }
  /**
   * Returns the previous date interval of the interval that a given date overlaps with.
   * @param date
   * @returns
   */
  getPreviousDateInterval(date) {
    const dateIntervals = this.getAllDateIntervals(date);
    if (!dateIntervals.length) {
      return null;
    }
    for (let i = dateIntervals.length - 1; i >= 0; i--) {
      if (isAfter(date, dateIntervals[i].to)) {
        return dateIntervals[i];
      }
    }
    return null;
  }
  /**
   * Returns the next date interval of the interval that a given date overlaps with.
   * @param date
   * @returns
   */
  getNextDateInterval(date) {
    const dateIntervals = this.getAllDateIntervals(date);
    if (!dateIntervals.length) {
      return null;
    }
    for (let i = 0; i < dateIntervals.length; i++) {
      if (isBefore(date, dateIntervals[i].from)) {
        return dateIntervals[i];
      }
    }
    return null;
  }
  /**
   * Calculates the duration of a given date interval in minutes.
   * @param interval
   * @returns
   */
  getDateIntervalDuration(interval) {
    const cache = this.memoizationCache.getDateIntervalDuration;
    const cached = cache.read({
      start: interval.from,
      end: interval.to
    });
    if (cached) {
      return cached;
    }
    const duration = differenceInMinutes(interval.to, interval.from);
    return cache.write(
      {
        start: interval.from,
        end: interval.to
      },
      duration
    );
  }
  /**
   * Checks if a given date is at the start of an interval.
   * @param date
   * @returns
   */
  isAtStartOfInterval(date) {
    const cache = this.memoizationCache.isAtStartOfInterval;
    const cached = cache.read(date);
    if (cached) {
      return cached;
    }
    const dateIntervals = this.getAllDateIntervals(date);
    if (!dateIntervals.length) {
      return cache.write(date, true);
    }
    for (let i = dateIntervals.length - 1; i >= 0; i--) {
      if (isEqual(date, dateIntervals[i].from)) {
        return cache.write(date, true);
      }
      const isInBetweenCurrentAndNextInterval = isAfter(date, dateIntervals[i].to) && (i < dateIntervals.length - 1 ? isBefore(date, dateIntervals[i + 1].from) : true);
      if (isInBetweenCurrentAndNextInterval) {
        return cache.write(date, true);
      }
      const isBeforeFirstInterval = i === 0 && isBefore(date, dateIntervals[i].from);
      if (isBeforeFirstInterval) {
        return cache.write(date, true);
      }
    }
    return cache.write(date, false);
  }
  /**
   * Checks if a given date is at the end of an interval.
   * @param date
   * @returns
   */
  isAtEndOfInterval(date) {
    const cache = this.memoizationCache.isAtEndOfInterval;
    const cached = cache.read(date);
    if (cached) {
      return cached;
    }
    const dateIntervals = this.getAllDateIntervals(date);
    if (!dateIntervals.length) {
      return cache.write(date, true);
    }
    for (let i = dateIntervals.length - 1; i >= 0; i--) {
      if (isEqual(date, dateIntervals[i].to)) {
        return cache.write(date, true);
      }
      const isInBetweenCurrentAndNextInterval = isAfter(date, dateIntervals[i].to) && (i < dateIntervals.length - 1 ? isBefore(date, dateIntervals[i + 1].from) : true);
      if (isInBetweenCurrentAndNextInterval) {
        return cache.write(date, true);
      }
      const isBeforeFirstInterval = i === 0 && isBefore(date, dateIntervals[i].from);
      if (isBeforeFirstInterval) {
        return cache.write(date, true);
      }
    }
    return cache.write(
      date,
      dateIntervals.some((interval) => isEqual(date, interval.to))
    );
  }
  setExceptions(exceptions) {
    this.exceptions = this.sortIntervals(exceptions);
    this.dayToExceptionsDictionary.clear();
    exceptions.forEach((exception) => {
      const dayStart = startOfDay(exception.from).getTime();
      const dayExceptions = this.dayToExceptionsDictionary.get(dayStart) ?? [];
      dayExceptions.push(exception);
      this.dayToExceptionsDictionary.set(dayStart, dayExceptions);
    });
  }
  /**
   * Merges a given list of intervals.
   * For example:
   * ```ts
   * mergeIntervals([{ from: 0, to: 8 }, { from: 6, to: 12 }, { from: 16, to: 18 }])
   * // => [{ from: 0, to: 12 }, { from: 16, to: 18 }]
   * ```
   * @param intervals
   * @returns
   */
  mergeIntervals(intervals) {
    const mergedIntervals = [];
    this.sortIntervals(intervals).forEach((interval) => {
      if (mergedIntervals.length === 0 || isBefore(mergedIntervals[mergedIntervals.length - 1].to, interval.from)) {
        mergedIntervals.push({ from: interval.from, to: interval.to });
      } else {
        mergedIntervals[mergedIntervals.length - 1].to = max([
          mergedIntervals[mergedIntervals.length - 1].to,
          interval.to
        ]);
      }
    });
    return mergedIntervals;
  }
  /**
   * Subtracts a given list of intervals from another list of intervals.
   * For example:
   * ```ts
   * subtractIntervals([{ from: 0, to: 10 }], [{ from: 2, to: 4 }, { from: 6, to: 8 }])
   * // => [{ from: 0, to: 2 }, { from: 4, to: 6 }, { from: 8, to: 10 }]
   * ```
   * @param intervals
   * @param intervalsToSubtract
   * @returns
   */
  subtractIntervals(intervals, intervalsToSubtract) {
    let result = intervals;
    intervalsToSubtract.forEach((intervalToSubtract) => {
      result = result.flatMap((currentInterval) => {
        const noOverlap = intervalToSubtract.to <= currentInterval.from || intervalToSubtract.from >= currentInterval.to;
        if (noOverlap) {
          return [currentInterval];
        }
        const overlapAtTheStart = intervalToSubtract.from <= currentInterval.from && intervalToSubtract.to < currentInterval.to;
        if (overlapAtTheStart) {
          return [{ from: intervalToSubtract.to, to: currentInterval.to }];
        }
        const overlapAtTheEnd = intervalToSubtract.from > currentInterval.from && intervalToSubtract.to >= currentInterval.to;
        if (overlapAtTheEnd) {
          return [{ from: currentInterval.from, to: intervalToSubtract.from }];
        }
        const overlapInTheMiddle = intervalToSubtract.from > currentInterval.from && intervalToSubtract.to < currentInterval.to;
        if (overlapInTheMiddle) {
          return [
            { from: currentInterval.from, to: intervalToSubtract.from },
            { from: intervalToSubtract.to, to: currentInterval.to }
          ];
        }
        return [];
      });
    });
    return result;
  }
  /**
   * Sorts a given list of intervals by the start date in ascending order.
   * @param intervals
   * @returns
   */
  sortIntervals(intervals) {
    return [...intervals].sort((a, b) => a.from < b.from ? -1 : 1);
  }
  /**
   * Returns all exceptions that match the given date, separated into working time exceptions and non-working time exceptions.
   * @param date
   * @returns
   */
  findMatchingExceptions(date) {
    const workingTimeExceptions = [];
    const nonWorkingTimeExceptions = [];
    const dayStart = startOfDay(date).getTime();
    const exceptions = this.dayToExceptionsDictionary.get(dayStart) ?? [];
    const searchFn = (d, exception) => {
      if (isBefore(d, startOfDay(exception.from))) {
        return -1;
      }
      if (isAfter(d, endOfDay(exception.to))) {
        return 1;
      }
      return 0;
    };
    const middleIdx = binarySearch(exceptions, date, searchFn);
    if (middleIdx === -1) {
      return { workingTimeExceptions, nonWorkingTimeExceptions };
    }
    const leftSide = exceptions.slice(0, middleIdx);
    let leftMostIdx = middleIdx;
    for (let i = leftSide.length - 1; i >= 0; i--) {
      if (searchFn(date, leftSide[i]) !== 0) {
        break;
      }
      leftMostIdx--;
    }
    const rightSide = exceptions.slice(middleIdx);
    let rightMostIdx = middleIdx;
    for (let i = 0; i < rightSide.length; i++) {
      if (searchFn(date, rightSide[i]) !== 0) {
        break;
      }
      rightMostIdx++;
    }
    const relevantExceptions = exceptions.slice(leftMostIdx, rightMostIdx + 1);
    relevantExceptions.forEach((exception) => {
      if (exception.isWorking) {
        workingTimeExceptions.push(exception);
      } else {
        nonWorkingTimeExceptions.push(exception);
      }
    });
    return { workingTimeExceptions, nonWorkingTimeExceptions };
  }
  generateId() {
    return `calendar-interval-${this.weekday.toString()}-${this.from ?? ""}-${this.to ?? ""}`;
  }
  /**
   * Creates a copy of the interval with the same state.
   * @returns
   */
  copy() {
    const copy = new _CalendarInterval(
      this.weekday,
      this.from,
      this.to,
      this.cache,
      this.prev,
      this.next
    );
    copy.exceptions = [...this.exceptions];
    copy.dayToExceptionsDictionary = new Map(this.dayToExceptionsDictionary);
    Object.entries(this.memoizationCache).forEach(
      ([key, cache]) => {
        copy.memoizationCache[key] = cache.copy();
      }
    );
    return copy;
  }
};

// src/core/calendars/utils.ts
function calendarToIntervals(calendar, cache) {
  const intervals = /* @__PURE__ */ new Map();
  const intervalIds = [];
  const weekDayIntervalDictionary = {};
  const addInterval = (interval) => {
    intervals.set(interval.id, interval);
    intervalIds.push(interval.id);
    if (!(interval.weekday in weekDayIntervalDictionary)) {
      weekDayIntervalDictionary[interval.weekday] = [];
    }
    weekDayIntervalDictionary[interval.weekday].push(interval.id);
  };
  if (!calendar.workingDays.length) {
    throw new NoWorkingTimeAvailableError(calendar.id);
  }
  fillMissingWorkingDays(calendar.workingDays).forEach((workingDay) => {
    if (!workingDay.workingTimes.length) {
      const interval = new CalendarInterval(workingDay.weekday, void 0, void 0, cache);
      addInterval(interval);
    } else {
      workingDay.workingTimes.sort((a, b) => a.from < b.from ? -1 : 1).forEach((workingTime) => {
        const interval = new CalendarInterval(
          workingDay.weekday,
          formatTimeString(workingTime.from),
          formatTimeString(workingTime.to),
          cache
        );
        addInterval(interval);
      });
    }
  });
  intervalIds.forEach((id, index) => {
    const interval = intervals.get(id);
    if (!interval) {
      return;
    }
    const link = createDoubleLink(index, intervalIds);
    interval.prev = link.prev;
    interval.next = link.next;
  });
  const intervalExceptionsDictionary = assignExceptionsToRelevantIntervals(
    intervals,
    calendar.exceptions,
    weekDayIntervalDictionary
  );
  intervals.forEach((interval) => {
    interval.setExceptions(intervalExceptionsDictionary[interval.id] ?? []);
  });
  return { intervals, weekDayIntervalDictionary };
}
function createDoubleLink(index, intervalIds) {
  return {
    prev: index > 0 ? intervalIds[index - 1] : intervalIds[intervalIds.length - 1],
    next: index < intervalIds.length - 1 ? intervalIds[index + 1] : intervalIds[0]
  };
}
function assignExceptionsToRelevantIntervals(intervals, exceptions, weekdayDictionary) {
  const exceptionsDictionary = {};
  exceptions.forEach((exception) => {
    exception.workingTimes.forEach((workingTime) => {
      const exceptionStart = buildDateFromTimeString(
        exception.startAt,
        formatTimeString(workingTime.from)
      );
      const exceptionEnd = buildDateFromTimeString(
        exception.finishAt,
        formatTimeString(workingTime.to)
      );
      const intermediateDays = getDaysWithinInterval(exceptionStart, exceptionEnd);
      intermediateDays.forEach((date, idx) => {
        const weekday = getWeekDay(date);
        const affectedIntervals = weekdayDictionary[weekday].map(
          (intervalId) => intervals.get(intervalId)
        );
        affectedIntervals.forEach((interval) => {
          if (!(interval.id in exceptionsDictionary)) {
            exceptionsDictionary[interval.id] = [];
          }
          exceptionsDictionary[interval.id].push({
            from: date,
            to: idx + 1 < intermediateDays.length ? intermediateDays[idx + 1] : exceptionEnd,
            isWorking: exception.isWorkingDay
          });
        });
      });
    });
  });
  return exceptionsDictionary;
}
function fillMissingWorkingDays(workingDays) {
  const weekdays = [];
  Array.from({ length: 7 }, (_, i) => i).forEach((weekday) => {
    const workingDay = workingDays.find((wd) => wd.weekday === weekday);
    if (workingDay) {
      weekdays.push(workingDay);
    } else {
      weekdays.push({ weekday, workingTimes: [] });
    }
  });
  return weekdays;
}

// src/core/calendars/calendarManager.ts
var CalendarManager = class _CalendarManager {
  constructor(calendar, cache = true, precomputedIntervals) {
    this.calendar = calendar;
    this.cache = cache;
    this.id = calendar.id;
    this.cache = cache;
    this.memoizationCache = {
      getNextValidDate: new DateCache(!cache),
      getPreviousValidDate: new DateCache(!cache),
      getNextDateRegardless: new DateCache(!cache),
      getPreviousDateRegardless: new DateCache(!cache),
      getWorkingTimeBetween: new DurationCache(!cache),
      addWorkingTime: new DateDurationCache(!cache),
      subtractWorkingTime: new DateDurationCache(!cache)
    };
    if (precomputedIntervals) {
      this.intervals = precomputedIntervals.intervals;
      this.weekDayIntervalDictionary = precomputedIntervals.weekDayIntervalDictionary;
      return;
    }
    const computed = calendarToIntervals(calendar, cache);
    this.intervals = computed.intervals;
    this.weekDayIntervalDictionary = computed.weekDayIntervalDictionary;
  }
  id;
  memoizationCache;
  intervals = /* @__PURE__ */ new Map();
  /** Dictionary of weekday to interval ids */
  weekDayIntervalDictionary = {};
  /**
   * Returns the next valid date according to the calendar definition.
   * If the given date is a valid date, it will return the same date.
   * @param date
   * @param exclusive If set to true, the returned date will be the start of the next interval in case the given date is at the end of an interval.
   * @returns
   */
  getNextValidDate(date, exclusive = false) {
    if (exclusive) {
      const isAtEndOfInterval = this.getCalendarIntervalFromDate(date).isAtEndOfInterval(date);
      if (isAtEndOfInterval) {
        const nextDate2 = this.getNextValidDate(this.getNextDateRegardless(date));
        return this.getCalendarIntervalFromDate(nextDate2).getMatchingDateInterval(nextDate2).from;
      }
    }
    const cache = this.memoizationCache.getNextValidDate;
    const cached = cache.read(date);
    if (cached) {
      return cached;
    }
    const calendarInterval = this.getCalendarIntervalFromDate(date);
    const dateIntervals = calendarInterval.getAllDateIntervals(date);
    for (let i = 0; i < dateIntervals.length; i++) {
      if (isBefore(date, dateIntervals[i].from)) {
        return cache.write(date, dateIntervals[i].from);
      }
      if (isWithinInterval(date, {
        start: dateIntervals[i].from,
        end: dateIntervals[i].to
      })) {
        return cache.write(date, date);
      }
    }
    const nextDate = this.getNextDateRegardless(date);
    if (isEqual(nextDate, date)) {
      throw new InfiniteLoopInCalendarError(nextDate, this.id);
    }
    return cache.write(date, this.getNextValidDate(nextDate));
  }
  /**
   * Returns the previous valid date according to the calendar definition.
   * If the given date is a valid date, it will return the same date.
   * @param date
   * @param exclusive If set to true, the returned date will be the end of the previous interval in case the given date is at the start of an interval.
   * @returns
   */
  getPreviousValidDate(date, exclusive = false) {
    if (exclusive) {
      const isAtStartOfInterval = this.getCalendarIntervalFromDate(date).isAtStartOfInterval(date);
      if (isAtStartOfInterval) {
        const previousDate2 = this.getPreviousValidDate(this.getPreviousDateRegardless(date));
        return this.getCalendarIntervalFromDate(previousDate2).getMatchingDateInterval(previousDate2).to;
      }
    }
    const cache = this.memoizationCache.getPreviousValidDate;
    const cached = cache.read(date);
    if (cached) {
      return cached;
    }
    const calendarInterval = this.getCalendarIntervalFromDate(date);
    const dateIntervals = calendarInterval.getAllDateIntervals(date);
    for (let i = dateIntervals.length - 1; i >= 0; i--) {
      if (isAfter(date, dateIntervals[i].to)) {
        return cache.write(date, dateIntervals[i].to);
      }
      if (isWithinInterval(date, {
        start: dateIntervals[i].from,
        end: dateIntervals[i].to
      })) {
        return cache.write(date, date);
      }
    }
    const previousDate = this.getPreviousDateRegardless(date);
    if (isEqual(previousDate, date)) {
      throw new InfiniteLoopInCalendarError(previousDate, this.id);
    }
    return cache.write(date, this.getPreviousValidDate(previousDate));
  }
  /**
   * Calculates the working time between two dates according to the calendar definition.
   * The result will be negative if the start date is after the end date.
   * @param start
   * @param end
   * @returns
   */
  getWorkingTimeBetween(start, end) {
    const startDate = min([start, end]);
    const endDate = max([start, end]);
    const date = this.getNextValidDate(startDate);
    const cache = this.memoizationCache.getWorkingTimeBetween;
    const cached = cache.read({ start, end });
    if (cached) {
      return cached;
    }
    if (!isBefore(date, endDate)) {
      return cache.write({ start, end }, 0);
    }
    const calendarInterval = this.getCalendarIntervalFromDate(date);
    const dateIntervals = calendarInterval.getAllDateIntervals(date);
    let lastIntervalEnd;
    const workingTime = dateIntervals.reduce((acc, interval) => {
      const intervalStart = max([interval.from, date]);
      const intervalEnd = min([interval.to, endDate]);
      lastIntervalEnd = intervalEnd;
      const duration = calendarInterval.getDateIntervalDuration({
        from: intervalStart,
        to: intervalEnd
      });
      return acc + duration;
    }, 0) * (isBefore(start, end) ? -1 : 1);
    if (lastIntervalEnd && isEqual(lastIntervalEnd, endDate)) {
      return cache.write({ start, end }, workingTime);
    }
    const nextDate = this.getNextDateRegardless(date);
    if (isEqual(nextDate, date)) {
      throw new InfiniteLoopInCalendarError(nextDate, this.id);
    }
    const nextArgs = isBefore(start, end) ? [nextDate, endDate] : [endDate, nextDate];
    return cache.write(
      { start, end },
      workingTime + this.getWorkingTimeBetween(nextArgs[0], nextArgs[1])
    );
  }
  /**
   * Adds working time to a date according to the calendar definition.
   * Subtracts working time if the given duration is negative.
   * It will always return a date of the first valid interval. In order to
   * change behavior call getNextValidDate or getPreviousValidDate on the result.
   * @param date
   * @param minutes
   * @returns
   */
  addWorkingTime(date, minutes) {
    if (Number.isNaN(minutes)) {
      throw new Error(
        `Received invalid amount of minutes ${minutes.toString()} for date ${date.toISOString()}.`
      );
    }
    if (minutes < 0) {
      return this.subtractWorkingTime(date, -minutes);
    }
    if (minutes === 0) {
      return date;
    }
    const cache = this.memoizationCache.addWorkingTime;
    const cached = cache.read({ date, duration: minutes });
    if (cached) {
      return cached;
    }
    const calendarInterval = this.getCalendarIntervalFromDate(date);
    const dateIntervals = calendarInterval.getAllDateIntervals(date);
    let remainingWorkingTime = minutes;
    for (let i = 0; i < dateIntervals.length; i++) {
      const intervalStart = max([dateIntervals[i].from, date]);
      const intervalEnd = dateIntervals[i].to;
      const duration = calendarInterval.getDateIntervalDuration({
        from: intervalStart,
        to: intervalEnd
      });
      if (remainingWorkingTime <= duration) {
        return cache.write(
          { date, duration: minutes },
          min([addMinutes(intervalStart, remainingWorkingTime), dateIntervals[i].to])
        );
      }
      remainingWorkingTime -= duration;
    }
    const nextDate = this.getNextDateRegardless(date);
    if (isEqual(nextDate, date)) {
      throw new InfiniteLoopInCalendarError(nextDate, this.id);
    }
    return cache.write(
      { date, duration: minutes },
      this.addWorkingTime(nextDate, remainingWorkingTime)
    );
  }
  /**
   * Subtracts working time from a date according to the calendar definition.
   * Adds working time if the given duration is negative.
   * It will always return a date of the first valid interval. In order to
   * change behavior call getNextValidDate or getPreviousValidDate on the result.
   * @param date
   * @param minutes
   * @returns
   */
  subtractWorkingTime(date, minutes) {
    if (Number.isNaN(minutes)) {
      throw new Error(
        `Received invalid amount of minutes ${minutes.toString()} for date ${date.toISOString()}.`
      );
    }
    if (minutes < 0) {
      return this.addWorkingTime(date, -minutes);
    }
    if (minutes === 0) {
      return date;
    }
    const cache = this.memoizationCache.subtractWorkingTime;
    const cached = cache.read({ date, duration: minutes });
    if (cached) {
      return cached;
    }
    const alignedDate = subSeconds(date, 1);
    const calendarInterval = this.getCalendarIntervalFromDate(alignedDate);
    const dateIntervals = calendarInterval.getAllDateIntervals(alignedDate);
    let remainingWorkingTime = minutes;
    for (let i = dateIntervals.length - 1; i >= 0; i--) {
      const intervalStart = dateIntervals[i].from;
      const intervalEnd = min([dateIntervals[i].to, date]);
      const duration = calendarInterval.getDateIntervalDuration({
        from: intervalStart,
        to: intervalEnd
      });
      if (remainingWorkingTime <= duration) {
        return cache.write(
          { date, duration: minutes },
          max([subMinutes(intervalEnd, remainingWorkingTime), dateIntervals[i].from])
        );
      }
      remainingWorkingTime -= duration;
    }
    const previousDate = this.getPreviousDateRegardless(date);
    if (isEqual(previousDate, date)) {
      throw new InfiniteLoopInCalendarError(previousDate, this.id);
    }
    return cache.write(
      { date, duration: minutes },
      this.subtractWorkingTime(previousDate, remainingWorkingTime)
    );
  }
  getCalendarIntervalFromDate(date) {
    const weekday = getWeekDay(date);
    const intervals = this.weekDayIntervalDictionary[weekday];
    if (intervals.length === 1) {
      return this.intervals.get(intervals[0]);
    }
    for (let i = intervals.length - 1; i >= 0; i--) {
      const interval = this.intervals.get(intervals[i]);
      if (interval.from && !isBefore(date, buildDateFromTimeString(date, interval.from))) {
        return interval;
      }
    }
    return this.intervals.get(intervals[0]);
  }
  /**
   * Returns the date of the next interval regardless of the validity of the given or returned date.
   * @param date
   * @returns
   */
  getNextDateRegardless(date) {
    const cache = this.memoizationCache.getNextDateRegardless;
    const cached = cache.read(date);
    if (cached) {
      return cached;
    }
    const calendarInterval = this.getCalendarIntervalFromDate(date);
    const nextDateInterval = calendarInterval.getNextDateInterval(date);
    if (nextDateInterval) {
      return cache.write(date, nextDateInterval.from);
    }
    const nextCalendarInterval = this.intervals.get(calendarInterval.next);
    const nextDateIntervals = nextCalendarInterval.getAllDateIntervals(
      buildDateFromWeekday(date, nextCalendarInterval.weekday)
    );
    const time = getTimeString(nextDateIntervals.length ? nextDateIntervals[0].from : date);
    return cache.write(
      date,
      buildDateFromWeekday(date, nextCalendarInterval.weekday, {
        timeString: time
      })
    );
  }
  /**
   * Returns the date of the previous interval regardless of the validity of the given or returned date.
   * @param date
   * @returns
   */
  getPreviousDateRegardless(date) {
    const cache = this.memoizationCache.getPreviousDateRegardless;
    const cached = cache.read(date);
    if (cached) {
      return cached;
    }
    const calendarInterval = this.getCalendarIntervalFromDate(date);
    const previousDateInterval = calendarInterval.getPreviousDateInterval(date);
    if (previousDateInterval) {
      return cache.write(date, previousDateInterval.to);
    }
    const previousCalendarInterval = this.intervals.get(calendarInterval.prev);
    const previousDateIntervals = previousCalendarInterval.getAllDateIntervals(
      buildDateFromWeekday(date, previousCalendarInterval.weekday)
    );
    const time = getTimeString(
      previousDateIntervals.length ? previousDateIntervals[previousDateIntervals.length - 1].to : date
    );
    return cache.write(
      date,
      buildDateFromWeekday(date, previousCalendarInterval.weekday, {
        timeString: time,
        pushForward: false
      })
    );
  }
  logCache() {
    Object.entries(this.memoizationCache).forEach(
      ([key, cache]) => {
        console.log(`Cache ${key}:`);
        cache.log();
      }
    );
  }
  getCacheString() {
    const cacheString = Object.entries(this.memoizationCache).reduce(
      (acc, [key, cache]) => `${acc}
Cache ${key}:
${Array.from(cache.getCache().entries()).reduce(
        (cacheAcc, [rawKey]) => `${cacheAcc}
${cache.getCacheEntryString(rawKey)}`,
        ""
      )}`,
      ""
    );
    return cacheString;
  }
  getEmptyCacheString() {
    return Object.entries(this.memoizationCache).reduce(
      (acc, [key]) => `${acc}
Cache ${key}:
`,
      ""
    );
  }
  /**
   * Creates a copy of the manager with the same state.
   * @returns
   */
  copy() {
    const copiedIntervals = new Map(
      Array.from(this.intervals.entries()).map((interval) => [interval[0], interval[1].copy()])
    );
    const copiedDictionary = { ...this.weekDayIntervalDictionary };
    const copy = new _CalendarManager(this.calendar, this.cache, {
      intervals: copiedIntervals,
      weekDayIntervalDictionary: copiedDictionary
    });
    Object.entries(this.memoizationCache).forEach(
      ([key, cache]) => {
        copy.memoizationCache[key] = cache.copy();
      }
    );
    return copy;
  }
};

// src/core/calendars/calendarStore.ts
var CalendarStore = class extends ObjectStore {
  constructor(state, cache = true, managers) {
    super(state);
    this.state = state;
    this.cache = cache;
    if (!managers) {
      state.forEach((calendar) => {
        this.managers.set(calendar.id, new CalendarManager(calendar, cache));
      });
    } else {
      this.managers = managers;
    }
  }
  objectName = "calendar";
  managers = /* @__PURE__ */ new Map();
  addedManagers = /* @__PURE__ */ new Map();
  updatedManagers = /* @__PURE__ */ new Map();
  deletedManagers = /* @__PURE__ */ new Map();
  getLatestManager(calendarId) {
    if (this.addedManagers.has(calendarId)) {
      return this.addedManagers.get(calendarId);
    }
    if (this.updatedManagers.has(calendarId)) {
      return this.updatedManagers.get(calendarId);
    }
    if (this.deleted.has(calendarId)) {
      throw new EntityNotFoundError("calendarManager", calendarId);
    }
    const manager = this.managers.get(calendarId);
    if (!manager) {
      throw new EntityNotFoundError("calendarManager", calendarId);
    }
    return manager;
  }
  getArchivedManager(calendarId) {
    return this.managers.get(calendarId);
  }
  patch({
    added,
    updated,
    deleted
  } = {}) {
    super.patch({ added, updated, deleted });
    added?.forEach((calendar) => {
      this.addedManagers.set(calendar.id, new CalendarManager(calendar, this.cache));
    });
    updated?.forEach((calendar) => {
      this.updatedManagers.set(
        calendar.id,
        new CalendarManager(
          {
            ...this.state.get(calendar.id) ?? {},
            ...calendar
          },
          this.cache
        )
      );
    });
    deleted?.forEach((calendar) => {
      this.deletedManagers.set(calendar.id, calendar);
    });
    return this;
  }
  commit() {
    this.addedManagers.forEach((manager, id) => {
      this.managers.set(id, manager);
    });
    this.updatedManagers.forEach((manager, id) => {
      this.managers.set(id, manager);
    });
    this.deletedManagers.forEach((_, id) => {
      this.managers.delete(id);
    });
    super.commit();
  }
  clear() {
    super.clear();
    this.addedManagers.clear();
    this.updatedManagers.clear();
    this.deletedManagers.clear();
  }
  copy() {
    const copiedManagers = new Map(
      Array.from(this.managers.entries()).map((manager) => [manager[0], manager[1].copy()])
    );
    return super.copy(this.cache, copiedManagers);
  }
};

// src/core/permissions/permissionStore.ts
var PermissionStore = class extends ObjectStore {
  constructor(state) {
    super(state);
    this.state = state;
    state.forEach((group) => {
      this.assignUsersToGroup(group);
    });
  }
  objectName = "permission";
  /**
   * Dictionary of user id to all group ids that have this user assigned and the permission they have within the group
   */
  userGroupPermissionDictionary = /* @__PURE__ */ new Map();
  /**
   * Dictionary of user id to the group id of the group that has admin rights for this user
   */
  userAdminGroupDictionary = /* @__PURE__ */ new Map();
  /**
   * Returns true if the user either has write permission for the specified group or has write permission for the admin group.
   * @param userId
   * @param groupId
   * @returns
   */
  userHasWritePermissionForGroup(userId, groupId) {
    if (this.userHasAdminRights(userId)) {
      return true;
    }
    if (!groupId) {
      return false;
    }
    const groupMembershipPermission = this.userGroupPermissionDictionary.get(userId)?.get(groupId);
    return groupMembershipPermission === "write" /* WRITE */;
  }
  /**
   * Returns true if the user has write permission for the admin group.
   * @param userId
   * @returns
   */
  userHasAdminRights(userId) {
    const userGroups = this.userGroupPermissionDictionary.get(userId);
    if (!userGroups) {
      return true;
    }
    const adminGroupId = this.userAdminGroupDictionary.get(userId);
    if (!adminGroupId) {
      return false;
    }
    const adminGroupMembershipPermission = this.userGroupPermissionDictionary.get(userId)?.get(adminGroupId);
    if (!adminGroupMembershipPermission) {
      return false;
    }
    return adminGroupMembershipPermission === "write" /* WRITE */;
  }
  assignUsersToGroup(group) {
    group.members.forEach((member) => {
      const groupIds = this.userGroupPermissionDictionary.get(member.user.id);
      if (groupIds) {
        groupIds.set(group.id, member.permission);
      } else {
        this.userGroupPermissionDictionary.set(
          member.user.id,
          /* @__PURE__ */ new Map([[group.id, member.permission]])
        );
      }
      if (group.isAdmin) {
        this.userAdminGroupDictionary.set(member.user.id, group.id);
      }
    });
  }
  unassignUsersFromGroup(group) {
    this.userGroupPermissionDictionary.forEach((groups) => {
      groups.delete(group.id);
    });
    this.userAdminGroupDictionary.forEach((adminGroupId, userId) => {
      if (adminGroupId === group.id) {
        this.userAdminGroupDictionary.delete(userId);
      }
    });
  }
  reset() {
    this.added.forEach((group) => {
      this.unassignUsersFromGroup(group);
    });
    this.updated.forEach((group) => {
      this.unassignUsersFromGroup(group);
      this.assignUsersToGroup(this.getArchivedById(group.id));
    });
    this.deleted.forEach((group) => {
      this.assignUsersToGroup(this.getArchivedById(group.id));
    });
    super.reset();
  }
  patch({
    added,
    updated,
    deleted
  } = {}) {
    super.patch({ added, updated, deleted });
    added?.forEach((group) => {
      this.assignUsersToGroup(group);
    });
    updated?.forEach((group) => {
      this.unassignUsersFromGroup(group);
      this.assignUsersToGroup(this.getLatestById(group.id));
    });
    deleted?.forEach((group) => {
      this.unassignUsersFromGroup(group);
    });
    return this;
  }
  copy() {
    return super.copy();
  }
};

// src/core/artifacts.ts
function getEntityMap() {
  return /* @__PURE__ */ new Map();
}
function copyStateMap(stateMap) {
  return Object.keys(stateMap).reduce((acc, key) => {
    acc[key] = new Map(stateMap[key]);
    return acc;
  }, {});
}
function buildStateMap(state, changes) {
  const stateMap = {};
  Object.entries(state).forEach(([entity, values]) => {
    stateMap[entity] = getEntityMap();
    values.forEach((item) => {
      stateMap[entity].set(item.id, item);
    });
  });
  return patchStateMap(stateMap, changes ?? {});
}
function patchStateMap(stateMap, changes) {
  if (changes.add) {
    Object.entries(changes.add).forEach(([entity, values]) => {
      values?.forEach((item) => {
        stateMap[entity].set(item.id, item);
      });
    });
  }
  if (changes.update) {
    Object.entries(changes.update).forEach(([entity, values]) => {
      values?.forEach((item) => {
        const previous = stateMap[entity].get(item.id);
        const validKeys = Object.keys(item).filter(
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          (key) => item[key] !== void 0
        );
        stateMap[entity].set(item.id, {
          ...previous ?? {},
          ...pickKeys(item, validKeys)
        });
      });
    });
  }
  if (changes.delete) {
    Object.entries(changes.delete ?? {}).forEach(([entity, values]) => {
      values?.forEach((item) => {
        stateMap[entity].delete(item.id);
      });
    });
  }
  return stateMap;
}
function buildChangesMap(changes) {
  const changesMap = {};
  Object.entries(changes).forEach(
    ([action, entities]) => {
      if (!entities) return;
      changesMap[action] = Object.entries(entities).reduce(
        (entityChanges, [entity, values]) => {
          if (Array.isArray(values)) {
            const entityChangeMap = getEntityMap();
            values.forEach((item) => {
              const validKeys = Object.keys(item).filter(
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                (key) => item[key] !== void 0
              );
              entityChangeMap.set(item.id, pickKeys(item, validKeys));
            });
            entityChanges[entity] = entityChangeMap;
          }
          return entityChanges;
        },
        {}
      );
    }
  );
  return changesMap;
}
function getArtifactsBuildingFunction({
  buildDependencyGraph: buildDependencyGraph3,
  patchDependencyGraph: patchDependencyGraph3,
  buildCalendarStore: buildCalendarStore2,
  patchCalendarStore: patchCalendarStore2,
  buildDependencyStore: buildDependencyStore3,
  patchDependencyStore: patchDependencyStore3,
  buildElementStore: buildElementStore3,
  patchElementStore: patchElementStore3,
  buildPermissionStore: buildPermissionStore2,
  patchPermissionStore: patchPermissionStore2
}) {
  return (state, changes, artifacts, options) => {
    let stateMap;
    let changesMap;
    if (options.optimistic && artifacts.stateMap && artifacts.changesMap) {
      stateMap = options.rebuildArtifacts.stateMap ? patchStateMap(artifacts.stateMap, changes) : artifacts.stateMap;
    } else {
      stateMap = buildStateMap(state, changes);
    }
    if (artifacts.changesMap && !options.rebuildArtifacts.changesMap) {
      changesMap = artifacts.changesMap;
    } else {
      changesMap = buildChangesMap(changes);
    }
    let calendarStore;
    let dependencyGraph;
    let dependencyStore;
    let elementStore;
    let permissionStore;
    if (options.optimistic && artifacts.dependencyGraph) {
      dependencyGraph = options.rebuildArtifacts.dependencyGraph ? patchDependencyGraph3(artifacts.dependencyGraph, changesMap) : artifacts.dependencyGraph;
    } else {
      dependencyGraph = buildDependencyGraph3(stateMap, changesMap, options);
    }
    if (!buildCalendarStore2 || !patchCalendarStore2) {
      calendarStore = new CalendarStore(/* @__PURE__ */ new Map());
    } else if (options.optimistic && artifacts.calendarStore) {
      calendarStore = options.rebuildArtifacts.calendarStore ? patchCalendarStore2(artifacts.calendarStore, stateMap, changesMap) : artifacts.calendarStore;
    } else {
      calendarStore = buildCalendarStore2(stateMap, changesMap, options);
    }
    if (options.optimistic && artifacts.dependencyStore) {
      dependencyStore = options.rebuildArtifacts.dependencyStore ? patchDependencyStore3(artifacts.dependencyStore, changesMap) : artifacts.dependencyStore;
    } else {
      dependencyStore = buildDependencyStore3(stateMap, changesMap, options);
    }
    if (options.optimistic && artifacts.elementStore) {
      elementStore = options.rebuildArtifacts.elementStore ? patchElementStore3(artifacts.elementStore, stateMap, changesMap) : artifacts.elementStore;
    } else {
      elementStore = buildElementStore3(stateMap, changesMap, options);
    }
    if (!buildPermissionStore2 || !patchPermissionStore2) {
      permissionStore = new PermissionStore(/* @__PURE__ */ new Map());
    } else if (options.optimistic && artifacts.permissionStore) {
      permissionStore = options.rebuildArtifacts.permissionStore ? patchPermissionStore2(artifacts.permissionStore, stateMap, changesMap) : artifacts.permissionStore;
    } else {
      permissionStore = buildPermissionStore2(stateMap, changesMap);
    }
    return {
      calendarStore,
      dependencyGraph,
      dependencyStore,
      elementStore,
      permissionStore,
      stateMap,
      changesMap,
      performanceTracker: artifacts.performanceTracker
    };
  };
}

// src/core/elements/utils.ts
function calculateStartDate(date, deltaInMinutes, calendar = null, enforceValidDate = true) {
  if (deltaInMinutes >= 0) {
    if (calendar) {
      const newDate = calendar.addWorkingTime(date, deltaInMinutes);
      if (enforceValidDate) {
        return calendar.getNextValidDate(newDate, true);
      }
      return newDate;
    }
    return addMinutes(date, deltaInMinutes);
  }
  if (calendar) {
    const newDate = calendar.subtractWorkingTime(date, -deltaInMinutes);
    if (enforceValidDate) {
      return calendar.getNextValidDate(newDate, true);
    }
    return newDate;
  }
  return subMinutes(date, -deltaInMinutes);
}
function calculateEndDate(date, deltaInMinutes, calendar = null, enforceValidDate = true) {
  if (deltaInMinutes >= 0) {
    if (calendar) {
      const newDate = calendar.addWorkingTime(date, deltaInMinutes);
      if (enforceValidDate) {
        return calendar.getPreviousValidDate(newDate, true);
      }
      return newDate;
    }
    return addMinutes(date, deltaInMinutes);
  }
  if (calendar) {
    const newDate = calendar.subtractWorkingTime(date, -deltaInMinutes);
    if (enforceValidDate) {
      return calendar.getPreviousValidDate(newDate, true);
    }
    return newDate;
  }
  return subMinutes(date, -deltaInMinutes);
}
function calculateDelta(from, to, calendar = null) {
  return calendar ? calendar.getWorkingTimeBetween(to, from) : differenceInMinutes(to, from);
}

// src/core/dependencies/utils.ts
function getSourceDate(source, dependency) {
  const offset = getSourceOffset(source, dependency);
  if (affectsSourceStart(dependency)) {
    return offset ? calculateStartDate(source.startDate, offset) : source.startDate;
  }
  if (affectsSourceEnd(dependency)) {
    return offset ? calculateEndDate(source.endDate, offset) : source.endDate;
  }
  throw new UnknownDependencyTypeError(dependency.type);
}
function getSourceOffset(source, dependency) {
  if (affectsSourceStart(dependency)) {
    return source.startOffset && dependency.useSourceStartOffset ? -Math.abs(source.startOffset) : 0;
  }
  if (affectsSourceEnd(dependency)) {
    return source.endOffset && dependency.useSourceEndOffset ? Math.abs(source.endOffset) : 0;
  }
  throw new UnknownDependencyTypeError(dependency.type);
}
function getTargetDate(target, dependency) {
  const offset = getTargetOffset(target, dependency);
  if (affectsTargetStart(dependency)) {
    return offset ? calculateStartDate(target.startDate, offset) : target.startDate;
  }
  if (affectsTargetEnd(dependency)) {
    return offset ? calculateEndDate(target.endDate, offset) : target.endDate;
  }
  throw new UnknownDependencyTypeError(dependency.type);
}
function getTargetOffset(target, dependency) {
  if (affectsTargetStart(dependency)) {
    return target.startOffset && dependency.useTargetStartOffset ? -Math.abs(target.startOffset) : 0;
  }
  if (affectsTargetEnd(dependency)) {
    return target.endOffset && dependency.useTargetEndOffset ? Math.abs(target.endOffset) : 0;
  }
  throw new UnknownDependencyTypeError(dependency.type);
}
function getConstraintDate(source, dependency, calendar) {
  const sourceDate = getSourceDate(source, dependency);
  if (affectsTargetStart(dependency)) {
    return calculateStartDate(sourceDate, dependency.lag, calendar, !!calendar);
  }
  if (affectsTargetEnd(dependency)) {
    return calculateEndDate(sourceDate, dependency.lag, calendar, !!calendar);
  }
  throw new UnknownDependencyTypeError(dependency.type);
}
function getConstraintViolationAmount(constraintDate, dependency, target, calendar) {
  const targetDate = getTargetDate(target, dependency);
  const difference2 = calculateDelta(constraintDate, targetDate, calendar);
  if (difference2 < 0) {
    return Math.abs(difference2);
  }
  return 0;
}
function violatesConstraint(targetDate, constraintDate) {
  return isBefore(targetDate, constraintDate);
}
function getDependencyCalendarId(source, target) {
  return target.calendarId || null;
}
function affectsTargetStart(dependency) {
  return ["START_TO_START" /* SS */, "FINISH_TO_START" /* FS */].includes(dependency.type);
}
function affectsTargetEnd(dependency) {
  return ["START_TO_FINISH" /* SF */, "FINISH_TO_FINISH" /* FF */].includes(dependency.type);
}
function affectsSourceStart(dependency) {
  return ["START_TO_START" /* SS */, "START_TO_FINISH" /* SF */].includes(dependency.type);
}
function affectsSourceEnd(dependency) {
  return ["FINISH_TO_START" /* FS */, "FINISH_TO_FINISH" /* FF */].includes(dependency.type);
}

// src/core/engine/utils.ts
var SchedulingEngineUtils = class {
  constructor(getState, getArtifacts) {
    this.getState = getState;
    this.getArtifacts = getArtifacts;
  }
  /**
   * Computes the working time in minutes between the two dates based on the calendar manager.
   * @param endDate
   * @param startDate
   * @param calendarManagerOrId
   * @returns
   */
  computeWorkingTimeBetween(endDate, startDate, calendarManagerOrId) {
    const artifacts = this.getArtifacts();
    if (calendarManagerOrId) {
      const calendarManager = typeof calendarManagerOrId === "string" ? artifacts.calendarStore.getLatestManager(calendarManagerOrId) : calendarManagerOrId;
      return calendarManager.getWorkingTimeBetween(endDate, startDate);
    }
    return differenceInMinutes(endDate, startDate);
  }
  /**
   * Returns a valid start date based on the calendar manager that is delta minutes away from the initial date.
   * @param date
   * @param calendarManagerOrId
   * @param deltaInMinutes
   * @returns
   */
  getValidStartDate(date, calendarManagerOrId, deltaInMinutes = 0) {
    const artifacts = this.getArtifacts();
    const calendarManager = typeof calendarManagerOrId === "string" ? artifacts.calendarStore.getLatestManager(calendarManagerOrId) : calendarManagerOrId;
    return calculateStartDate(date, deltaInMinutes, calendarManager);
  }
  /**
   * Returns a valid end date based on the calendar manager that is delta minutes away from the initial date.
   * @param date
   * @param calendarManagerOrId
   * @param deltaInMinutes
   * @returns
   */
  getValidEndDate(date, calendarManagerOrId, deltaInMinutes = 0) {
    const artifacts = this.getArtifacts();
    const calendarManager = typeof calendarManagerOrId === "string" ? artifacts.calendarStore.getLatestManager(calendarManagerOrId) : calendarManagerOrId;
    return calculateEndDate(date, deltaInMinutes, calendarManager);
  }
  /**
   * Checks if the date is during working time based on the calendar manager.
   * @param date
   * @param calendarManagerOrId
   * @returns
   */
  isStartDateDuringWorkingTime(date, calendarManagerOrId) {
    const artifacts = this.getArtifacts();
    if (calendarManagerOrId) {
      const calendarManager = typeof calendarManagerOrId === "string" ? artifacts.calendarStore.getLatestManager(calendarManagerOrId) : calendarManagerOrId;
      return isEqual(calendarManager.getNextValidDate(date), date);
    }
    return true;
  }
  /**
   * Checks if the date is during working time based on the calendar manager.
   * @param date
   * @param calendarManagerOrId
   * @returns
   */
  isEndDateDuringWorkingTime(date, calendarManagerOrId) {
    const artifacts = this.getArtifacts();
    if (calendarManagerOrId) {
      const calendarManager = typeof calendarManagerOrId === "string" ? artifacts.calendarStore.getLatestManager(calendarManagerOrId) : calendarManagerOrId;
      return isEqual(calendarManager.getNextValidDate(subSeconds(date, 1)), subSeconds(date, 1));
    }
    return true;
  }
  /**
   * Returns the current predecessor dependency ids of the element.
   * @param elementId
   * @returns
   */
  getPredecessorDependencyIds(elementId) {
    const artifacts = this.getArtifacts();
    return artifacts.dependencyGraph.getPredecessorEdgeIds(elementId);
  }
  /**
   * Returns the current successor dependency ids of the element.
   * @param elementId
   * @returns
   */
  getSuccessorDependencyIds(elementId) {
    const artifacts = this.getArtifacts();
    return artifacts.dependencyGraph.getSuccessorEdgeIds(elementId);
  }
  /**
   * Returns the current incident dependency ids of the elements.
   * @param elementIds
   * @param intersectionOnly
   * @returns
   */
  getIncidentDependencies(elementIds, intersectionOnly = false) {
    const artifacts = this.getArtifacts();
    return artifacts.dependencyGraph.getIncidentEdges(elementIds, intersectionOnly).map((edge) => edge.id);
  }
  /**
   * Calculates the current constraint date of the dependency.
   * @param dependencyId
   */
  getDependencyConstraintDate(dependencyId) {
    const artifacts = this.getArtifacts();
    const dependency = artifacts.dependencyStore.getLatestById(dependencyId);
    const source = artifacts.elementStore.getLatestById(dependency.from.id);
    const target = artifacts.elementStore.getLatestById(dependency.to.id);
    const calendarId = getDependencyCalendarId(source, target);
    const calendarManager = calendarId ? artifacts.calendarStore.getLatestManager(calendarId) : null;
    return getConstraintDate(source, dependency, calendarManager);
  }
  /**
   * Calculates the current constraint violation amount in minutes of the dependency.
   * @param dependencyId
   */
  getDependencyConstraintViolation(dependencyId) {
    const artifacts = this.getArtifacts();
    const dependency = artifacts.dependencyStore.getLatestById(dependencyId);
    const source = artifacts.elementStore.getLatestById(dependency.from.id);
    const target = artifacts.elementStore.getLatestById(dependency.to.id);
    const calendarId = getDependencyCalendarId(source, target);
    const calendarManager = calendarId ? artifacts.calendarStore.getLatestManager(calendarId) : null;
    return getConstraintViolationAmount(
      getConstraintDate(source, dependency, calendarManager),
      dependency,
      target,
      calendarManager
    );
  }
};

// src/core/results.ts
function getResultReadingFunction(transformResults3) {
  return (state, changes, artifacts) => {
    const { dependencyStore, elementStore } = artifacts;
    const invokedConstraints = dependencyStore.getInvokedConstraints();
    return {
      ...transformResults3(
        state,
        changes,
        artifacts.stateMap,
        artifacts.changesMap,
        { added: elementStore.getAdded(), updated: elementStore.getUpdated() },
        { added: dependencyStore.getAdded(), updated: dependencyStore.getUpdated() }
      ),
      meta: {
        invokedConstraints
      }
    };
  };
}

// src/core/engine/engine.ts
var import_lodash3 = __toESM(require_lodash());

// src/common/performance/performanceTracker.ts
var PerformanceTracker = class {
  constructor(name, debug = false) {
    this.name = name;
    this.debug = debug;
    if (this.debug) {
      this.data[this.name] = {
        executionTimes: {},
        calls: {},
        customProperties: {},
        openCalls: {}
      };
    }
  }
  data = {};
  register(obj) {
    const className = obj.constructor.name;
    if (!this.debug) {
      return obj;
    }
    if (!(className in this.data)) {
      this.data[className] = {
        executionTimes: {},
        calls: {},
        customProperties: {},
        openCalls: {}
      };
    }
    return this.trackPerformanceOfMethods(obj);
  }
  cleanupDebug() {
    this.data = {};
  }
  logEvaluation() {
    if (!this.debug) {
      return;
    }
    Object.entries(this.data).forEach(([objName, objData]) => {
      console.log(`>> ${objName}:`);
      Object.entries(objData.executionTimes).sort(([methodNameA], [methodNameB]) => methodNameA.localeCompare(methodNameB)).forEach(([methodName, executionData]) => {
        console.log(
          `	 ${methodName} -> Total=${executionData.toFixed(0)}ms, Calls=${objData.calls[methodName].toString()}, Avg=${(executionData / objData.calls[methodName]).toFixed(3)}ms`
        );
      });
    });
    this.cleanupDebug();
  }
  startCustomTrack(name) {
    if (!this.debug) {
      return;
    }
    this.data[this.name].customProperties[name] = performance.now();
    this.trackFunctionCall(this.name, name);
  }
  stopCustomTrack(name) {
    if (!this.debug) {
      return;
    }
    if (!this.data[this.name].customProperties[name]) {
      return;
    }
    this.finishFunctionCallTrack(
      this.name,
      name,
      this.data[this.name].customProperties[name],
      performance.now()
    );
  }
  trackFunctionCall(objName, methodName) {
    if (!(objName in this.data)) {
      return;
    }
    if (!this.data[objName].openCalls[methodName]) {
      this.data[objName].openCalls[methodName] = 0;
    }
    this.data[objName].openCalls[methodName] += 1;
  }
  finishFunctionCallTrack(objName, methodName, start, end) {
    if (!(objName in this.data)) {
      return;
    }
    this.data[objName].openCalls[methodName] -= 1;
    if (this.data[objName].openCalls[methodName] > 0) {
      return;
    }
    if (!this.data[objName].executionTimes[methodName]) {
      this.data[objName].executionTimes[methodName] = 0;
    }
    if (!this.data[objName].calls[methodName]) {
      this.data[objName].calls[methodName] = 0;
    }
    this.data[objName].executionTimes[methodName] += end - start;
    this.data[objName].calls[methodName] += 1;
  }
  trackPerformanceOfMethods(obj) {
    const methodNames = this.getAllMethodNames(obj);
    methodNames.forEach((methodName) => {
      const originalMethod = obj[methodName];
      obj[methodName] = (...args) => {
        const className = obj.constructor.name;
        this.trackFunctionCall(className, methodName);
        const start = performance.now();
        const result = originalMethod.apply(obj, args);
        const end = performance.now();
        this.finishFunctionCallTrack(className, methodName, start, end);
        return result;
      };
    });
    return obj;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getAllMethodNames(obj) {
    const methods = /* @__PURE__ */ new Set();
    let proto = Object.getPrototypeOf(obj);
    while (proto && proto !== Object.prototype) {
      const names = Object.getOwnPropertyNames(proto).filter(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (prop) => typeof obj[prop] === "function" && prop !== "constructor"
      );
      names.forEach((name) => methods.add(name));
      proto = Object.getPrototypeOf(proto);
    }
    return Array.from(methods.values());
  }
};

// src/core/dependencies/dependencyStore.ts
var DependencyStore = class extends ObjectStore {
  objectName = "dependency";
  /**
   * Map of dependency id and the magnitude of change the dependency
   * propagates from the source to the target
   */
  propagations = /* @__PURE__ */ new Map();
  /**
   * Map of dependency id and its constraint date
   */
  constraints = /* @__PURE__ */ new Map();
  /**
   * Map that contains an dependency when it's constraint got invoked during scheduling and stores the lag that could be
   * set to overrule the dependency that has been invoked
   */
  invokedConstraints = /* @__PURE__ */ new Map();
  setPropagation(dependencyId, magnitude) {
    this.propagations.set(dependencyId, magnitude);
  }
  getPropagation(dependencyId) {
    return this.propagations.get(dependencyId) ?? 0;
  }
  setConstraint(dependencyId, date) {
    this.constraints.set(dependencyId, date);
  }
  getConstraint(dependencyId) {
    const constraint = this.constraints.get(dependencyId);
    return constraint;
  }
  getInvokedConstraints() {
    return Array.from(this.invokedConstraints.values());
  }
  setInvokedConstraint(dependencyId, invokedConstraint) {
    this.invokedConstraints.set(dependencyId, invokedConstraint);
  }
  bufferChanged(dependencyId) {
    const change = this.updated.get(dependencyId);
    return change?.buffer !== void 0;
  }
  clear() {
    super.clear();
    this.propagations.clear();
    this.invokedConstraints.clear();
    this.constraints.clear();
  }
  copy() {
    return super.copy();
  }
};

// src/core/elements/elementStore.ts
var ElementStore = class extends ObjectStore {
  constructor(state) {
    super(state);
    this.state = state;
    state.forEach((element) => {
      this.addElementInCalendarDictionary(element.id, element.calendarId);
    });
  }
  objectName = "element";
  /**
   * Dictionary of calendar id to all element ids that have this calendar assigned
   */
  calendarElementDictionary = /* @__PURE__ */ new Map();
  /**
   * Returns all element ids that have the given calendar assigned.
   * @param calendarId
   * @returns
   */
  getElementIdsWithCalendar(calendarId) {
    const elementIds = this.calendarElementDictionary.get(calendarId);
    if (!elementIds) {
      return [];
    }
    return Array.from(elementIds.values());
  }
  addElementInCalendarDictionary(elementId, calendarId) {
    if (calendarId) {
      const elementIds = this.calendarElementDictionary.get(calendarId);
      if (elementIds) {
        elementIds.add(elementId);
      } else {
        this.calendarElementDictionary.set(calendarId, /* @__PURE__ */ new Set([elementId]));
      }
    }
  }
  updateElementInCalendarDictionary(elementId, newCalendarId, oldCalendarId) {
    if (oldCalendarId === newCalendarId) {
      return;
    }
    if (oldCalendarId) {
      this.removeElementFromCalendarDictionary(elementId, oldCalendarId);
    }
    if (newCalendarId) {
      this.addElementInCalendarDictionary(elementId, newCalendarId);
    }
  }
  removeElementFromCalendarDictionary(elementId, calendarId) {
    if (calendarId) {
      const elementIds = this.calendarElementDictionary.get(calendarId);
      if (elementIds) {
        elementIds.delete(elementId);
      }
    }
  }
  datesChanged(elementId) {
    const change = this.updated.get(elementId);
    return change?.startDate !== void 0 || change?.endDate !== void 0;
  }
  reset() {
    this.added.forEach((object) => {
      const calendarId = object.calendarId;
      this.removeElementFromCalendarDictionary(object.id, calendarId);
    });
    this.updated.forEach((object) => {
      const newCalendarId = this.getArchivedById(object.id)?.calendarId;
      const oldCalendarId = object.calendarId;
      this.updateElementInCalendarDictionary(object.id, newCalendarId, oldCalendarId);
    });
    this.deleted.forEach((object) => {
      const calendarId = this.getArchivedById(object.id)?.calendarId;
      this.addElementInCalendarDictionary(object.id, calendarId);
    });
    super.reset();
  }
  patch({
    added,
    updated,
    deleted
  } = {}) {
    super.patch({ added, updated, deleted });
    added?.forEach((object) => {
      const calendarId = object.calendarId;
      this.addElementInCalendarDictionary(object.id, calendarId);
    });
    updated?.forEach((object) => {
      const oldCalendarId = this.getArchivedById(object.id)?.calendarId;
      const newCalendarId = object.calendarId;
      if (object.calendarId !== void 0) {
        this.updateElementInCalendarDictionary(object.id, newCalendarId, oldCalendarId);
      }
    });
    deleted?.forEach((object) => {
      const calendarId = this.getArchivedById(object.id)?.calendarId;
      this.removeElementFromCalendarDictionary(object.id, calendarId);
    });
    return this;
  }
  copy() {
    return super.copy();
  }
};

// src/core/dependencies/scheduling.ts
function scheduleDependencies(artifacts, options) {
  const { dependencyStore } = artifacts;
  const optimisticDependencyIds = getOptimisticToBeScheduledDependencyIds(artifacts);
  const dependencyIdsToBeScheduled = options.optimistic ? Array.from(optimisticDependencyIds.values()) : dependencyStore.getAllIds();
  dependencyIdsToBeScheduled.forEach((dependencyId) => {
    const dependency = dependencyStore.getLatestById(dependencyId);
    const scheduledDependency = scheduleDependency(dependency, artifacts);
    const changes = getDependencyChanges(dependency, scheduledDependency);
    if (changes) {
      dependencyStore.setLatest(changes);
    }
  });
}
function scheduleDependency(dependency, artifacts) {
  const { elementStore, calendarStore } = artifacts;
  const scheduledDependency = { ...dependency };
  const predecessor = elementStore.getLatestById(dependency.from.id);
  const successor = elementStore.getLatestById(dependency.to.id);
  const calendarId = getDependencyCalendarId(predecessor, successor);
  const calendarManager = calendarId ? calendarStore.getLatestManager(calendarId) : null;
  const constraintDate = getConstraintDate(predecessor, dependency, calendarManager);
  const targetDate = getTargetDate(successor, dependency);
  const gap = calculateDelta(constraintDate, targetDate, calendarManager);
  const buffer = Math.max(gap, 0);
  scheduledDependency.buffer = buffer;
  scheduledDependency.isViolated = gap < 0;
  if (!predecessor.startOffset && dependency.useSourceStartOffset) {
    scheduledDependency.useSourceStartOffset = false;
  }
  if (!predecessor.endOffset && dependency.useSourceEndOffset) {
    scheduledDependency.useSourceEndOffset = false;
  }
  if (!successor.startOffset && dependency.useTargetStartOffset) {
    scheduledDependency.useTargetStartOffset = false;
  }
  if (!successor.endOffset && dependency.useTargetEndOffset) {
    scheduledDependency.useTargetEndOffset = false;
  }
  return scheduledDependency;
}
function getOptimisticToBeScheduledDependencyIds(artifacts) {
  const ids = /* @__PURE__ */ new Set();
  const { calendarStore, dependencyStore, elementStore, dependencyGraph } = artifacts;
  dependencyStore.getChanged().forEach((dependency) => {
    ids.add(dependency.id);
  });
  elementStore.getChanged().forEach((element) => {
    dependencyGraph.getIncidentEdges(element.id).forEach((edge) => {
      ids.add(edge.id);
    });
  });
  calendarStore.getChanged().forEach((calendar) => {
    elementStore.getElementIdsWithCalendar(calendar.id).forEach((elementId) => {
      dependencyGraph.getIncidentEdges(elementId).forEach((edge) => {
        ids.add(edge.id);
      });
    });
  });
  return ids;
}
function getDependencyChanges(dependency, scheduledDependency) {
  const changes = { id: dependency.id };
  if (scheduledDependency.lag !== dependency.lag) {
    changes.lag = scheduledDependency.lag;
  }
  if (scheduledDependency.buffer !== dependency.buffer) {
    changes.buffer = scheduledDependency.buffer;
  }
  if (dependency.useSourceStartOffset !== void 0 && scheduledDependency.useSourceStartOffset !== dependency.useSourceStartOffset) {
    changes.useSourceStartOffset = scheduledDependency.useSourceStartOffset;
  }
  if (dependency.useSourceEndOffset !== void 0 && scheduledDependency.useSourceEndOffset !== dependency.useSourceEndOffset) {
    changes.useSourceEndOffset = scheduledDependency.useSourceEndOffset;
  }
  if (dependency.useTargetStartOffset !== void 0 && scheduledDependency.useTargetStartOffset !== dependency.useTargetStartOffset) {
    changes.useTargetStartOffset = scheduledDependency.useTargetStartOffset;
  }
  if (dependency.useTargetEndOffset !== void 0 && scheduledDependency.useTargetEndOffset !== dependency.useTargetEndOffset) {
    changes.useTargetEndOffset = scheduledDependency.useTargetEndOffset;
  }
  if (dependency.isViolated !== void 0 && scheduledDependency.isViolated !== dependency.isViolated) {
    changes.isViolated = scheduledDependency.isViolated;
  }
  return Object.keys(changes).length > 1 ? changes : null;
}

// src/core/dependencies/dependencyResolver.ts
var DependencyResolver = class {
  constructor(calendarStore, dependencyStore, elementStore, permissionStore, context, options) {
    this.calendarStore = calendarStore;
    this.dependencyStore = dependencyStore;
    this.elementStore = elementStore;
    this.permissionStore = permissionStore;
    this.context = context;
    this.options = options;
  }
  /**
   * Reschedules a given element based on its predecessors. At first,
   * the element is rescheduled with the minimum propagation of its predecessors (for negative propagations).
   * Then, the element is rescheduled with the maximum propagation of its predecessors (for positive propagations).
   * The element is then validated against the constraints of its predecessors by either rescheduling the element again
   * or by overruling the constraints of the dependencies.
   * @param element
   * @param predecessorDependencyIds
   * @returns
   */
  resolvePredecessors(element, predecessorDependencyIds) {
    const dependencies = [];
    let minPropagation = Number.POSITIVE_INFINITY;
    let maxPropagation = Number.NEGATIVE_INFINITY;
    let minPropagationDependency = null;
    let maxPropagationDependency = null;
    predecessorDependencyIds.forEach((dependencyId) => {
      const dependency = this.dependencyStore.getLatestById(dependencyId);
      const propagation = this.dependencyStore.getPropagation(dependencyId);
      if (propagation < 0 && propagation < minPropagation) {
        minPropagationDependency = dependency;
        minPropagation = propagation;
      }
      if (propagation > 0 && propagation > maxPropagation) {
        maxPropagationDependency = dependency;
        maxPropagation = propagation;
      }
      dependencies.push(dependency);
    });
    return this.applyConstraints(
      this.applyPropagation(
        this.applyPropagation(element, minPropagationDependency),
        maxPropagationDependency
      ),
      dependencies
    );
  }
  /**
   * Updates successor dependencies based on potential changes of a given element.
   * The function calculates the propagation of the changes from the element to its successors.
   * @param element
   * @param successorDependencyIds
   * @returns
   */
  resolveSuccessors(element, successorDependencyIds) {
    const propagations = /* @__PURE__ */ new Map();
    successorDependencyIds.forEach((dependencyId) => {
      const dependency = this.dependencyStore.getLatestById(dependencyId);
      const successor = this.elementStore.getLatestById(dependency.to.id);
      const oldElement = this.elementStore.getArchivedById(element.id);
      const oldSuccessor = this.elementStore.getArchivedById(successor.id);
      const oldDependency = this.dependencyStore.getArchivedById(dependency.id);
      const constraintDate = this.calculateConstraint(dependencyId, element, successor);
      propagations.set(
        dependencyId,
        this.calculatePropagation({
          predecessor: element,
          successor,
          dependency,
          constraintDate,
          oldPredecessor: oldElement,
          oldSuccessor,
          oldDependency
        })
      );
    });
    return { propagations };
  }
  /**
   * Reschedules an element based on a propagation that is derived from a dependency.
   * @param element
   * @param dependency
   * @returns
   */
  applyPropagation(element, dependency) {
    if (!dependency) {
      return element;
    }
    if (!this.shouldApplyPropagation(element)) {
      return element;
    }
    const source = this.elementStore.getLatestById(dependency.from.id);
    const propagation = this.dependencyStore.getPropagation(dependency.id);
    const targetDate = getTargetDate(element, dependency);
    const { startDate, endDate } = this.rescheduleTarget(
      targetDate,
      propagation,
      source,
      element,
      dependency
    );
    return {
      ...element,
      startDate,
      endDate
    };
  }
  /**
   * Reschedules element to satisfy all constraints of the dependencies.
   * @param element
   * @param dependencies
   * @returns
   */
  applyConstraints(element, dependencies) {
    let resolvedElement = { ...element };
    const invokedConstraints = /* @__PURE__ */ new Map();
    const enforcedDependencies = [];
    const otherDependencies = [];
    dependencies.forEach((dependency) => {
      if (this.shouldEnforceBuffer(dependency, resolvedElement)) {
        enforcedDependencies.push(dependency);
      } else {
        otherDependencies.push(dependency);
      }
    });
    enforcedDependencies.forEach((dependency, idx) => {
      const source = this.elementStore.getLatestById(dependency.from.id);
      const constraintDate = this.calculateConstraint(dependency.id, source, resolvedElement);
      const { startDate, endDate } = this.rescheduleTarget(
        constraintDate,
        dependency.buffer,
        source,
        resolvedElement,
        dependency
      );
      if (idx > 0 && (isBefore(startDate, resolvedElement.startDate) || isBefore(endDate, resolvedElement.endDate))) {
        return;
      }
      resolvedElement = {
        ...resolvedElement,
        startDate,
        endDate
      };
    });
    const originalResolvedElement = { ...resolvedElement };
    otherDependencies.forEach((dependency) => {
      const source = this.elementStore.getLatestById(dependency.from.id);
      if (!this.shouldEnforceConstraint(source, resolvedElement)) {
        return;
      }
      const constraintDate = this.calculateConstraint(dependency.id, source, resolvedElement);
      const originalTargetDate = getTargetDate(originalResolvedElement, dependency);
      const currentTargetDate = getTargetDate(resolvedElement, dependency);
      if (violatesConstraint(originalTargetDate, constraintDate)) {
        const originalViolationAmount = this.calculateConstraintViolationAmount(
          dependency,
          source,
          originalResolvedElement
        );
        invokedConstraints.set(dependency.id, {
          dependencyId: dependency.id,
          fromId: dependency.from.id,
          toId: dependency.to.id,
          lagToOverrule: dependency.lag - originalViolationAmount
        });
      }
      if (violatesConstraint(currentTargetDate, constraintDate)) {
        const { startDate, endDate } = this.rescheduleTarget(
          constraintDate,
          0,
          source,
          resolvedElement,
          dependency
        );
        resolvedElement = {
          ...resolvedElement,
          startDate,
          endDate
        };
      }
    });
    return {
      resolvedElement,
      invokedConstraints
    };
  }
  calculateConstraint(dependencyId, predecessor, successor) {
    const constraint = this.dependencyStore.getConstraint(dependencyId);
    if (constraint) {
      return constraint;
    }
    const dependency = this.dependencyStore.getLatestById(dependencyId);
    const source = predecessor ?? this.elementStore.getLatestById(dependency.from.id);
    const target = successor ?? this.elementStore.getLatestById(dependency.to.id);
    const calendar = this.getDependencyCalendar(source, target);
    const constraintDate = getConstraintDate(source, dependency, calendar);
    this.dependencyStore.setConstraint(dependency.id, constraintDate);
    return constraintDate;
  }
  calculateConstraintViolationAmount(dependency, predecessor, successor) {
    const calendarManager = this.getDependencyCalendar(predecessor, successor);
    const constraintDate = this.calculateConstraint(dependency.id, predecessor, successor);
    return getConstraintViolationAmount(constraintDate, dependency, successor, calendarManager);
  }
  /**
   * Returns the propagation of the changes from the old dependency to the new dependency.
   * The propagation is the difference of the old and new constraint date.
   * @param param0
   * @returns
   */
  calculatePropagation({
    predecessor,
    successor,
    dependency,
    constraintDate,
    oldPredecessor,
    oldSuccessor,
    oldDependency
  }) {
    if (!oldPredecessor || !oldDependency || !oldSuccessor || oldDependency.type !== dependency.type) {
      return 0;
    }
    const calendarManager = this.getDependencyCalendar(predecessor, successor);
    const oldCalendarManager = this.getOldDependencyCalendar(oldPredecessor, oldSuccessor);
    const oldConstraintDate = getConstraintDate(oldPredecessor, oldDependency, oldCalendarManager);
    if (!isBefore(constraintDate, oldConstraintDate)) return 0;
    return calculateDelta(oldConstraintDate, constraintDate, calendarManager);
  }
  rescheduleTarget(anchorDate, change, source, target, dependency) {
    const calendarManager = this.getDependencyCalendar(source, target);
    const offset = getTargetOffset(target, dependency);
    if (affectsTargetStart(dependency)) {
      const newStartDate = subMinutes(
        calculateStartDate(anchorDate, change, calendarManager, !!target.calendarId),
        offset
      );
      if (target.duration < 0) {
        throw new InvalidElementDurationError(target.id, target.duration);
      }
      return {
        startDate: newStartDate,
        endDate: calculateEndDate(
          newStartDate,
          target.duration,
          calendarManager,
          !!target.calendarId
        )
      };
    }
    if (affectsTargetEnd(dependency)) {
      const newEndDate = subMinutes(
        calculateEndDate(anchorDate, change, calendarManager, !!target.calendarId),
        offset
      );
      if (target.duration < 0) {
        throw new InvalidElementDurationError(target.id, target.duration);
      }
      return {
        startDate: calculateStartDate(
          newEndDate,
          -target.duration,
          calendarManager,
          !!target.calendarId
        ),
        endDate: newEndDate
      };
    }
    throw new UnknownDependencyTypeError(dependency.type);
  }
  getDependencyCalendar(source, target) {
    const calendarId = getDependencyCalendarId(source, target);
    return calendarId ? this.calendarStore.getLatestManager(calendarId) : null;
  }
  getOldDependencyCalendar(source, target) {
    const calendarId = getDependencyCalendarId(source, target);
    return calendarId ? this.calendarStore.getArchivedManager(calendarId) ?? null : null;
  }
  /**
   * Determines whether a propagation of another dependency should be applied to the given successor element.
   * @param element
   * @returns
   */
  shouldApplyPropagation(successor) {
    if (successor.isFixed) {
      return false;
    }
    if (this.elementStore.datesChanged(successor.id)) {
      return false;
    }
    if (this.context.user && !this.permissionStore.userHasWritePermissionForGroup(this.context.user.id, successor.groupId)) {
      return false;
    }
    return true;
  }
  /**
   * Determines whether a constraint of another dependency should be enforced for the given successor element.
   * @param element
   * @returns
   */
  shouldEnforceConstraint(predecessor, successor) {
    if (this.options.enforceValidDates) {
      return true;
    }
    if (successor.isFixed) {
      return false;
    }
    if (this.context.user && !this.permissionStore.userHasWritePermissionForGroup(this.context.user.id, successor.groupId)) {
      return false;
    }
    if (this.context.user && !this.permissionStore.userHasAdminRights(this.context.user.id) && !this.permissionStore.userHasWritePermissionForGroup(
      this.context.user.id,
      predecessor.groupId
    ) && this.elementStore.datesChanged(successor.id)) {
      return false;
    }
    return true;
  }
  /**
   * Determines whether a dependency should enforce it's buffer for the given successor element.
   * @param element
   * @returns
   */
  shouldEnforceBuffer(dependency, successor) {
    if (this.options.enforceValidDates) {
      return true;
    }
    if (successor.isFixed) {
      return false;
    }
    if (this.context.user && !this.permissionStore.userHasWritePermissionForGroup(this.context.user.id, successor.groupId)) {
      return false;
    }
    if (this.dependencyStore.getAdded().has(dependency.id) || this.dependencyStore.bufferChanged(dependency.id)) {
      return true;
    }
    return false;
  }
};

// src/core/elements/scheduling.ts
function scheduleElements(artifacts, context, options) {
  const { dependencyGraph, elementStore } = artifacts;
  const optimisticElementIds = getOptimisticToBeScheduledElementIds(artifacts);
  let elementIdsToBeScheduled;
  if (options.minimal) {
    elementIdsToBeScheduled = getMinimalToBeScheduledElementIds(artifacts);
  } else {
    elementIdsToBeScheduled = options.optimistic ? artifacts.dependencyGraph.getDescendants(optimisticElementIds) : elementStore.getAllIds();
  }
  dependencyGraph.getTopologicalOrder(elementIdsToBeScheduled).forEach((elementId) => {
    if (options.optimistic) {
      const predecessors = Array.from(dependencyGraph.getPredecessors(elementId));
      const noPredecessorHasChanges = predecessors.every(
        (predecessorId) => !elementStore.hasChanges(predecessorId)
      );
      if (!optimisticElementIds.has(elementId) && noPredecessorHasChanges) {
        return;
      }
    }
    const element = elementStore.getLatestById(elementId);
    const scheduledElement = scheduleElement(element, artifacts, context, options);
    const changes = getElementChanges(element, scheduledElement);
    if (changes) {
      elementStore.setLatest(changes);
    }
  });
}
function scheduleElement(element, artifacts, context, options) {
  const { calendarStore, dependencyStore, dependencyGraph } = artifacts;
  const scheduledElement = { ...element };
  if (element.calendarId && (!element.isFixed || options.enforceValidDates)) {
    const calendarManager = calendarStore.getLatestManager(element.calendarId);
    const startDate = calculateStartDate(element.startDate, 0, calendarManager);
    if (element.duration < 0) {
      throw new InvalidElementDurationError(element.id, element.duration);
    }
    const endDate = calculateEndDate(startDate, element.duration, calendarManager);
    scheduledElement.startDate = startDate;
    scheduledElement.endDate = endDate;
  }
  const dependencyResolver = new DependencyResolver(
    artifacts.calendarStore,
    artifacts.dependencyStore,
    artifacts.elementStore,
    artifacts.permissionStore,
    context,
    options
  );
  artifacts.performanceTracker.register(dependencyResolver);
  const predecessorDependencyIds = dependencyGraph.getPredecessorEdgeIds(element.id);
  const successorDependencyIds = dependencyGraph.getSuccessorEdgeIds(element.id);
  const { resolvedElement, invokedConstraints } = dependencyResolver.resolvePredecessors(
    scheduledElement,
    predecessorDependencyIds
  );
  scheduledElement.startDate = resolvedElement.startDate;
  scheduledElement.endDate = resolvedElement.endDate;
  invokedConstraints.forEach((invokedConstraint, dependencyId) => {
    dependencyStore.setInvokedConstraint(dependencyId, invokedConstraint);
  });
  const { propagations } = dependencyResolver.resolveSuccessors(
    scheduledElement,
    successorDependencyIds
  );
  propagations.forEach((propagation, dependencyId) => {
    dependencyStore.setPropagation(dependencyId, propagation);
  });
  return scheduledElement;
}
function getMinimalToBeScheduledElementIds(artifacts) {
  const ids = /* @__PURE__ */ new Set();
  const { elementStore } = artifacts;
  elementStore.getChanged().forEach((element) => {
    ids.add(element.id);
  });
  return ids;
}
function getOptimisticToBeScheduledElementIds(artifacts) {
  const ids = /* @__PURE__ */ new Set();
  const { elementStore, calendarStore, dependencyStore } = artifacts;
  elementStore.getChanged().forEach((element) => {
    ids.add(element.id);
  });
  dependencyStore.getChanged().forEach((dependency) => {
    ids.add(dependency.from.id);
    ids.add(dependency.to.id);
  });
  calendarStore.getChanged().forEach((calendar) => {
    elementStore.getElementIdsWithCalendar(calendar.id).forEach((elementId) => {
      const predecessors = artifacts.dependencyGraph.getPredecessors(elementId);
      const successors = artifacts.dependencyGraph.getSuccessors(elementId);
      [...predecessors, ...successors, elementId].forEach((id) => {
        ids.add(id);
      });
    });
  });
  return ids;
}
function getElementChanges(element, scheduledElement) {
  const changes = {
    id: element.id,
    entity: element.entity
  };
  if (!isEqual(scheduledElement.startDate, element.startDate)) {
    changes.startDate = scheduledElement.startDate;
  }
  if (!isEqual(scheduledElement.endDate, element.endDate)) {
    changes.endDate = scheduledElement.endDate;
  }
  return Object.keys(changes).length > 2 ? changes : null;
}

// src/core/scheduling.ts
function getSchedulingFunction() {
  return (artifacts, context, options) => {
    artifacts.performanceTracker.startCustomTrack("scheduleElements");
    scheduleElements(artifacts, context, options);
    artifacts.performanceTracker.stopCustomTrack("scheduleElements");
    artifacts.performanceTracker.startCustomTrack("scheduleDependencies");
    scheduleDependencies(artifacts, options);
    artifacts.performanceTracker.stopCustomTrack("scheduleDependencies");
  };
}

// src/core/engine/engine.ts
var SchedulingEngine = class {
  state = {};
  artifacts = {};
  optimistic;
  cache;
  debug;
  stateless;
  minimal;
  enforceValidDates;
  _isInitialized = false;
  constructor({
    optimistic = true,
    cache = true,
    debug = false,
    stateless = false,
    minimal = false,
    enforceValidDates = false
  } = {}) {
    this.optimistic = optimistic;
    this.cache = cache;
    this.debug = debug;
    this.stateless = stateless;
    this.minimal = minimal;
    this.enforceValidDates = enforceValidDates;
    this.artifacts.performanceTracker = new PerformanceTracker("CustomTracks", debug);
    this.artifacts.performanceTracker.register(this);
  }
  get isInitialized() {
    return this._isInitialized;
  }
  /**
   * Initializes the engine with the given state.
   * @param state
   */
  initialize(state) {
    this.state = state;
    const options = this.getOptions();
    this.artifacts.performanceTracker.startCustomTrack("artifactsBuildingFunction");
    this.artifacts = this.artifactsBuildingFunction(
      this.state,
      {},
      {
        performanceTracker: this.artifacts.performanceTracker
      },
      options
    );
    this.artifacts.performanceTracker.stopCustomTrack("artifactsBuildingFunction");
    this.registerArtifactsForTracking(this.artifacts);
    this._isInitialized = true;
  }
  /**
   * Resets the engine to its initial state.
   */
  reset() {
    this.state = {};
    this.artifacts = {
      performanceTracker: new PerformanceTracker("CustomTracks", this.debug)
    };
    this.artifacts.performanceTracker.register(this);
    this._isInitialized = false;
  }
  /**
   * Rebases the engine based on another engine instance. This method is used to rebase the
   * state and artifacts according to this other engine.
   * @param engine
   * @returns
   */
  rebase(engine) {
    if (!engine._isInitialized) {
      throw new SchedulingEngineNotInitializedError();
    }
    const options = this.getOptions();
    const state = engine.getState();
    const artifacts = engine.getArtifacts();
    this.state = (0, import_lodash3.cloneDeep)(state);
    this.artifacts.performanceTracker.startCustomTrack("artifactsBuildingFunction");
    this.artifacts = this.artifactsBuildingFunction(
      this.state,
      {},
      {
        ...artifacts,
        performanceTracker: this.artifacts.performanceTracker
      },
      options
    );
    this.artifacts.performanceTracker.stopCustomTrack("artifactsBuildingFunction");
    this.registerArtifactsForTracking(this.artifacts);
    this._isInitialized = true;
  }
  /**
   * Returns a deep copy of the engine instance.
   * @returns
   */
  copy() {
    const engine = new this.constructor();
    engine.rebase(this);
    return engine;
  }
  /**
   * Detects changes between the state of this engine and another engine instance.
   * The returned changes correspond to changes that would need to be applied to the current engine
   * to get to the state of the given engine.
   * @param engine
   * @returns
   */
  diff(engine) {
    if (!engine._isInitialized) {
      throw new SchedulingEngineNotInitializedError();
    }
    const myStateMap = this.artifacts.stateMap;
    const otherStateMap = engine.getArtifacts().stateMap;
    const added = {};
    const updated = {};
    const deleted = {};
    Object.keys(this.state).forEach((key) => {
      const myIds = [...myStateMap[key].keys()];
      const otherIds = [...otherStateMap[key].keys()];
      const addedIds = [...difference(new Set(otherIds), new Set(myIds))];
      const deletedIds = [...difference(new Set(myIds), new Set(otherIds))];
      const commonIds = [...intersection(new Set(myIds), new Set(otherIds))];
      const addedValues = addedIds.map(
        (id) => otherStateMap[key].get(id)
      );
      const deletedValues = deletedIds.map(
        (id) => myStateMap[key].get(id)
      );
      const updatedValues = commonIds.map((id) => {
        const myValue = myStateMap[key].get(id);
        const otherValue = otherStateMap[key].get(id);
        const divergingKeys = findDivergingKeys(myValue, otherValue);
        if (!divergingKeys.length) {
          return void 0;
        }
        return {
          id,
          ...Object.fromEntries(divergingKeys.map((k) => [k, otherValue[k]]))
        };
      }).filter(Boolean);
      if (addedValues.length) {
        added[key] = addedValues;
      }
      if (updatedValues.length) {
        updated[key] = updatedValues;
      }
      if (deletedValues.length) {
        deleted[key] = deletedValues;
      }
    });
    return {
      ...Object.keys(added).length ? { add: added } : {},
      ...Object.keys(updated).length ? { update: updated } : {},
      ...Object.keys(deleted).length ? { delete: deleted } : {}
    };
  }
  /**
   * Applies changes directly to the state without scheduling. This method is used to apply changes
   * of previously scheduled entities to the state without recomputing the scheduling (e.g., if stateless scheduling has been performed).
   * It should not be used without a previous scheduling process.
   * @param changes
   */
  commit(changes) {
    if (!this._isInitialized) {
      throw new SchedulingEngineNotInitializedError();
    }
    const options = this.getOptions();
    this.state = Object.entries(this.state).reduce((acc, [key, value]) => {
      const patch = patchArray(value, {
        added: new Map(changes.add?.[key]?.map((item) => [item.id, item])),
        updated: new Map(changes.update?.[key]?.map((item) => [item.id, item])),
        deleted: new Map(changes.delete?.[key]?.map((item) => [item.id, item]))
      });
      acc[key] = patch;
      return acc;
    }, {});
    this.artifacts.performanceTracker.startCustomTrack("artifactsBuildingFunction");
    this.artifacts = this.artifactsBuildingFunction(this.state, changes, this.artifacts, options);
    this.artifacts.elementStore.commit();
    this.artifacts.dependencyStore.commit();
    this.artifacts.calendarStore.commit();
    this.artifacts.performanceTracker.stopCustomTrack("artifactsBuildingFunction");
    this.registerArtifactsForTracking(this.artifacts);
  }
  /**
   * Schedules the elements based on the given changes and returns the new state and changes.
   * If the engine is NOT stateless, the state and artifacts are automatically updated after scheduling.
   * @param changes
   * @param tmpOptions
   * @returns
   */
  schedule(changes, context = {}, tmpOptions = {}) {
    if (!this._isInitialized) {
      throw new SchedulingEngineNotInitializedError();
    }
    const options = { ...this.getOptions(), ...tmpOptions };
    this.artifacts.performanceTracker.startCustomTrack("artifactsBuildingFunction");
    const artifacts = this.artifactsBuildingFunction(
      this.state,
      changes,
      this.copyArtifacts(this.artifacts),
      options
    );
    this.artifacts.performanceTracker.stopCustomTrack("artifactsBuildingFunction");
    this.registerArtifactsForTracking(artifacts);
    this.artifacts.performanceTracker.startCustomTrack("schedulingFunction");
    try {
      this.schedulingFunction(artifacts, context, options);
    } catch (error) {
      this.resetArtifacts(artifacts);
      throw error;
    }
    this.artifacts.performanceTracker.stopCustomTrack("schedulingFunction");
    this.artifacts.performanceTracker.startCustomTrack("resultReadingFunction");
    const result = this.resultReadingFunction(this.state, changes, artifacts, options);
    this.artifacts.performanceTracker.stopCustomTrack("resultReadingFunction");
    if (!options.stateless) {
      this.state = result.state;
      this.artifacts = artifacts;
      this.artifacts.stateMap = patchStateMap(this.artifacts.stateMap, result.changes);
      this.commitArtifacts(this.artifacts);
    } else {
      this.resetArtifacts(this.artifacts);
    }
    return result;
  }
  /**
   * Shifts all elements of the schedule based on a given anchor date. The anchor date will be used as the start date of
   * the element that previously was the earliest element in the schedule. All remaining elements will be shifted accordingly
   * to keep the relative distances between them.
   * This method is always stateless. The returned changes can be commited to the state using the commit method. After
   * the shifting a final scheduling round is performed to make sure the complete state is valid.
   * @param anchorDate
   */
  shift(anchorDate) {
    if (!this._isInitialized) {
      throw new SchedulingEngineNotInitializedError();
    }
    const options = {
      ...this.getOptions(),
      stateless: true
    };
    const artifacts = this.copyArtifacts(this.artifacts, { force: true });
    const elements = [...artifacts.elementStore.getState().values()];
    const anchorElement = elements.reduce((acc, element) => {
      if (!acc || isBefore(element.startDate, acc.startDate)) {
        return element;
      }
      return acc;
    }, null);
    if (!anchorElement) {
      return {
        state: this.state,
        changes: {},
        meta: {
          invokedConstraints: []
        }
      };
    }
    elements.forEach((element) => {
      const calendar = element.calendarId ? artifacts.calendarStore.getLatestManager(element.calendarId) : null;
      const originalDeltaToAnchor = calculateDelta(
        anchorElement.startDate,
        element.startDate,
        calendar
      );
      const newStartDate = calculateStartDate(anchorDate, originalDeltaToAnchor, calendar);
      const newEndDate = calculateEndDate(newStartDate, element.duration, calendar);
      if (!isEqual(newStartDate, element.startDate) || !isEqual(newEndDate, element.endDate)) {
        artifacts.elementStore.setLatest({
          id: element.id,
          entity: element.entity,
          startDate: newStartDate,
          endDate: newEndDate
        });
      }
    });
    this.schedulingFunction(artifacts, {}, { ...options, enforceValidDates: true });
    const result = this.resultReadingFunction(this.state, {}, artifacts, options);
    return result;
  }
  /**
   * Amend the scheduling state with another given partial state. This method is used to apply changes to the
   * scheduling state without recomputing the scheduling. This only works for properties of the entities that are
   * unrelated to the scheduling process. It takes a list of ids per entity type and a partial state object
   * that is used to amend the entity by index position.
   */
  amend(entityIds, entityAmendments) {
    if (!this._isInitialized) {
      throw new SchedulingEngineNotInitializedError();
    }
    const options = this.getOptions();
    Object.entries(entityIds).forEach(([entityKey, ids]) => {
      const entityIndices = new Map(this.state[entityKey].map((item, idx) => [item.id, idx]));
      ids?.forEach((id, idx) => {
        if (!entityAmendments[entityKey] || idx >= entityAmendments[entityKey].length) {
          return;
        }
        const amendments = entityAmendments[entityKey][idx];
        const entityIdx = entityIndices.get(id);
        if (entityIdx === void 0) {
          return;
        }
        this.state[entityKey][entityIdx] = {
          ...this.state[entityKey][entityIdx],
          ...amendments
        };
      });
    });
    this.artifacts = this.artifactsBuildingFunction(
      this.state,
      {},
      {
        performanceTracker: this.artifacts.performanceTracker
      },
      options
    );
  }
  getState() {
    return (0, import_lodash3.cloneDeep)(this.state);
  }
  getArtifacts() {
    return this.copyArtifacts(this.artifacts, { force: true });
  }
  getOptions() {
    return {
      optimistic: this.optimistic,
      debug: this.debug,
      cache: this.cache,
      stateless: this.stateless,
      minimal: this.minimal,
      enforceValidDates: this.enforceValidDates,
      rebuildArtifacts: {
        calendarStore: true,
        dependencyGraph: true,
        dependencyStore: true,
        elementStore: true,
        permissionStore: true,
        stateMap: true,
        changesMap: true
      }
    };
  }
  copyArtifacts(artifacts, { force = false } = {}) {
    this.artifacts.performanceTracker.startCustomTrack("copyStateMap");
    const stateMap = copyStateMap(artifacts.stateMap);
    this.artifacts.performanceTracker.stopCustomTrack("copyStateMap");
    return {
      // Stores have dedicated commit and reset methods and should usually not be copied as a whole
      calendarStore: force ? artifacts.calendarStore.copy() : artifacts.calendarStore,
      dependencyStore: force ? artifacts.dependencyStore.copy() : artifacts.dependencyStore,
      elementStore: force ? artifacts.elementStore.copy() : artifacts.elementStore,
      permissionStore: force ? artifacts.permissionStore.copy() : artifacts.permissionStore,
      dependencyGraph: artifacts.dependencyGraph.copy(),
      stateMap,
      changesMap: artifacts.changesMap,
      performanceTracker: artifacts.performanceTracker
    };
  }
  commitArtifacts(artifacts) {
    artifacts.calendarStore.commit();
    artifacts.dependencyStore.commit();
    artifacts.elementStore.commit();
    artifacts.permissionStore.commit();
  }
  resetArtifacts(artifacts) {
    artifacts.calendarStore.reset();
    artifacts.dependencyStore.reset();
    artifacts.elementStore.reset();
    artifacts.permissionStore.reset();
  }
  registerArtifactsForTracking(artifacts) {
    if (!this.debug) {
      return;
    }
    artifacts.calendarStore.getAllIds().forEach((calendarId) => {
      const manager = artifacts.calendarStore.getLatestManager(calendarId);
      artifacts.performanceTracker.register(manager);
      manager.intervals.forEach((interval) => {
        artifacts.performanceTracker.register(interval);
      });
    });
    artifacts.performanceTracker.register(artifacts.calendarStore);
    artifacts.performanceTracker.register(artifacts.dependencyGraph);
    artifacts.performanceTracker.register(artifacts.dependencyStore);
    artifacts.performanceTracker.register(artifacts.elementStore);
    artifacts.performanceTracker.register(artifacts.permissionStore);
    artifacts.performanceTracker.register(this.utils);
  }
  logDebugEvaluation(name) {
    if (!this.debug) {
      console.log("Engine is not in debug mode.");
      return;
    }
    const mainText = `Scheduling Engine Debug Evaluation for ${name}`;
    console.log(`*** Start of ${mainText} *** `);
    this.artifacts.performanceTracker.logEvaluation();
    console.log(`*** End of ${mainText} *** `);
  }
};

// src/common/utils/maps.ts
function transformMap(map, transform) {
  const transformedMap = /* @__PURE__ */ new Map();
  const transformedItems = transform(Array.from(map?.values() ?? []));
  transformedItems.forEach((item) => {
    transformedMap.set(item.id, item);
  });
  return transformedMap;
}
function mergeMaps(mapA, mapB) {
  const mergedMap = /* @__PURE__ */ new Map();
  mapA?.forEach((value, key) => {
    mergedMap.set(key, value);
  });
  mapB?.forEach((value, key) => {
    mergedMap.set(key, value);
  });
  return mergedMap;
}
function pickMapItems(ids, array) {
  const idSet = new Set(ids);
  return new Map(array.filter((item) => idSet.has(item.id)).map((item) => [item.id, item]));
}

// src/scheduleOrders/calendars/transform.ts
function orderCalendarsToCalendars(calendars, pauses) {
  const pauseExceptions = pauses.map((p) => {
    return {
      startAt: p.start,
      finishAt: p.end,
      isWorkingDay: false,
      workingTimes: [{ from: "00:00", to: "00:00" }]
    };
  });
  return calendars.map((c) => {
    return {
      ...c,
      exceptions: [
        ...c.exceptions.map((e) => ({
          ...e,
          workingTimes: e.workingTimes ?? [{ from: "00:00", to: "00:00" }]
        })),
        ...pauseExceptions
      ]
    };
  });
}

// src/scheduleOrders/contributorGroups/transform.ts
function contributorGroupsToUserGroups(contributorGroups) {
  return contributorGroups.map((g) => {
    return {
      id: g.id,
      isAdmin: g.isTenantOwnerGroup,
      members: g.memberships.map((m) => ({
        user: m.user,
        permission: m.permission === "EDITOR" ? "write" /* WRITE */ : "read" /* READ */
      }))
    };
  });
}

// src/scheduleOrders/milestones/transform.ts
function milestonesToElements(milestones, milestonesMap) {
  if (!milestones) return [];
  return milestones.map((m) => {
    const element = {
      id: m.id,
      entity: "MILESTONE" /* MILESTONE */,
      duration: 0
    };
    if (m.contributorGroup?.id !== void 0) element.groupId = m.contributorGroup.id;
    if (m.date !== void 0) {
      element.startDate = m.date;
      element.endDate = m.date;
    }
    if (m.isFixed !== void 0 || m.completedAt !== void 0) {
      const baseMilestone = milestonesMap?.get(m.id);
      const isFixed = m.isFixed ?? baseMilestone?.isFixed;
      const completedAt = m.completedAt ?? baseMilestone?.completedAt;
      element.isFixed = isFixed || !!completedAt;
    }
    return element;
  });
}
function elementsToMilestones(elements, milestoneMap) {
  return elements.map((element) => {
    const baseMilestone = milestoneMap?.get(element.id) ?? { id: element.id };
    const transformedMilestone = { ...baseMilestone };
    if (element.startDate !== void 0) transformedMilestone.date = element.startDate;
    return transformedMilestone;
  });
}

// src/scheduleOrders/orderDependencies/transform.ts
function orderDependenciesToDependencies(orderDependencies) {
  if (!orderDependencies) return [];
  return orderDependencies.map((d) => {
    const dependency = {
      id: d.id
    };
    if (d.from !== void 0) dependency.from = d.from;
    if (d.to !== void 0) dependency.to = d.to;
    if (d.type !== void 0) dependency.type = d.type;
    if (d.lagInMinutes !== void 0) dependency.lag = d.lagInMinutes;
    if (d.bufferInMinutes !== void 0) dependency.buffer = d.bufferInMinutes;
    if (d.useDryingBreak !== void 0) dependency.useSourceEndOffset = d.useDryingBreak;
    if (d.isViolated !== void 0) dependency.isViolated = d.isViolated;
    return dependency;
  });
}
function dependenciesToOrderDependencies(dependencies, dependencyMap) {
  return dependencies.map((dependency) => {
    const baseDependency = dependencyMap?.get(dependency.id) ?? { id: dependency.id };
    const transformedDependency = {
      ...baseDependency
    };
    if (dependency.buffer !== void 0) transformedDependency.bufferInMinutes = dependency.buffer;
    if (dependency.lag !== void 0) transformedDependency.lagInMinutes = dependency.lag;
    if (dependency.useSourceEndOffset !== void 0) {
      transformedDependency.useDryingBreak = dependency.useSourceEndOffset;
    }
    if (dependency.isViolated !== void 0) {
      transformedDependency.isViolated = dependency.isViolated;
    }
    return transformedDependency;
  });
}

// src/scheduleOrders/orders/transform.ts
function ordersToElements(orders, ordersMap) {
  if (!orders) return [];
  return orders.map((o) => {
    const element = {
      id: o.id,
      entity: "ORDER" /* ORDER */
    };
    if (o.startAt !== void 0) element.startDate = o.startAt;
    if (o.finishAt !== void 0) element.endDate = o.finishAt;
    if (o.duration !== void 0) element.duration = o.duration;
    if (o.calendar?.id !== void 0) element.calendarId = o.calendar.id;
    if (o.dryingBreak !== void 0) element.endOffset = o.dryingBreak?.duration ?? 0;
    if (o.contributorGroup?.id !== void 0) element.groupId = o.contributorGroup.id;
    if (o.isFixed !== void 0 || o.status !== void 0) {
      const baseOrder = ordersMap?.get(o.id);
      const isFixed = o.isFixed ?? baseOrder?.isFixed;
      const status = o.status ?? baseOrder?.status;
      element.isFixed = isFixed || !!status && ["DONE" /* DONE */, "REPORTED_DONE" /* REPORTED_DONE */].includes(status);
    }
    return element;
  });
}
function elementsToOrders(elements, orderMap) {
  return elements.map((element) => {
    const baseOrder = orderMap?.get(element.id) ?? { id: element.id };
    const transformedOrder = { ...baseOrder };
    if (element.startDate !== void 0) transformedOrder.startAt = element.startDate;
    if (element.endDate !== void 0) transformedOrder.finishAt = element.endDate;
    return transformedOrder;
  });
}

// src/scheduleOrders/artifacts.ts
function buildElementStore(stateMap, changesMap) {
  const orderState = transformMap(stateMap.orders, (o) => ordersToElements(o));
  const milestoneState = transformMap(stateMap.milestones, (m) => milestonesToElements(m));
  return patchElementStore(
    new ElementStore(mergeMaps(orderState, milestoneState)),
    stateMap,
    changesMap
  );
}
function patchElementStore(elementStore, stateMap, changesMap) {
  const ordersAdded = transformMap(changesMap.add?.orders, (o) => ordersToElements(o));
  const milestonesAdded = transformMap(changesMap.add?.milestones, (m) => milestonesToElements(m));
  const ordersUpdated = transformMap(
    changesMap.update?.orders,
    (o) => ordersToElements(o, stateMap.orders)
  );
  const milestonesUpdated = transformMap(
    changesMap.update?.milestones,
    (m) => milestonesToElements(m, stateMap.milestones)
  );
  return elementStore.patch({
    added: mergeMaps(ordersAdded, milestonesAdded),
    updated: mergeMaps(ordersUpdated, milestonesUpdated),
    deleted: mergeMaps(changesMap.delete?.orders, changesMap.delete?.milestones)
  });
}
function buildDependencyStore(stateMap, changesMap) {
  const dependencyState = transformMap(
    stateMap.dependencies,
    (d) => orderDependenciesToDependencies(d)
  );
  return patchDependencyStore(new DependencyStore(dependencyState), changesMap);
}
function patchDependencyStore(dependencyStore, changesMap) {
  const dependencyAdded = transformMap(
    changesMap.add?.dependencies,
    (d) => orderDependenciesToDependencies(d)
  );
  const dependencyUpdated = transformMap(
    changesMap.update?.dependencies,
    (d) => orderDependenciesToDependencies(d)
  );
  return dependencyStore.patch({
    added: dependencyAdded,
    updated: dependencyUpdated,
    deleted: changesMap.delete?.dependencies
  });
}
function buildDependencyGraph(stateMap) {
  const nodes = mergeMaps(stateMap.orders, stateMap.milestones);
  const edges = stateMap.dependencies;
  return new DependencyGraph(nodes, edges);
}
function patchDependencyGraph(dependencyGraph, changesMap) {
  const nodesAdded = mergeMaps(changesMap.add?.orders, changesMap.add?.milestones);
  const nodesDeleted = mergeMaps(changesMap.delete?.orders, changesMap.delete?.milestones);
  const edgesAdded = changesMap.add?.dependencies;
  const edgesDeleted = changesMap.delete?.dependencies;
  return dependencyGraph.patch(
    {
      added: nodesAdded,
      deleted: nodesDeleted
    },
    {
      added: edgesAdded,
      deleted: edgesDeleted
    }
  );
}
function getUpdatedCalendars(stateMap, changesMap) {
  const updatedCalendars = /* @__PURE__ */ new Map();
  if (changesMap.update?.calendars?.size) {
    changesMap.update.calendars.forEach((partialCalendar) => {
      const currentCalendar = stateMap.calendars.get(partialCalendar.id);
      if (!currentCalendar) {
        throw new EntityNotFoundError("Calendar", partialCalendar.id);
      }
      const calendar = {
        ...currentCalendar,
        ...partialCalendar
      };
      updatedCalendars.set(calendar.id, calendar);
    });
  }
  if (changesMap.add?.pauses?.size || changesMap.update?.pauses?.size || changesMap.delete?.pauses?.size) {
    stateMap.calendars.forEach((calendar) => {
      updatedCalendars.set(calendar.id, calendar);
    });
  }
  return updatedCalendars;
}
function buildCalendarStore(stateMap, changesMap, options) {
  const calendarState = transformMap(
    stateMap.calendars,
    (calendars) => orderCalendarsToCalendars(calendars, Array.from(stateMap.pauses.values()))
  );
  return patchCalendarStore(new CalendarStore(calendarState, options.cache), stateMap, changesMap);
}
function patchCalendarStore(calendarStore, stateMap, changesMap) {
  const calendarsAdded = transformMap(
    changesMap.add?.calendars,
    (calendars) => orderCalendarsToCalendars(calendars, Array.from(stateMap.pauses.values()))
  );
  const calendarsUpdated = transformMap(
    getUpdatedCalendars(stateMap, changesMap),
    (calendars) => orderCalendarsToCalendars(calendars, Array.from(stateMap.pauses.values()))
  );
  return calendarStore.patch({
    added: calendarsAdded,
    updated: calendarsUpdated,
    deleted: changesMap.delete?.calendars
  });
}
function buildPermissionStore(stateMap, changesMap) {
  const contributorGroupsState = transformMap(
    stateMap.contributorGroups,
    (contributorGroups) => contributorGroupsToUserGroups(contributorGroups)
  );
  return patchPermissionStore(new PermissionStore(contributorGroupsState), stateMap, changesMap);
}
function patchPermissionStore(permissionStore, stateMap, changesMap) {
  const permissionsAdded = transformMap(
    changesMap.add?.contributorGroups,
    (contributorGroups) => contributorGroupsToUserGroups(contributorGroups)
  );
  const permissionsUpdated = transformMap(
    changesMap.update?.contributorGroups,
    (contributorGroups) => contributorGroupsToUserGroups(
      contributorGroups.map((g) => ({
        ...stateMap.contributorGroups.get(g.id),
        ...g
      }))
    )
  );
  return permissionStore.patch({
    added: permissionsAdded,
    updated: permissionsUpdated,
    deleted: changesMap.delete?.contributorGroups
  });
}

// src/scheduleOrders/results.ts
function transformResults(state, changes, stateMap, changesMap, elements, dependencies) {
  const addedOrders = transformMap(
    elements.added,
    (e) => elementsToOrders(
      e.filter((element) => element.entity === "ORDER" /* ORDER */),
      changesMap.add?.orders
    )
  );
  const addedMilestones = transformMap(
    elements.added,
    (e) => elementsToMilestones(
      e.filter((element) => element.entity === "MILESTONE" /* MILESTONE */),
      changesMap.add?.milestones
    )
  );
  const addedDependencies = transformMap(
    dependencies.added,
    (d) => dependenciesToOrderDependencies(d, changesMap.add?.dependencies)
  );
  const updatedOrders = transformMap(
    elements.updated,
    (e) => elementsToOrders(
      e.filter((element) => element.entity === "ORDER" /* ORDER */),
      changesMap.update?.orders
    )
  );
  const updatedMilestones = transformMap(
    elements.updated,
    (e) => elementsToMilestones(
      e.filter((element) => element.entity === "MILESTONE" /* MILESTONE */),
      changesMap.update?.milestones
    )
  );
  const updatedDependencies = transformMap(
    dependencies.updated,
    (d) => dependenciesToOrderDependencies(d, changesMap.update?.dependencies)
  );
  return {
    state: {
      orders: patchArray(state.orders, {
        added: addedOrders,
        updated: updatedOrders,
        deleted: changesMap.delete?.orders
      }),
      milestones: patchArray(state.milestones, {
        added: addedMilestones,
        updated: updatedMilestones,
        deleted: changesMap.delete?.milestones
      }),
      dependencies: patchArray(state.dependencies, {
        added: addedDependencies,
        updated: updatedDependencies,
        deleted: changesMap.delete?.dependencies
      }),
      pauses: Array.from(stateMap.pauses.values()),
      calendars: Array.from(stateMap.calendars.values()),
      contributorGroups: Array.from(stateMap.contributorGroups.values())
    },
    changes: {
      ...changes,
      add: {
        ...changes.add,
        orders: Array.from(addedOrders.values()),
        milestones: Array.from(addedMilestones.values()),
        dependencies: Array.from(addedDependencies.values())
      },
      update: {
        ...changes.update,
        orders: Array.from(updatedOrders.values()),
        milestones: Array.from(updatedMilestones.values()),
        dependencies: Array.from(updatedDependencies.values())
      }
    }
  };
}

// src/scheduleOrders/engine.ts
var OrderSchedulingEngine = class extends SchedulingEngine {
  schedulingFunction = getSchedulingFunction();
  resultReadingFunction = getResultReadingFunction(transformResults);
  artifactsBuildingFunction = getArtifactsBuildingFunction({
    buildDependencyGraph,
    patchDependencyGraph,
    buildCalendarStore,
    patchCalendarStore,
    buildDependencyStore,
    patchDependencyStore,
    buildElementStore,
    patchElementStore,
    buildPermissionStore,
    patchPermissionStore
  });
  utils = new OrderSchedulingEngineUtils(
    () => this.state,
    () => this.artifacts
  );
  copy() {
    return super.copy();
  }
  initialize(state) {
    const pauseMap = new Map(state.pauses.map((pause) => [pause.id, pause]));
    const calendarMap = new Map(state.calendars.map((calendar) => [calendar.id, calendar]));
    this.artifacts.calendarStore = buildCalendarStore(
      {
        pauses: pauseMap,
        calendars: calendarMap
      },
      {},
      this.getOptions()
    );
    const elements = [
      ...ordersToElements(state.orders),
      ...milestonesToElements(state.milestones)
    ];
    const computedState = {
      ...state,
      orders: this.computeOrderDurations(state.orders),
      dependencies: this.computeOrderDependencyViolations(
        state.dependencies,
        new Map(elements.map((element) => [element.id, element]))
      )
    };
    super.initialize(computedState);
    return computedState;
  }
  schedule(changes, context = {}, options = {}) {
    const stateMapCopy = copyStateMap(this.artifacts.stateMap);
    this.artifacts.calendarStore = patchCalendarStore(
      this.artifacts.calendarStore,
      patchStateMap(stateMapCopy, {
        add: { pauses: changes.add?.pauses ?? [], calendars: changes.add?.calendars ?? [] },
        update: {
          pauses: changes.update?.pauses ?? [],
          calendars: changes.update?.calendars ?? []
        },
        delete: {
          pauses: changes.delete?.pauses ?? [],
          calendars: changes.delete?.calendars ?? []
        }
      }),
      buildChangesMap(changes)
    );
    return super.schedule(
      {
        ...changes,
        add: {
          ...changes.add,
          ...changes.add?.orders ? { orders: this.computeOrderDurations(changes.add.orders, stateMapCopy) } : {},
          ...changes.add?.dependencies ? {
            // The isViolated flag will be computed during scheduling, we just set it to false in the beginning
            dependencies: changes.add.dependencies.map((dependency) => ({
              ...dependency,
              isViolated: false
            }))
          } : {}
        },
        update: {
          ...changes.update,
          ...changes.update?.orders ? { orders: this.computeOrderDurations(changes.update.orders, stateMapCopy) } : {}
        }
      },
      context,
      {
        ...this.getOptions(),
        ...options,
        rebuildArtifacts: {
          ...this.getOptions().rebuildArtifacts,
          ...options.rebuildArtifacts,
          calendarStore: false
        }
      }
    );
  }
  commit(changes) {
    const stateMapCopy = copyStateMap(this.artifacts.stateMap);
    this.artifacts.calendarStore = patchCalendarStore(
      this.artifacts.calendarStore,
      patchStateMap(stateMapCopy, {
        add: { pauses: changes.add?.pauses ?? [], calendars: changes.add?.calendars ?? [] },
        update: {
          pauses: changes.update?.pauses ?? [],
          calendars: changes.update?.calendars ?? []
        },
        delete: {
          pauses: changes.delete?.pauses ?? [],
          calendars: changes.delete?.calendars ?? []
        }
      }),
      buildChangesMap(changes)
    );
    super.commit({
      ...changes,
      add: {
        ...changes.add,
        ...changes.add?.orders ? { orders: this.computeOrderDurations(changes.add.orders, stateMapCopy) } : {},
        ...changes.add?.dependencies ? {
          // The isViolated flag was computed during previous scheduling, so we know it's there
          dependencies: changes.add.dependencies.map((dependency) => ({
            ...dependency,
            isViolated: dependency.isViolated
          }))
        } : {}
      },
      update: {
        ...changes.update,
        ...changes.update?.orders ? { orders: this.computeOrderDurations(changes.update.orders, stateMapCopy) } : {}
      }
    });
  }
  amend(entityIds, entityAmendments) {
    const filteredAmendments = Object.entries(entityAmendments).reduce((acc, [entityKey, amendments]) => {
      if (entityKey === "orders") {
        acc[entityKey] = amendments.map(
          (a) => omitKeys(a, ["startAt", "finishAt", "calendar", "dryingBreak", "isFixed", "status"])
        );
      } else if (entityKey === "milestones") {
        acc[entityKey] = amendments.map((a) => omitKeys(a, ["date", "isFixed", "completedAt"]));
      } else if (entityKey === "pauses") {
        acc[entityKey] = amendments.map(
          (a) => omitKeys(a, ["start", "end"])
        );
      } else if (entityKey === "dependencies") {
        acc[entityKey] = amendments.map(
          (a) => omitKeys(a, ["lagInMinutes", "bufferInMinutes", "useDryingBreak", "type", "isViolated"])
        );
      } else if (entityKey === "calendars") {
        acc[entityKey] = amendments.map((a) => omitKeys(a, ["workingDays", "exceptions"]));
      } else {
        acc[entityKey] = amendments;
      }
      return acc;
    }, {});
    super.amend(entityIds, filteredAmendments);
  }
  computeOrderDurations(orders, stateMap) {
    return orders.map((order) => {
      if ("duration" in order && order.duration !== void 0) {
        if (order.duration <= 0) {
          throw new InvalidElementDurationError(order.id, order.duration, "order");
        }
        return order;
      }
      if (!order.startAt && !order.finishAt) {
        return order;
      }
      const partialOrder = omitUndefinedKeys(order);
      const previousOrder = stateMap ? stateMap.orders.get(order.id) : null;
      const enrichedOrder = {
        ...previousOrder,
        ...partialOrder
      };
      if (!enrichedOrder.finishAt || !enrichedOrder.startAt || !enrichedOrder.calendar) {
        throw new UndefinedElementDatesError("order", partialOrder.id);
      }
      let newDuration = this.utils.computeWorkingTimeBetween(
        enrichedOrder.finishAt,
        enrichedOrder.startAt,
        enrichedOrder.calendar.id
      );
      newDuration = newDuration <= 0 ? generateDuration(1) : newDuration;
      return {
        ...partialOrder,
        ...newDuration !== previousOrder?.duration ? { duration: newDuration } : {}
      };
    });
  }
  computeOrderDependencyViolations(orderDependencies, elementsMap) {
    return orderDependencies.map((orderDependency) => {
      const { from, to } = orderDependency;
      const source = elementsMap.get(from.id);
      const target = elementsMap.get(to.id);
      if (!source || !target) {
        return {
          ...orderDependency,
          isViolated: false
        };
      }
      const [dependency] = orderDependenciesToDependencies([
        orderDependency
      ]);
      const calendarId = getDependencyCalendarId(source, target);
      const calendarManager = calendarId ? this.artifacts.calendarStore.getLatestManager(calendarId) : null;
      const isViolated = violatesConstraint(
        getTargetDate(target, dependency),
        getConstraintDate(source, dependency, calendarManager)
      );
      return {
        ...orderDependency,
        isViolated
      };
    });
  }
};
var OrderSchedulingEngineUtils = class extends SchedulingEngineUtils {
  computeWorkingTimeBetween(endDate, startDate, calendarId, calendars = [], pauses = []) {
    return super.computeWorkingTimeBetween(
      endDate,
      startDate,
      this.getPotentiallyRecomputedCalendarManager(calendarId, calendars, pauses)
    );
  }
  isStartDateDuringWorkingTime(date, calendarId, calendars = [], pauses = []) {
    return super.isStartDateDuringWorkingTime(
      date,
      this.getPotentiallyRecomputedCalendarManager(calendarId, calendars, pauses)
    );
  }
  isEndDateDuringWorkingTime(date, calendarId, calendars = [], pauses = []) {
    return super.isEndDateDuringWorkingTime(
      date,
      this.getPotentiallyRecomputedCalendarManager(calendarId, calendars, pauses)
    );
  }
  getPotentiallyRecomputedCalendarManager(calendarId, calendars = [], pauses = []) {
    const state = this.getState();
    const updatedCalendar = calendars.find((c) => c.id === calendarId);
    const needsRecomputeOfCalendarManager = calendarId && (updatedCalendar || pauses.length > 0);
    if (needsRecomputeOfCalendarManager) {
      const previousCalendar = state.calendars.find((c) => c.id === calendarId);
      if (!previousCalendar) throw new EntityNotFoundError("Calendar", calendarId);
      const calendar = {
        ...previousCalendar,
        ...updatedCalendar || {}
      };
      const currentPauses = mergeArrays(state.pauses, pauses);
      const [schedulingCalendar] = orderCalendarsToCalendars([calendar], currentPauses);
      return new CalendarManager(schedulingCalendar);
    }
    return calendarId;
  }
};

// src/common/ids.ts
var import_pure_uuid = __toESM(require_uuid());
function generateId() {
  return new import_pure_uuid.default(4).format();
}
function generateOrderId() {
  return generateId();
}
function generateOrderTaskId() {
  return generateId();
}
function generateOrderDependencyId() {
  return generateId();
}
function generateTradeSequenceActivityId() {
  return generateId();
}
function generateTradeSequenceActivityDependencyId() {
  return generateId();
}

// src/scheduleOrdersFromTradeSequence/orders/utils.ts
function getDerivedEntities(orders, orderDependencies, activities, tasks, orderAssignments) {
  const ordersMap = new Map(orders.map((order) => [order.id, order]));
  const activityMap = new Map(
    activities.map((activity) => [activity.id, activity])
  );
  const derivedOrders = orders.filter(
    (order) => order.tradeSequenceActivity && activityMap.has(order.tradeSequenceActivity.id)
  );
  orderAssignments?.assignments.forEach((assignment) => {
    const order = ordersMap.get(assignment.orderId);
    if (!order || !activityMap.has(assignment.activityId)) return;
    derivedOrders.push({
      ...order,
      tradeSequenceActivity: { id: assignment.activityId },
      tradeSequenceInstanceId: orderAssignments.tradeSequenceInstanceId
    });
  });
  const derivedOrdersMap = new Map(derivedOrders.map((order) => [order.id, order]));
  const derivedOrderDependencies = orderDependencies.filter(
    (dependency) => derivedOrdersMap.get(dependency.from.id)?.tradeSequenceInstanceId === derivedOrdersMap.get(dependency.to.id)?.tradeSequenceInstanceId
  );
  const derivedEntitiesGroupedByInstanceId = /* @__PURE__ */ new Map();
  derivedOrders.forEach((order) => {
    const instanceId = order.tradeSequenceInstanceId;
    if (!instanceId) return;
    const enrichedOrder = {
      ...order,
      tasks: tasks?.[order.id] ?? []
    };
    if (!derivedEntitiesGroupedByInstanceId.has(instanceId)) {
      derivedEntitiesGroupedByInstanceId.set(instanceId, {
        derivedOrders: [enrichedOrder],
        derivedOrderDependencies: [],
        sectionId: order.wbsSection.id
      });
    } else {
      derivedEntitiesGroupedByInstanceId.get(instanceId)?.derivedOrders.push(enrichedOrder);
    }
  });
  derivedOrderDependencies.forEach((dependency) => {
    const instanceId = derivedOrdersMap.get(dependency.from.id)?.tradeSequenceInstanceId;
    if (!instanceId) return;
    derivedEntitiesGroupedByInstanceId.get(instanceId).derivedOrderDependencies.push(dependency);
  });
  return {
    all: {
      derivedOrders,
      derivedOrderDependencies
    },
    grouped: derivedEntitiesGroupedByInstanceId
  };
}
function getCrossInstanceDependencies(allDerivedOrders, allOrderDependencies) {
  const crossInstanceDependencies = [];
  const orderIdToInstanceId = /* @__PURE__ */ new Map();
  allDerivedOrders.forEach((order) => {
    orderIdToInstanceId.set(order.id, order.tradeSequenceInstanceId ?? null);
  });
  allOrderDependencies.forEach((dependency) => {
    const fromInstanceId = orderIdToInstanceId.get(dependency.from.id);
    const toInstanceId = orderIdToInstanceId.get(dependency.to.id);
    if (fromInstanceId && toInstanceId && fromInstanceId !== toInstanceId) {
      crossInstanceDependencies.push(dependency);
    }
  });
  return crossInstanceDependencies;
}
function computeReferenceDateFromDerivedOrders(derivedOrders, oldActivities) {
  if (!oldActivities?.length) {
    const earliestOrder = findEarliestOrder(derivedOrders);
    return { referenceDate: earliestOrder.startAt, referenceOffset: 0 };
  }
  const earliestOrderWithOffset = findEarliestOrderLinkedToValidOldActivity(
    derivedOrders,
    oldActivities
  );
  return {
    referenceDate: earliestOrderWithOffset.earliestOrder.startAt,
    referenceOffset: earliestOrderWithOffset.originalOffset
  };
}
function findEarliestOrder(orders) {
  return orders.reduce(
    (earliest, order) => isBefore(order.startAt, earliest.startAt) ? order : earliest
  );
}
function findEarliestOrderLinkedToValidOldActivity(orders, oldActivities) {
  const originalOffsetsMap = /* @__PURE__ */ new Map();
  oldActivities.forEach((activity) => {
    originalOffsetsMap.set(activity.id, activity.offset);
  });
  const earliestOrderWithItsOriginalOffset = orders.reduce((result, order) => {
    const offset = originalOffsetsMap.get(order.tradeSequenceActivity?.id ?? "");
    if (offset === void 0) {
      return result;
    }
    if (!result) {
      return { earliestOrder: order, originalOffset: offset };
    }
    return isBefore(order.startAt, result.earliestOrder.startAt) ? { earliestOrder: order, originalOffset: offset } : result;
  }, void 0);
  if (!earliestOrderWithItsOriginalOffset) {
    throw new NoOrderFoundInSequenceError();
  }
  return earliestOrderWithItsOriginalOffset;
}
function getIdMappingFromNewlyDerivedEntities(instanceId, addedOrders, addedOrderDependencies) {
  return {
    tradeSequenceInstanceId: instanceId,
    activityIdToOrderId: addedOrders.reduce((map, order) => {
      map[order.tradeSequenceActivity.id] = order.id;
      return map;
    }, {}),
    orderIdsToOrderDependencyId: addedOrderDependencies.map((dependency) => ({
      fromOrderId: dependency.from.id,
      toOrderId: dependency.to.id,
      dependencyId: dependency.id
    }))
  };
}

// src/scheduleOrdersFromTradeSequence/activities/reconstructions.ts
function constructActivitiesFromOrders(orders, params) {
  const { referenceDate, referenceOffset } = computeReferenceDateFromDerivedOrders(
    orders,
    params.oldActivities
  );
  return orders.map((order) => {
    const tasks = params.orderIdToTasksMapping?.[order.id] ?? order.tasks;
    return {
      id: order.tradeSequenceActivity?.id ?? params.orderIdToActivityIdMapping?.get(order.id) ?? generateTradeSequenceActivityId(),
      name: order.name,
      duration: order.duration,
      offset: params.engine.utils.computeWorkingTimeBetween(
        order.startAt,
        referenceDate,
        order.calendar.id
      ) + referenceOffset,
      tenantTradeVariation: order.tenantTradeVariation,
      taskTemplates: tasks?.map((task) => ({
        id: task.template ?? generateOrderTaskId(),
        name: task.name,
        sequenceNumber: task.sequenceNumber,
        description: task.description
      })) ?? [],
      dryingBreak: order.dryingBreak ?? null,
      estimatedWorkers: order.estimatedWorkers ?? null
    };
  });
}
function constructActivityDependenciesFromOrderDependencies(orderDependencies, params) {
  const lookups = params.lookups;
  if (!lookups) {
    if (!params.orderIdToActivityIdMapping) {
      throw new Error("Either pass lookups or orderIdToActivityIdMapping");
    }
  }
  return orderDependencies.map((dependency) => {
    const fromActivityId = lookups?.lookupOldActivity(dependency.from.id)?.id ?? params.orderIdToActivityIdMapping?.get(dependency.from.id);
    const toActivityId = lookups?.lookupOldActivity(dependency.to.id)?.id ?? params.orderIdToActivityIdMapping?.get(dependency.to.id);
    if (!fromActivityId || !toActivityId) {
      return void 0;
    }
    return {
      ...dependency,
      id: lookups?.lookupOldActivityDependency(dependency.id)?.id ?? generateTradeSequenceActivityDependencyId(),
      from: { id: fromActivityId },
      to: { id: toActivityId }
    };
  }).filter(Boolean);
}

// src/scheduleOrdersFromTradeSequence/orders/derivatives.ts
function deriveOrderChanges(activityChanges, params) {
  const orderChanges = {
    add: [],
    update: [],
    delete: []
  };
  activityChanges.added.forEach((activity) => {
    const defaultContributorGroupId = params.lookups.lookupDefaultContributorGroupId(
      activity.tenantTradeVariation.id
    );
    const predecessorDependencies = params.newActivityDependencies.filter(
      (dependency) => dependency.to.id === activity.id
    );
    orderChanges.add.push(
      deriveNewOrder(activity, {
        ...params,
        defaultContributorGroupId,
        predecessorDependencies,
        orderIdMapping: params.lookups.lookupDerivedOrderIdMapping(activity.id)
      })
    );
  });
  activityChanges.updated.forEach((activity) => {
    const derivedOrder = params.lookups.lookupDerivedOrder(activity.before.id);
    if (!derivedOrder) {
      return;
    }
    orderChanges.update.push(
      deriveUpdatedOrder(
        { id: activity.before.id, ...activity.after },
        {
          engine: params.engine,
          derivedOrder,
          oldActivity: activity.before
        }
      )
    );
  });
  activityChanges.deleted.forEach((activity) => {
    const derivedOrder = params.lookups.lookupDerivedOrder(activity.id);
    if (!derivedOrder) {
      return;
    }
    orderChanges.delete.push(derivedOrder);
  });
  return orderChanges;
}
function deriveOrderDependencyChanges(activityDependencyChanges, params) {
  const orderDependencyChanges = {
    add: [],
    update: [],
    delete: []
  };
  activityDependencyChanges.added.forEach((activityDependency) => {
    const transformedDependency = deriveNewOrderDependency(activityDependency, {
      addedDerivedOrders: params.addedDerivedOrders,
      derivedFromOrder: params.lookups.lookupDerivedOrder(activityDependency.from.id),
      derivedToOrder: params.lookups.lookupDerivedOrder(activityDependency.to.id),
      orderDependencyIdMapping: params.lookups.lookupDerivedOrderDependencyIdMapping(
        activityDependency.from.id,
        activityDependency.to.id
      )
    });
    if (transformedDependency) {
      orderDependencyChanges.add.push(transformedDependency);
    }
  });
  activityDependencyChanges.updated.forEach((activityDependency) => {
    const derivedOrderDependency = params.lookups.lookupDerivedOrderDependency(
      activityDependency.before.from.id,
      activityDependency.before.to.id
    );
    if (!derivedOrderDependency) {
      return;
    }
    orderDependencyChanges.update.push(
      deriveUpdatedOrderDependency(
        { id: activityDependency.before.id, ...activityDependency.after },
        { derivedOrderDependency, oldActivityDependency: activityDependency.before }
      )
    );
  });
  activityDependencyChanges.deleted.forEach((activityDependency) => {
    const derivedOrderDependency = params.lookups.lookupDerivedOrderDependency(
      activityDependency.from.id,
      activityDependency.to.id
    );
    if (!derivedOrderDependency) {
      return;
    }
    orderDependencyChanges.delete.push(derivedOrderDependency);
  });
  return orderDependencyChanges;
}
function deriveNewOrder(newActivity, params) {
  let startDate = new UTCDate(1970);
  let endDate = new UTCDate(1970);
  if (!params.predecessorDependencies.length) {
    startDate = params.engine.utils.getValidStartDate(
      params.referenceDate,
      params.calendarId,
      newActivity.offset - params.referenceOffset
    );
    endDate = params.engine.utils.getValidEndDate(
      startDate,
      params.calendarId,
      newActivity.duration
    );
  }
  return {
    id: params.orderIdMapping ?? generateOrderId(),
    name: newActivity.name,
    startAt: startDate,
    finishAt: endDate,
    duration: newActivity.duration,
    tenantTradeVariation: { id: newActivity.tenantTradeVariation.id },
    calendar: { id: params.calendarId },
    tradeSequenceInstanceId: params.instanceId,
    tradeSequenceActivity: { id: newActivity.id },
    estimatedWorkers: newActivity.estimatedWorkers,
    contributorGroup: params.defaultContributorGroupId ? { id: params.defaultContributorGroupId } : null,
    wbsSection: { id: params.sectionId },
    isFixed: false,
    status: "NOT_SET" /* NOT_SET */,
    dryingBreak: newActivity.dryingBreak,
    tasks: newActivity.taskTemplates.map((template) => ({
      id: generateOrderTaskId(),
      description: template.description,
      name: template.name,
      sequenceNumber: template.sequenceNumber,
      template: template.id ?? ""
    }))
  };
}
function deriveUpdatedOrder(activityChanges, params) {
  const orderChanges = { id: params.derivedOrder.id };
  if (activityChanges.offset !== void 0) {
    const offsetDelta = activityChanges.offset - params.oldActivity.offset;
    const startDate = params.engine.utils.getValidStartDate(
      params.derivedOrder.startAt,
      params.derivedOrder.calendar.id,
      offsetDelta
    );
    const endDate = params.engine.utils.getValidEndDate(
      startDate,
      params.derivedOrder.calendar.id,
      params.derivedOrder.duration
    );
    orderChanges.startAt = startDate;
    orderChanges.finishAt = endDate;
  }
  if (activityChanges.duration !== void 0) {
    orderChanges.duration = activityChanges.duration;
  }
  if (activityChanges.tenantTradeVariation !== void 0) {
    orderChanges.tenantTradeVariation = activityChanges.tenantTradeVariation;
  }
  if (activityChanges.dryingBreak !== void 0) {
    orderChanges.dryingBreak = activityChanges.dryingBreak;
  }
  if (activityChanges.taskTemplates !== void 0) {
    orderChanges.tasks = activityChanges.taskTemplates.map((template) => ({
      id: params.derivedOrder.tasks?.find((t) => t.template === template.id)?.id ?? generateOrderTaskId(),
      description: template.description,
      name: template.name,
      sequenceNumber: template.sequenceNumber,
      template: template.id ?? ""
    }));
  }
  if (activityChanges.name !== void 0) {
    orderChanges.name = activityChanges.name;
  }
  if (activityChanges.tenantTradeVariation !== void 0) {
    orderChanges.tenantTradeVariation = activityChanges.tenantTradeVariation;
  }
  if (activityChanges.estimatedWorkers !== void 0) {
    orderChanges.estimatedWorkers = activityChanges.estimatedWorkers;
  }
  return orderChanges;
}
function deriveNewOrderDependency(newActivityDependency, params) {
  const fromOrder = params.derivedFromOrder ?? params.addedDerivedOrders.find(
    (order) => order.tradeSequenceActivity?.id === newActivityDependency.from.id
  );
  const toOrder = params.derivedToOrder ?? params.addedDerivedOrders.find(
    (order) => order.tradeSequenceActivity?.id === newActivityDependency.to.id
  );
  if (!fromOrder || !toOrder) {
    return void 0;
  }
  return {
    ...newActivityDependency,
    id: params.orderDependencyIdMapping ?? generateOrderDependencyId(),
    from: { id: fromOrder.id },
    to: { id: toOrder.id },
    isViolated: false
  };
}
function deriveUpdatedOrderDependency(activityDependencyChanges, params) {
  const orderDependencyChanges = {
    id: params.derivedOrderDependency.id
  };
  if (activityDependencyChanges.lagInMinutes !== void 0) {
    const lagDelta = activityDependencyChanges.lagInMinutes - params.oldActivityDependency.lagInMinutes;
    orderDependencyChanges.lagInMinutes = params.derivedOrderDependency.lagInMinutes + lagDelta;
  }
  if (activityDependencyChanges.bufferInMinutes !== void 0) {
    const bufferDelta = activityDependencyChanges.bufferInMinutes - params.oldActivityDependency.bufferInMinutes;
    orderDependencyChanges.bufferInMinutes = params.derivedOrderDependency.bufferInMinutes + bufferDelta;
  }
  if (activityDependencyChanges.type !== void 0) {
    orderDependencyChanges.type = activityDependencyChanges.type;
  }
  if (activityDependencyChanges.useDryingBreak !== void 0) {
    orderDependencyChanges.useDryingBreak = activityDependencyChanges.useDryingBreak;
  }
  return orderDependencyChanges;
}
function deriveOrderSkip(skip) {
  return {
    ...skip,
    fields: skip.fields ? rename(skip.fields, {
      offset: ["startAt", "finishAt"],
      duration: "finishAt",
      taskTemplates: "tasks"
    }) : void 0
  };
}
function deriveOrderDependencySkip(skip) {
  return {
    ...skip,
    fields: skip.fields ? rename(skip.fields, {}) : void 0
  };
}

// src/scheduleOrdersFromTradeSequence/activities/changes.ts
var import_lodash4 = __toESM(require_lodash());
var compareDirectly = (a, b) => a === b;
var compareId = (a, b) => a.id === b.id;
var compareDeeply = (a, b) => (0, import_lodash4.isEqual)(a, b);
function findActivityChanges(oldActivities, newActivities, params = {}) {
  const oldActivityIds = new Set(oldActivities.map((activity) => activity.id));
  const newActivityIds = new Set(newActivities.map((activity) => activity.id));
  const added = pickMapItems(difference(newActivityIds, oldActivityIds), newActivities);
  const deleted = pickMapItems(difference(oldActivityIds, newActivityIds), oldActivities);
  const common = intersection(oldActivityIds, newActivityIds);
  const updated = /* @__PURE__ */ new Map();
  const comparisonFields = {
    name: compareDirectly,
    duration: compareDirectly,
    tenantTradeVariation: compareId,
    estimatedWorkers: compareDirectly,
    dryingBreak: compareDeeply,
    ...params.ignoreOffset ? {} : { offset: compareDirectly },
    ...params.ignoreTasks ? {} : {
      taskTemplates: (a, b) => {
        const aTasks = a?.map((t) => omitUndefinedKeys(t)) ?? [];
        const bTasks = b?.map((t) => omitUndefinedKeys(t)) ?? [];
        return compareDeeply(aTasks, bTasks);
      }
    }
  };
  Array.from(common).forEach((commonId) => {
    const oldActivity = oldActivities.find((a) => a.id === commonId);
    const newActivity = newActivities.find((a) => a.id === commonId);
    Object.entries(comparisonFields).forEach(([field, compare]) => {
      if (!compare(
        oldActivity[field],
        newActivity[field]
      )) {
        updated.set(commonId, {
          before: oldActivity,
          after: {
            ...updated.get(commonId)?.after ?? {},
            [field]: newActivity[field]
          }
        });
      }
    });
  });
  return {
    added,
    deleted,
    updated
  };
}
function findActivityDependencyChanges(oldActivityDependencies, newActivityDependencies, params = {}) {
  const dependencyMappedIdConnector = "#";
  const toMappedIds = (originalDependencies) => {
    return new Set(
      originalDependencies.map(
        (dependency) => `${dependency.from.id}${dependencyMappedIdConnector}${dependency.to.id}`
      )
    );
  };
  const toOriginalIds = (mappedDependencies, originalDependencies) => {
    return new Map(
      Array.from(mappedDependencies).map((id) => {
        const [from, to] = id.split(dependencyMappedIdConnector);
        const dependency = originalDependencies.find((d) => d.from.id === from && d.to.id === to);
        return [dependency.id, dependency];
      })
    );
  };
  const mappedOldDependencies = toMappedIds(oldActivityDependencies);
  const mappedNewDependencies = toMappedIds(newActivityDependencies);
  const added = toOriginalIds(
    difference(mappedNewDependencies, mappedOldDependencies),
    newActivityDependencies
  );
  const deleted = toOriginalIds(
    difference(mappedOldDependencies, mappedNewDependencies),
    oldActivityDependencies
  );
  const common = intersection(mappedOldDependencies, mappedNewDependencies);
  const updated = /* @__PURE__ */ new Map();
  const comparisonFields = {
    lagInMinutes: compareDirectly,
    type: compareDirectly,
    useDryingBreak: compareDirectly,
    ...params.ignoreBuffer ? {} : { bufferInMinutes: compareDirectly }
  };
  Array.from(common).forEach((commonId) => {
    const [from, to] = commonId.split(dependencyMappedIdConnector);
    const oldDependency = oldActivityDependencies.find(
      (d) => d.from.id === from && d.to.id === to
    );
    const newDependency = newActivityDependencies.find(
      (d) => d.from.id === from && d.to.id === to
    );
    const originalId = newDependency.id;
    Object.entries(comparisonFields).forEach(([field, compare]) => {
      if (!compare(
        oldDependency[field],
        newDependency[field]
      )) {
        updated.set(originalId, {
          before: oldDependency,
          after: {
            ...updated.get(originalId)?.after ?? {},
            [field]: newDependency[field]
          }
        });
      }
    });
  });
  return {
    added,
    deleted,
    updated
  };
}

// src/scheduleOrdersFromTradeSequence/activities/deviations.ts
function findActivityDeviations(derivedOrders, oldActivities, params) {
  const reconstructedActivities = constructActivitiesFromOrders(derivedOrders, {
    engine: params.engine,
    oldActivities
  });
  const deviations = findActivityChanges(oldActivities, reconstructedActivities, {
    ignoreOffset: true,
    ignoreTasks: params.ignoreTasks
  });
  return deviations;
}
function findActivityDependencyDeviations(derivedOrderDependencies, oldActivityDependencies, params) {
  const reconstructedActivityDependencies = constructActivityDependenciesFromOrderDependencies(
    derivedOrderDependencies,
    {
      lookups: params.lookups
    }
  );
  const deviations = findActivityDependencyChanges(
    oldActivityDependencies,
    reconstructedActivityDependencies,
    {
      ignoreBuffer: true
    }
  );
  return deviations;
}

// src/scheduleOrdersFromTradeSequence/activities/filters.ts
var import_lodash5 = __toESM(require_lodash());

// src/scheduleOrdersFromTradeSequence/activities/utils.ts
function completeOrderIsSkipped(derivedOrder) {
  let skipReason;
  if (isBefore(derivedOrder.finishAt, /* @__PURE__ */ new Date())) {
    skipReason = "PAST" /* PAST */;
  } else if (derivedOrder.status && ["DONE" /* DONE */, "REPORTED_DONE" /* REPORTED_DONE */].includes(derivedOrder.status)) {
    skipReason = "DONE" /* DONE */;
  }
  return skipReason;
}
function completeInstanceIsSkipped(derivedOrders) {
  return derivedOrders.every(
    (order) => isBefore(order.finishAt, /* @__PURE__ */ new Date()) || ["DONE" /* DONE */, "REPORTED_DONE" /* REPORTED_DONE */].includes(order.status)
  );
}

// src/scheduleOrdersFromTradeSequence/activities/filters.ts
function filterActivityChanges(changes, deviations, params) {
  const filteredChanges = (0, import_lodash5.cloneDeep)(changes);
  const skippedChanges = /* @__PURE__ */ new Map();
  if (completeInstanceIsSkipped(params.derivedOrders)) {
    filteredChanges.added.clear();
  }
  changes.updated.forEach((activity) => {
    const derivedOrder = params.lookups.lookupDerivedOrder(activity.before.id);
    if (!derivedOrder) {
      return;
    }
    const skipReason = completeOrderIsSkipped(derivedOrder);
    if (skipReason) {
      filteredChanges.updated.delete(activity.before.id);
      skippedChanges.set(activity.before.id, { reason: skipReason });
      return;
    }
    if (derivedOrder.isFixed && (activity.after.offset !== void 0 || activity.after.duration !== void 0)) {
      filteredChanges.updated.set(activity.before.id, {
        before: activity.before,
        after: omitKeys(activity.after, ["offset", "duration"])
      });
      skippedChanges.set(activity.before.id, { reason: "FIXED" /* FIXED */ });
    }
  });
  changes.deleted.forEach((activity) => {
    const derivedOrder = params.lookups.lookupDerivedOrder(activity.id);
    if (!derivedOrder) {
      return;
    }
    const skipReason = completeOrderIsSkipped(derivedOrder);
    if (skipReason) {
      filteredChanges.deleted.delete(activity.id);
      skippedChanges.set(activity.id, { reason: skipReason });
    }
  });
  deviations.updated.forEach((deviation, activityId) => {
    const change = filteredChanges.updated.get(activityId);
    if (!change) {
      return;
    }
    const { cleanedChange, conflictingKeys } = cleanChangeFromConflicts(change, deviation);
    if (!conflictingKeys.size) {
      return;
    }
    if (cleanedChange === void 0) {
      filteredChanges.updated.delete(activityId);
    } else {
      filteredChanges.updated.set(activityId, {
        before: change.before,
        after: cleanedChange
      });
    }
    if (!skippedChanges.has(activityId)) {
      skippedChanges.set(activityId, {
        reason: "CONFLICT" /* CONFLICT */,
        fields: conflictingKeys
      });
    }
  });
  deviations.deleted.forEach((_, activityId) => {
    filteredChanges.updated.delete(activityId);
    filteredChanges.deleted.delete(activityId);
  });
  return {
    filteredChanges,
    skippedChanges
  };
}
function filterActivityDependencyChanges(changes, deviations, params) {
  const filteredChanges = (0, import_lodash5.cloneDeep)(changes);
  const skippedChanges = /* @__PURE__ */ new Map();
  if (completeInstanceIsSkipped(params.derivedOrders)) {
    filteredChanges.added.clear();
  }
  changes.added.forEach((activityDependency) => {
    const derivedToOrder = params.lookups.lookupDerivedOrder(activityDependency.to.id);
    const derivedOrderDependency = params.lookups.lookupDerivedOrderDependency(
      activityDependency.from.id,
      activityDependency.to.id
    );
    if (derivedOrderDependency) {
      filteredChanges.added.delete(activityDependency.id);
      return;
    }
    if (derivedToOrder) {
      const skipReason = completeOrderIsSkipped(derivedToOrder);
      if (skipReason) {
        filteredChanges.added.delete(activityDependency.id);
        skippedChanges.set(activityDependency.id, { reason: skipReason });
      }
    }
  });
  changes.updated.forEach((activityDependency, activityDependencyId) => {
    const derivedFromOrder = params.lookups.lookupDerivedOrder(activityDependency.before.from.id);
    const derivedToOrder = params.lookups.lookupDerivedOrder(activityDependency.before.to.id);
    if (!derivedFromOrder || !derivedToOrder) {
      filteredChanges.updated.delete(activityDependencyId);
      return;
    }
    const skipReason = completeOrderIsSkipped(derivedToOrder);
    if (skipReason) {
      filteredChanges.updated.delete(activityDependencyId);
      skippedChanges.set(activityDependencyId, { reason: skipReason });
    }
  });
  changes.deleted.forEach((activityDependency) => {
    const derivedToOrder = params.lookups.lookupDerivedOrder(activityDependency.to.id);
    const derivedOrderDependency = params.lookups.lookupDerivedOrderDependency(
      activityDependency.from.id,
      activityDependency.to.id
    );
    if (!derivedOrderDependency) {
      filteredChanges.deleted.delete(activityDependency.id);
      return;
    }
    if (derivedToOrder) {
      const skipReason = completeOrderIsSkipped(derivedToOrder);
      if (skipReason) {
        filteredChanges.deleted.delete(activityDependency.id);
        skippedChanges.set(activityDependency.id, { reason: skipReason });
      }
    }
  });
  deviations.updated.forEach((deviation, activityDependencyId) => {
    if (skippedChanges.has(activityDependencyId)) {
      return;
    }
    const change = filteredChanges.updated.get(activityDependencyId);
    if (!change) {
      return;
    }
    if ("useDryingBreak" in deviation.after || "type" in deviation.after) {
      filteredChanges.updated.delete(activityDependencyId);
      skippedChanges.set(activityDependencyId, {
        reason: "CONFLICT" /* CONFLICT */,
        fields: new Set(Object.keys(change.after))
      });
      return;
    }
    const { cleanedChange, conflictingKeys } = cleanChangeFromConflicts(change, deviation);
    if (!conflictingKeys.size) {
      return;
    }
    if (cleanedChange === void 0) {
      filteredChanges.updated.delete(activityDependencyId);
    } else {
      filteredChanges.updated.set(activityDependencyId, {
        before: change.before,
        after: cleanedChange
      });
    }
    skippedChanges.set(activityDependencyId, {
      reason: "CONFLICT" /* CONFLICT */,
      fields: conflictingKeys
    });
  });
  deviations.deleted.forEach((_, activityDependencyId) => {
    filteredChanges.updated.delete(activityDependencyId);
    filteredChanges.deleted.delete(activityDependencyId);
  });
  return {
    filteredChanges,
    skippedChanges
  };
}
function cleanChangeFromConflicts(change, deviation) {
  const deviationKeys = new Set(Object.keys(deviation.after));
  const changeKeys = new Set(Object.keys(change.after));
  const conflictingKeys = intersection(deviationKeys, changeKeys);
  if (!conflictingKeys.size) {
    return {
      cleanedChange: change.after,
      conflictingKeys
    };
  }
  const cleanedChangeKeys = difference(changeKeys, conflictingKeys);
  if (!cleanedChangeKeys.size) {
    return {
      cleanedChange: void 0,
      conflictingKeys
    };
  }
  const cleanedChange = Object.fromEntries(
    Array.from(cleanedChangeKeys).map((key) => [key, change.after[key]])
  );
  return {
    cleanedChange,
    conflictingKeys
  };
}

// src/scheduleOrdersFromTradeSequence/utils/lookups.ts
function getLookups(params) {
  const activityIdToDerivedOrderLookup = /* @__PURE__ */ new Map();
  const derivedOrderIdToOldActivityLookup = /* @__PURE__ */ new Map();
  const derivedOrderIdToNewActivityLookup = /* @__PURE__ */ new Map();
  const activityIdToDerivedOrderIdMappingLookup = /* @__PURE__ */ new Map();
  const lookupDerivedOrder = (activityId) => {
    return activityIdToDerivedOrderLookup.get(activityId);
  };
  const lookupOldActivity = (derivedOrderId) => {
    return derivedOrderIdToOldActivityLookup.get(derivedOrderId);
  };
  const lookupNewActivity = (derivedOrderId) => {
    return derivedOrderIdToNewActivityLookup.get(derivedOrderId);
  };
  const lookupDerivedOrderIdMapping = (activityId) => {
    return activityIdToDerivedOrderIdMappingLookup.get(activityId);
  };
  params.derivedOrders?.forEach((order) => {
    activityIdToDerivedOrderLookup.set(order.tradeSequenceActivity?.id ?? "", order);
  });
  params.oldActivities?.forEach((activity) => {
    const derivedOrder = lookupDerivedOrder(activity.id);
    if (derivedOrder) {
      derivedOrderIdToOldActivityLookup.set(derivedOrder.id, activity);
    }
  });
  params.newActivities?.forEach((activity) => {
    const derivedOrder = lookupDerivedOrder(activity.id);
    if (derivedOrder) {
      derivedOrderIdToNewActivityLookup.set(derivedOrder.id, activity);
    }
  });
  Object.entries(params.idMapping?.activityIdToOrderId ?? {}).forEach(
    ([activityId, derivedOrderId]) => {
      activityIdToDerivedOrderIdMappingLookup.set(activityId, derivedOrderId);
    }
  );
  const activityFromIdAndToIdToDerivedOrderDependencyLookup = /* @__PURE__ */ new Map();
  const derivedOrderDependencyIdToOldActivityDependencyLookup = /* @__PURE__ */ new Map();
  const derivedOrderDependencyIdToNewActivityDependencyLookup = /* @__PURE__ */ new Map();
  const activityFromIdAndToIdToDerivedOrderDependencyIdMappingLookup = /* @__PURE__ */ new Map();
  const lookupDerivedOrderDependency = (fromActivityId, toActivityId) => {
    const fromIdLookup = activityFromIdAndToIdToDerivedOrderDependencyLookup.get(fromActivityId);
    if (!fromIdLookup) {
      return void 0;
    }
    return fromIdLookup.get(toActivityId);
  };
  const lookupOldActivityDependency = (derivedOrderDependencyId) => {
    return derivedOrderDependencyIdToOldActivityDependencyLookup.get(derivedOrderDependencyId);
  };
  const lookupNewActivityDependency = (derivedOrderDependencyId) => {
    return derivedOrderDependencyIdToNewActivityDependencyLookup.get(derivedOrderDependencyId);
  };
  const lookupDerivedOrderDependencyIdMapping = (fromActivityId, toActivityId) => {
    const fromIdLookup = activityFromIdAndToIdToDerivedOrderDependencyIdMappingLookup.get(fromActivityId);
    if (!fromIdLookup) {
      return void 0;
    }
    return fromIdLookup.get(toActivityId);
  };
  const derivedOrdersMap = new Map(
    (params.derivedOrders ?? []).map((order) => [order.id, order])
  );
  params.derivedOrderDependencies?.forEach((orderDependency) => {
    const fromOrderId = orderDependency.from.id;
    const toOrderId = orderDependency.to.id;
    const fromOrder = derivedOrdersMap.get(fromOrderId);
    const toOrder = derivedOrdersMap.get(toOrderId);
    if (fromOrder && toOrder) {
      const fromActivityId = fromOrder.tradeSequenceActivity?.id ?? "";
      const toActivityId = toOrder.tradeSequenceActivity?.id ?? "";
      let fromIdLookup = activityFromIdAndToIdToDerivedOrderDependencyLookup.get(fromActivityId);
      if (!fromIdLookup) {
        fromIdLookup = /* @__PURE__ */ new Map();
        activityFromIdAndToIdToDerivedOrderDependencyLookup.set(fromActivityId, fromIdLookup);
      }
      fromIdLookup.set(toActivityId, orderDependency);
    }
  });
  params.oldActivityDependencies?.forEach((activityDependency) => {
    const derivedOrderDependency = lookupDerivedOrderDependency(
      activityDependency.from.id,
      activityDependency.to.id
    );
    if (derivedOrderDependency) {
      derivedOrderDependencyIdToOldActivityDependencyLookup.set(
        derivedOrderDependency.id,
        activityDependency
      );
    }
  });
  params.newActivityDependencies?.forEach((activityDependency) => {
    const derivedOrderDependency = lookupDerivedOrderDependency(
      activityDependency.from.id,
      activityDependency.to.id
    );
    if (derivedOrderDependency) {
      derivedOrderDependencyIdToNewActivityDependencyLookup.set(
        derivedOrderDependency.id,
        activityDependency
      );
    }
  });
  const orderIdMappingsMap = new Map(
    Object.entries(params.idMapping?.activityIdToOrderId ?? {}).map(([activityId, orderId]) => [
      orderId,
      activityId
    ])
  );
  params.idMapping?.orderIdsToOrderDependencyId.forEach((mapping) => {
    const fromActivityId = orderIdMappingsMap.get(mapping.fromOrderId) ?? "";
    const toActivityId = orderIdMappingsMap.get(mapping.toOrderId) ?? "";
    let fromIdLookup = activityFromIdAndToIdToDerivedOrderDependencyIdMappingLookup.get(fromActivityId);
    if (!fromIdLookup) {
      fromIdLookup = /* @__PURE__ */ new Map();
      activityFromIdAndToIdToDerivedOrderDependencyIdMappingLookup.set(
        fromActivityId,
        fromIdLookup
      );
    }
    fromIdLookup.set(toActivityId, mapping.dependencyId);
  });
  const tradeIdToDefaultContributorGroupIdLookup = /* @__PURE__ */ new Map();
  const orderIdToOrderAssignmentLookup = /* @__PURE__ */ new Map();
  const lookupDefaultContributorGroupId = (tradeId) => {
    return tradeIdToDefaultContributorGroupIdLookup.get(tradeId);
  };
  const lookupOrderAssignment = (orderId) => {
    return orderIdToOrderAssignmentLookup.get(orderId);
  };
  params.contributorGroups?.forEach((contributorGroup) => {
    contributorGroup.tenantTradeVariationAssignments.forEach((assignment) => {
      if (assignment.isDefaultContributor) {
        tradeIdToDefaultContributorGroupIdLookup.set(
          assignment.tenantTradeVariation.id,
          contributorGroup.id
        );
      }
    });
  });
  params.orderAssignments?.assignments.forEach((assignment) => {
    orderIdToOrderAssignmentLookup.set(assignment.orderId, {
      tradeSequenceInstanceId: params.orderAssignments.tradeSequenceInstanceId,
      activityId: assignment.activityId
    });
  });
  return {
    lookupDerivedOrder,
    lookupOldActivity,
    lookupNewActivity,
    lookupDerivedOrderIdMapping,
    lookupDerivedOrderDependency,
    lookupOldActivityDependency,
    lookupNewActivityDependency,
    lookupDerivedOrderDependencyIdMapping,
    lookupDefaultContributorGroupId,
    lookupOrderAssignment
  };
}

// src/scheduleOrdersFromTradeSequence/utils/scheduling.ts
function scheduleWithEnforcedDependencies(engine, context, params) {
  const result = engine.schedule(
    {
      add: {
        orders: params.addedOrders,
        dependencies: params.addedOrderDependencies
      },
      update: {
        orders: params.updatedOrders,
        dependencies: mergeArrays(
          params.updatedOrderDependencies ?? [],
          params.enforcedDependencies
        )
      },
      delete: {
        orders: params.deletedOrders,
        dependencies: params.deletedOrderDependencies
      }
    },
    context
  );
  return result;
}

// src/scheduleOrdersFromTradeSequence/sync.ts
function syncDerivedOrdersWithTradeSequence(inputEngine, newTradeSequence, oldTradeSequence, { stateless = true, context = {}, ...params } = {}) {
  const engine = inputEngine.copy();
  const {
    addedOrders,
    updatedOrders,
    deletedOrders,
    addedOrderDependencies,
    updatedOrderDependencies,
    deletedOrderDependencies,
    skippedOrders,
    skippedOrderDependencies,
    idMappings,
    unchangedSameInstanceDependencies,
    crossInstanceDependencies
  } = determineDerivedOrderChanges(inputEngine, newTradeSequence, oldTradeSequence, params);
  const firstResult = scheduleWithEnforcedDependencies(engine, context, {
    addedOrders,
    updatedOrders,
    deletedOrders,
    addedOrderDependencies,
    updatedOrderDependencies: mergeArrays(updatedOrderDependencies, params.dependencies ?? []),
    deletedOrderDependencies,
    enforcedDependencies: unchangedSameInstanceDependencies
  });
  const unresolvedCrossInstanceDependencies = crossInstanceDependencies.filter(
    (dependency) => !params.dependencies?.find((d) => d.id === dependency.id)
  );
  let secondResult;
  if (unresolvedCrossInstanceDependencies.length) {
    secondResult = scheduleWithEnforcedDependencies(engine, context, {
      enforcedDependencies: unresolvedCrossInstanceDependencies
    });
  }
  const changes = inputEngine.diff(engine);
  if (!stateless) {
    inputEngine.commit(changes);
  }
  const mergedMeta = {
    invokedConstraints: mergeArrays(
      firstResult.meta.invokedConstraints,
      secondResult?.meta.invokedConstraints ?? [],
      "dependencyId"
    )
  };
  return {
    state: engine.getState(),
    changes,
    meta: mergedMeta,
    skippedOrders,
    skippedOrderDependencies,
    idMappings
  };
}
function determineDerivedOrderChanges(engine, newTradeSequence, oldTradeSequence, params) {
  const addedOrders = [];
  const updatedOrders = [];
  const deletedOrders = [];
  const addedOrderDependencies = [];
  const updatedOrderDependencies = [];
  const deletedOrderDependencies = [];
  const skippedOrders = /* @__PURE__ */ new Map();
  const skippedOrderDependencies = /* @__PURE__ */ new Map();
  const unchangedSameInstanceDependencies = [];
  const engineState = engine.getState();
  const derivedEntities = getDerivedEntities(
    engineState.orders,
    engineState.dependencies,
    mergeArrays(oldTradeSequence.activities, newTradeSequence.activities),
    params.tasks,
    params.orderAssignments
  );
  const crossInstanceDependencies = getCrossInstanceDependencies(
    derivedEntities.all.derivedOrders,
    engineState.dependencies
  );
  const idMappings = params.idMappings ?? [];
  const idMappingsPerInstanceId = new Map(
    idMappings.map((mapping) => [mapping.tradeSequenceInstanceId, mapping])
  );
  const activityChanges = findActivityChanges(
    oldTradeSequence.activities,
    newTradeSequence.activities,
    {
      ignoreTasks: !params.tasks
    }
  );
  const activityDependencyChanges = findActivityDependencyChanges(
    oldTradeSequence.dependencies,
    newTradeSequence.dependencies
  );
  derivedEntities.grouped.forEach(
    ({ derivedOrders, derivedOrderDependencies, sectionId }, instanceId) => {
      const lookups = getLookups({
        newActivities: newTradeSequence.activities,
        oldActivities: oldTradeSequence.activities,
        newActivityDependencies: newTradeSequence.dependencies,
        oldActivityDependencies: oldTradeSequence.dependencies,
        derivedOrders,
        derivedOrderDependencies,
        contributorGroups: engineState.contributorGroups,
        idMapping: idMappingsPerInstanceId.get(instanceId),
        orderAssignments: params.orderAssignments
      });
      const activityDeviations = findActivityDeviations(
        derivedOrders,
        oldTradeSequence.activities,
        { engine, ignoreTasks: !params.tasks }
      );
      const activityDependencyDeviations = findActivityDependencyDeviations(
        derivedOrderDependencies,
        oldTradeSequence.dependencies,
        { lookups }
      );
      const { filteredChanges: filteredActivityChanges, skippedChanges: skippedActivityChanges } = filterActivityChanges(activityChanges, activityDeviations, {
        lookups,
        derivedOrders
      });
      const {
        filteredChanges: filteredActivityDependencyChanges,
        skippedChanges: skippedActivityDependencyChanges
      } = filterActivityDependencyChanges(activityDependencyChanges, activityDependencyDeviations, {
        lookups,
        derivedOrders
      });
      skippedActivityChanges.forEach((value, key) => {
        const derivedOrder = lookups.lookupDerivedOrder(key);
        if (derivedOrder) {
          skippedOrders.set(derivedOrder.id, deriveOrderSkip(value));
        }
      });
      skippedActivityDependencyChanges.forEach((value, key) => {
        const activityDependency = mergeArrays(
          oldTradeSequence.dependencies,
          newTradeSequence.dependencies
        ).find((dependency) => dependency.id === key);
        if (activityDependency) {
          const derivedOrderDependency = lookups.lookupDerivedOrderDependency(
            activityDependency.from.id,
            activityDependency.to.id
          );
          if (derivedOrderDependency) {
            skippedOrderDependencies.set(
              derivedOrderDependency.id,
              deriveOrderDependencySkip(value)
            );
          }
        }
      });
      const derivedOrderChanges = deriveOrderChanges(filteredActivityChanges, {
        engine,
        lookups,
        newActivityDependencies: newTradeSequence.dependencies,
        calendarId: newTradeSequence.calendar.id,
        instanceId,
        sectionId,
        ...computeReferenceDateFromDerivedOrders(derivedOrders, oldTradeSequence.activities)
      });
      const derivedOrderDependencyChanges = deriveOrderDependencyChanges(
        filteredActivityDependencyChanges,
        {
          lookups,
          addedDerivedOrders: derivedOrderChanges.add
        }
      );
      if (params.orderAssignments) {
        derivedOrders.forEach((order) => {
          const assignment = lookups.lookupOrderAssignment(order.id);
          if (!assignment) return;
          if (derivedOrderChanges.delete.find((o) => o.id === order.id)) return;
          const existingUpdateIdx = derivedOrderChanges.update.findIndex((o) => o.id === order.id);
          if (existingUpdateIdx === -1) {
            derivedOrderChanges.update.push({
              id: order.id,
              tradeSequenceActivity: { id: assignment.activityId },
              tradeSequenceInstanceId: assignment.tradeSequenceInstanceId
            });
          } else {
            derivedOrderChanges.update[existingUpdateIdx] = {
              ...derivedOrderChanges.update[existingUpdateIdx],
              tradeSequenceActivity: { id: assignment.activityId },
              tradeSequenceInstanceId: assignment.tradeSequenceInstanceId
            };
          }
        });
      }
      addedOrders.push(...derivedOrderChanges.add);
      updatedOrders.push(...derivedOrderChanges.update);
      deletedOrders.push(...derivedOrderChanges.delete);
      addedOrderDependencies.push(...derivedOrderDependencyChanges.add);
      updatedOrderDependencies.push(...derivedOrderDependencyChanges.update);
      deletedOrderDependencies.push(...derivedOrderDependencyChanges.delete);
      derivedOrderDependencies.forEach((dependency) => {
        if ([...derivedOrderDependencyChanges.update, ...derivedOrderDependencyChanges.delete].find(
          (updatedDependency) => updatedDependency.id === dependency.id
        ) || params.dependencies?.find((d) => d.id === dependency.id)) {
          return;
        }
        unchangedSameInstanceDependencies.push(dependency);
      });
      const newIdMapping = getIdMappingFromNewlyDerivedEntities(
        instanceId,
        derivedOrderChanges.add,
        derivedOrderDependencyChanges.add
      );
      const idMappingIdx = idMappings.findIndex(
        (mapping) => mapping.tradeSequenceInstanceId === instanceId
      );
      if (idMappingIdx !== -1) {
        idMappings[idMappingIdx] = newIdMapping;
      } else {
        idMappings.push(newIdMapping);
      }
    }
  );
  return {
    addedOrders,
    updatedOrders,
    deletedOrders,
    addedOrderDependencies,
    updatedOrderDependencies,
    deletedOrderDependencies,
    skippedOrders,
    skippedOrderDependencies,
    idMappings,
    crossInstanceDependencies,
    unchangedSameInstanceDependencies
  };
}

// src/scheduleOrdersFromTradeSequence/generate.ts
function generateDerivedOrdersFromTradeSequence(engine, newTradeSequence, { stateless = true, context = {}, ...params }) {
  const lookups = getLookups({
    newActivities: newTradeSequence.activities,
    newActivityDependencies: newTradeSequence.dependencies,
    oldActivities: newTradeSequence.activities,
    oldActivityDependencies: newTradeSequence.dependencies,
    contributorGroups: engine.getState().contributorGroups,
    idMapping: params.idMapping
  });
  const activityChanges = {
    added: new Map(newTradeSequence.activities.map((activity) => [activity.id, activity])),
    updated: /* @__PURE__ */ new Map(),
    deleted: /* @__PURE__ */ new Map()
  };
  const activityDependencyChanges = {
    added: new Map(
      newTradeSequence.dependencies.map((activityDependency) => [
        activityDependency.id,
        activityDependency
      ])
    ),
    updated: /* @__PURE__ */ new Map(),
    deleted: /* @__PURE__ */ new Map()
  };
  const derivedOrderChanges = deriveOrderChanges(activityChanges, {
    engine,
    lookups,
    newActivityDependencies: newTradeSequence.dependencies,
    sectionId: params.sectionId,
    calendarId: newTradeSequence.calendar.id,
    instanceId: params.tradeSequenceInstanceId,
    referenceDate: params.date,
    referenceOffset: 0
  });
  const derivedOrderDependencyChanges = deriveOrderDependencyChanges(activityDependencyChanges, {
    lookups,
    addedDerivedOrders: derivedOrderChanges.add
  });
  const idMapping = getIdMappingFromNewlyDerivedEntities(
    params.tradeSequenceInstanceId,
    derivedOrderChanges.add,
    derivedOrderDependencyChanges.add
  );
  const result = engine.schedule(
    {
      add: {
        orders: derivedOrderChanges.add,
        dependencies: derivedOrderDependencyChanges.add
      }
    },
    context,
    { stateless }
  );
  return {
    ...result,
    idMapping
  };
}
function generateDerivedOrdersFromFreshPrefilledTradeSequence(engine, newTradeSequence, { stateless = true, context = {}, ...params }) {
  const state = engine.getState();
  const orderMap = new Map(state.orders.map((order) => [order.id, order]));
  const derivedOrders = params.orderAssignments.assignments.map((assignment) => {
    const order = orderMap.get(assignment.orderId);
    if (!order) {
      return null;
    }
    return {
      ...order,
      // Make sure to clean potential outdated references to the old activity and instance id.
      tradeSequenceActivity: null,
      tradeSequenceInstanceId: null
    };
  }).filter(Boolean);
  const derivedOrderMap = new Map(derivedOrders.map((order) => [order.id, order]));
  const derivedOrderDependencies = state.dependencies.filter(
    (dependency) => derivedOrderMap.has(dependency.from.id) && derivedOrderMap.has(dependency.to.id)
  );
  const orderIdToActivityIdMapping = new Map(
    params.orderAssignments.assignments.map((assignment) => [
      assignment.orderId,
      assignment.activityId
    ])
  );
  const tasks = params.tasks ? Object.entries(params.tasks).reduce(
    (acc, [orderId, orderTasks]) => {
      const newActivity = newTradeSequence.activities.find(
        (activity) => activity.id === orderIdToActivityIdMapping.get(orderId)
      );
      if (!newActivity) {
        acc[orderId] = orderTasks ?? null;
        return acc;
      }
      acc[orderId] = orderTasks ? orderTasks.map((task) => {
        const matchingTask = newActivity.taskTemplates.find((t) => t.name === task.name);
        if (matchingTask) {
          return {
            ...task,
            template: matchingTask.id
          };
        }
        return {
          ...task,
          template: generateOrderTaskId()
        };
      }) : null;
      return acc;
    },
    {}
  ) : null;
  const activities = constructActivitiesFromOrders(derivedOrders, {
    engine,
    orderIdToActivityIdMapping,
    orderIdToTasksMapping: tasks ?? void 0
  });
  const activityDependencies = constructActivityDependenciesFromOrderDependencies(
    derivedOrderDependencies,
    { orderIdToActivityIdMapping }
  );
  const oldTradeSequence = {
    ...newTradeSequence,
    activities,
    dependencies: activityDependencies
  };
  const result = syncDerivedOrdersWithTradeSequence(engine, newTradeSequence, oldTradeSequence, {
    orderAssignments: params.orderAssignments,
    idMappings: params.idMapping ? [params.idMapping] : void 0,
    tasks,
    stateless,
    context
  });
  return {
    ...omitKeys(result, ["idMappings"]),
    idMapping: result.idMappings[0]
  };
}

// src/scheduleTradeSequenceActivities/activities/transform.ts
function activitiesToElements(activities) {
  return activities?.map((a) => {
    const element = {
      id: a.id
    };
    if (a.startDate !== void 0) {
      element.startDate = a.startDate;
    }
    if (a.endDate !== void 0) {
      element.endDate = a.endDate;
    }
    if (a.duration !== void 0) {
      element.duration = a.duration;
    }
    if (a.dryingBreak !== void 0) {
      element.endOffset = a.dryingBreak?.duration;
    }
    return element;
  }) ?? [];
}
function elementsToActivities(elements, activitiesMap) {
  return elements.map((element) => {
    const baseActivity = activitiesMap?.get(element.id) ?? { id: element.id };
    const transformedActivity = { ...baseActivity };
    if (element.startDate !== void 0) transformedActivity.startDate = element.startDate;
    if (element.endDate !== void 0) transformedActivity.endDate = element.endDate;
    return transformedActivity;
  });
}

// src/scheduleTradeSequenceActivities/activityDependencies/transform.ts
function activityDependenciesToDependencies(activityDependencies) {
  return activityDependencies?.map((d) => {
    const dependency = {
      id: d.id
    };
    if (d.from !== void 0) dependency.from = d.from;
    if (d.to !== void 0) dependency.to = d.to;
    if (d.type !== void 0) dependency.type = d.type;
    if (d.lagInMinutes !== void 0) dependency.lag = d.lagInMinutes;
    if (d.bufferInMinutes !== void 0) dependency.buffer = d.bufferInMinutes;
    if (d.useDryingBreak !== void 0) dependency.useSourceEndOffset = d.useDryingBreak;
    return dependency;
  }) ?? [];
}
function dependenciesToActivityDependencies(dependencies, dependencyMap) {
  return dependencies.map((dependency) => {
    const baseDependency = dependencyMap?.get(dependency.id) ?? { id: dependency.id };
    const transformedDependency = {
      ...baseDependency
    };
    if (dependency.buffer !== void 0) transformedDependency.bufferInMinutes = dependency.buffer;
    if (dependency.lag !== void 0) transformedDependency.lagInMinutes = dependency.lag;
    if (dependency.useSourceEndOffset !== void 0) {
      transformedDependency.useDryingBreak = dependency.useSourceEndOffset;
    }
    return transformedDependency;
  });
}

// src/scheduleTradeSequenceActivities/artifacts.ts
function buildElementStore2(stateMap, changesMap) {
  const activityState = transformMap(stateMap.activities, (a) => activitiesToElements(a));
  return patchElementStore2(new ElementStore(activityState), stateMap, changesMap);
}
function patchElementStore2(elementStore, stateMap, changesMap) {
  const activitiesAdded = transformMap(changesMap.add?.activities, (a) => activitiesToElements(a));
  const activitiesUpdated = transformMap(
    changesMap.update?.activities,
    (a) => activitiesToElements(a)
  );
  return elementStore.patch({
    added: activitiesAdded,
    updated: activitiesUpdated,
    deleted: changesMap.delete?.activities ?? /* @__PURE__ */ new Map()
  });
}
function buildDependencyStore2(stateMap, changesMap) {
  const dependencyState = transformMap(
    stateMap.dependencies,
    (d) => activityDependenciesToDependencies(d)
  );
  return patchDependencyStore2(new DependencyStore(dependencyState), changesMap);
}
function patchDependencyStore2(dependencyStore, changesMap) {
  const dependencyAdded = transformMap(
    changesMap.add?.dependencies,
    (d) => activityDependenciesToDependencies(d)
  );
  const dependencyUpdated = transformMap(
    changesMap.update?.dependencies,
    (d) => activityDependenciesToDependencies(d)
  );
  return dependencyStore.patch({
    added: dependencyAdded,
    updated: dependencyUpdated,
    deleted: changesMap.delete?.dependencies
  });
}
function buildDependencyGraph2(stateMap) {
  const nodes = stateMap.activities;
  const edges = stateMap.dependencies;
  return new DependencyGraph(nodes, edges);
}
function patchDependencyGraph2(dependencyGraph, changesMap) {
  const nodesAdded = changesMap.add?.activities;
  const nodesDeleted = changesMap.delete?.activities;
  const edgesAdded = changesMap.add?.dependencies;
  const edgesDeleted = changesMap.delete?.dependencies;
  return dependencyGraph.patch(
    {
      added: nodesAdded,
      deleted: nodesDeleted
    },
    {
      added: edgesAdded,
      deleted: edgesDeleted
    }
  );
}

// src/scheduleTradeSequenceActivities/results.ts
function transformResults2(state, changes, stateMap, changesMap, elements, dependencies) {
  const addedActivities = transformMap(
    elements.added,
    (e) => elementsToActivities(e, changesMap.add?.activities)
  );
  const addedDependencies = transformMap(
    dependencies.added,
    (d) => dependenciesToActivityDependencies(d, changesMap.add?.dependencies)
  );
  const updatedActivities = transformMap(
    elements.updated,
    (e) => elementsToActivities(e, changesMap.update?.activities)
  );
  const updatedDependencies = transformMap(
    dependencies.updated,
    (d) => dependenciesToActivityDependencies(d, changesMap.update?.dependencies)
  );
  return {
    state: {
      activities: patchArray(state.activities, {
        added: addedActivities,
        updated: updatedActivities,
        deleted: changesMap.delete?.activities
      }),
      dependencies: patchArray(state.dependencies, {
        added: addedDependencies,
        updated: updatedDependencies,
        deleted: changesMap.delete?.dependencies
      })
    },
    changes: {
      ...changes,
      add: {
        ...changes.add,
        activities: Array.from(addedActivities.values()),
        dependencies: Array.from(addedDependencies.values())
      },
      update: {
        ...changes.update,
        activities: Array.from(updatedActivities.values()),
        dependencies: Array.from(updatedDependencies.values())
      }
    }
  };
}

// src/scheduleTradeSequenceActivities/engine.ts
var TradeSequenceActivitySchedulingEngine = class extends SchedulingEngine {
  schedulingFunction = getSchedulingFunction();
  resultReadingFunction = getResultReadingFunction(transformResults2);
  artifactsBuildingFunction = getArtifactsBuildingFunction({
    buildDependencyGraph: buildDependencyGraph2,
    patchDependencyGraph: patchDependencyGraph2,
    buildDependencyStore: buildDependencyStore2,
    patchDependencyStore: patchDependencyStore2,
    buildElementStore: buildElementStore2,
    patchElementStore: patchElementStore2
  });
  utils = new TradeSequenceActivitySchedulingEngineUtils(
    () => this.state,
    () => this.artifacts
  );
  copy() {
    return super.copy();
  }
  initialize(state) {
    super.initialize({
      ...state,
      activities: this.computeTradeSequenceActivityDurations(
        state.activities
      )
    });
  }
  schedule(changes, context = {}, options = {}) {
    return super.schedule(
      {
        ...changes,
        add: {
          ...changes.add,
          ...changes.add?.activities ? { activities: this.computeTradeSequenceActivityDurations(changes.add.activities) } : {}
        },
        update: {
          ...changes.update,
          ...changes.update?.activities ? { activities: this.computeTradeSequenceActivityDurations(changes.update.activities) } : {}
        }
      },
      context,
      options
    );
  }
  commit(changes) {
    super.commit({
      ...changes,
      add: {
        ...changes.add,
        ...changes.add?.activities ? { activities: this.computeTradeSequenceActivityDurations(changes.add.activities) } : {}
      },
      update: {
        ...changes.update,
        ...changes.update?.activities ? { activities: this.computeTradeSequenceActivityDurations(changes.update.activities) } : {}
      }
    });
  }
  computeTradeSequenceActivityDurations(activities) {
    return activities.map((activity) => {
      if ("duration" in activity && activity.duration !== void 0) {
        return activity;
      }
      if (!activity.startDate && !activity.endDate) {
        return activity;
      }
      const partialActivity = omitUndefinedKeys(activity);
      const previousActivity = this.artifacts.stateMap ? this.artifacts.stateMap.activities.get(activity.id) : null;
      const enrichedActivity = {
        ...previousActivity,
        ...partialActivity
      };
      if (!enrichedActivity.startDate || !enrichedActivity.endDate) {
        throw new UndefinedElementDatesError("tradeSequenceActivity", partialActivity.id);
      }
      const newDuration = differenceInMinutes(enrichedActivity.endDate, enrichedActivity.startDate);
      return {
        ...partialActivity,
        ...newDuration !== previousActivity?.duration ? { duration: newDuration } : {}
      };
    });
  }
};
var TradeSequenceActivitySchedulingEngineUtils = class extends SchedulingEngineUtils {
};
export {
  BaseError,
  DependencyCycleError,
  DependencyGraph,
  DependencyType,
  EntityNotFoundError,
  InfiniteLoopInCalendarError,
  InvalidDateTimeFormatError,
  InvalidElementDurationError,
  MultipleDependenciesError,
  NoOrderFoundInSequenceError,
  NoWorkingTimeAvailableError,
  OrderSchedulingEngine,
  OrderSchedulingEngineUtils,
  OrderStatus,
  SchedulingEngineNotInitializedError,
  TradeSequenceActivitySchedulingEngine,
  TradeSequenceActivitySchedulingEngineUtils,
  UndefinedElementDatesError,
  UnknownDependencyTypeError,
  constructActivitiesFromOrders,
  constructActivityDependenciesFromOrderDependencies,
  generateDerivedOrdersFromFreshPrefilledTradeSequence,
  generateDerivedOrdersFromTradeSequence,
  syncDerivedOrdersWithTradeSequence
};
/*! Bundled license information:

lodash/lodash.js:
  (**
   * @license
   * Lodash <https://lodash.com/>
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)

pure-uuid/uuid.js:
  (*!
  **  Pure-UUID -- Pure JavaScript Based Universally Unique Identifier (UUID)
  **  Copyright (c) 2004-2023 Dr. Ralf S. Engelschall <rse@engelschall.com>
  **
  **  Permission is hereby granted, free of charge, to any person obtaining
  **  a copy of this software and associated documentation files (the
  **  "Software"), to deal in the Software without restriction, including
  **  without limitation the rights to use, copy, modify, merge, publish,
  **  distribute, sublicense, and/or sell copies of the Software, and to
  **  permit persons to whom the Software is furnished to do so, subject to
  **  the following conditions:
  **
  **  The above copyright notice and this permission notice shall be included
  **  in all copies or substantial portions of the Software.
  **
  **  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  **  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  **  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
  **  IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
  **  CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
  **  TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
  **  SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  *)
*/
//# sourceMappingURL=index.mjs.map